import React, { useState, useRef, useEffect } from 'react';
import { useGyerekek } from '../GyerekekContext';

// ============ ANIMÁLT HÁTTÉR ============
function AnimaltHatter911() {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animId;
    const resize = () => { canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; };
    resize();
    window.addEventListener('resize', resize);
    const reszecskek = Array.from({length: 50}, () => ({
      x: Math.random() * canvas.width, y: Math.random() * canvas.height,
      vx: (Math.random() - 0.5) * 0.6, vy: (Math.random() - 0.5) * 0.6,
      r: Math.random() * 3 + 1,
      szin: ['#2196f3','#1976d2','#42a5f5','#90caf9','#1565c0','#64b5f6'][Math.floor(Math.random()*6)],
      alpha: Math.random() * 0.5 + 0.2,
    }));
    const rajzol = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (let i = 0; i < reszecskek.length; i++) {
        for (let j = i + 1; j < reszecskek.length; j++) {
          const dx = reszecskek[i].x - reszecskek[j].x;
          const dy = reszecskek[i].y - reszecskek[j].y;
          const dist = Math.sqrt(dx*dx + dy*dy);
          if (dist < 130) {
            ctx.beginPath();
            ctx.moveTo(reszecskek[i].x, reszecskek[i].y);
            ctx.lineTo(reszecskek[j].x, reszecskek[j].y);
            ctx.strokeStyle = `rgba(33,150,243,${(1 - dist/130) * 0.12})`;
            ctx.lineWidth = 1; ctx.stroke();
          }
        }
      }
      reszecskek.forEach(r => {
        r.x += r.vx; r.y += r.vy;
        if (r.x < 0 || r.x > canvas.width) r.vx *= -1;
        if (r.y < 0 || r.y > canvas.height) r.vy *= -1;
        ctx.beginPath(); ctx.arc(r.x, r.y, r.r, 0, Math.PI * 2);
        ctx.fillStyle = r.szin; ctx.globalAlpha = r.alpha; ctx.fill(); ctx.globalAlpha = 1;
      });
      animId = requestAnimationFrame(rajzol);
    };
    rajzol();
    return () => { cancelAnimationFrame(animId); window.removeEventListener('resize', resize); };
  }, []);
  return <canvas ref={canvasRef} style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 0}}/>;
}

// ============ KONFETTI ============
function KonfettiHatter() {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    canvas.width = canvas.parentElement?.offsetWidth || 700;
    canvas.height = canvas.parentElement?.offsetHeight || 500;
    const ctx = canvas.getContext('2d');
    let animId;
    const reszecskek = Array.from({length: 150}, () => ({
      x: Math.random() * canvas.width, y: -20 - Math.random() * 200,
      r: Math.random() * 9 + 4, vx: (Math.random() - 0.5) * 5, vy: Math.random() * 5 + 2,
      szin: ['#2196f3','#1976d2','#42a5f5','#ff6b9d','#ffd93d','#6bcb77','#ff6b35','#c77dff'][Math.floor(Math.random()*8)],
      forgat: Math.random() * Math.PI * 2, forgSeb: (Math.random() - 0.5) * 0.18, forma: Math.floor(Math.random() * 3),
    }));
    const rajzol = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      reszecskek.forEach(r => {
        r.x += r.vx; r.y += r.vy; r.forgat += r.forgSeb;
        if (r.y > canvas.height + 20) { r.y = -20; r.x = Math.random() * canvas.width; }
        ctx.save(); ctx.translate(r.x, r.y); ctx.rotate(r.forgat);
        ctx.fillStyle = r.szin; ctx.globalAlpha = 0.9;
        if (r.forma === 0) { ctx.fillRect(-r.r/2, -r.r/2, r.r, r.r*1.5); }
        else if (r.forma === 1) { ctx.beginPath(); ctx.arc(0, 0, r.r/2, 0, Math.PI*2); ctx.fill(); }
        else { ctx.beginPath(); ctx.moveTo(0,-r.r/2); ctx.lineTo(r.r/2,r.r/2); ctx.lineTo(-r.r/2,r.r/2); ctx.closePath(); ctx.fill(); }
        ctx.restore(); ctx.globalAlpha = 1;
      });
      animId = requestAnimationFrame(rajzol);
    };
    rajzol();
    return () => cancelAnimationFrame(animId);
  }, []);
  return <canvas ref={canvasRef} style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', borderRadius: '28px', zIndex: 0}}/>;
}

// ============ AGENT X JEGYZET ============
function AgentXJegyzet({ jegyzet }) {
  if (!jegyzet) return null;
  return (
    <div style={{background: 'linear-gradient(135deg, #e3f2fd, #e8eaf6)', border: '2.5px solid #1976d2', borderRadius: '22px', padding: '1.5rem 2rem', animation: 'felugrik911 0.4s ease-out', boxShadow: '0 4px 20px rgba(25,118,210,0.12)'}}>
      <div style={{display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '0.875rem'}}>
        <div style={{width: '44px', height: '44px', borderRadius: '14px', background: 'linear-gradient(135deg, #1976d2, #1565c0)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '25px', flexShrink: 0}}>📝</div>
        <div>
          <p style={{fontSize: '18px', fontWeight: '900', color: '#1565c0', margin: 0}}>Agent X Jegyzet</p>
          <p style={{fontSize: '14px', color: '#90a4ae', margin: 0, fontWeight: '700'}}>Ezt jegyezd meg! 🕵️</p>
        </div>
      </div>
      <p style={{fontSize: '17px', fontWeight: '700', color: '#2d3748', margin: 0, lineHeight: 1.8}}>{jegyzet}</p>
    </div>
  );
}

// ============ AGENT X BUBORÉK (gépíró animáció) ============
function AgentXBuborek({ szoveg, szin }) {
  const [kijelzett, setKijelzett] = useState('');
  const [gepel, setGepel] = useState(true);
  const biztosSzoveg = szoveg || '';

  useEffect(() => {
    setKijelzett('');
    if (!biztosSzoveg) { setGepel(false); return; }
    setGepel(true);
    let i = 0;
    const id = setInterval(() => {
      i++;
      setKijelzett(biztosSzoveg.slice(0, i));
      if (i >= biztosSzoveg.length) { clearInterval(id); setGepel(false); }
    }, 20);
    return () => clearInterval(id);
  }, [biztosSzoveg]);

  return (
    <div className={gepel ? 'agentx-buborek villog' : 'agentx-buborek'}
      style={{background: 'var(--bg-card)', border: `2.5px solid ${szin}`, borderRadius: '18px', borderBottomLeftRadius: '4px', padding: '12px 14px', position: 'relative', fontSize: '15px', fontWeight: '700', color: '#2d3748', minHeight: '64px', width: '100%', boxSizing: 'border-box', lineHeight: 1.5, whiteSpace: 'pre-line'}}>
      {kijelzett}{gepel && <span className="agentx-kurzor">▌</span>}
      <div style={{position: 'absolute', top: '-9px', left: '24px', width: '16px', height: '16px', background: 'var(--bg-card)', borderTop: `2.5px solid ${szin}`, borderLeft: `2.5px solid ${szin}`, transform: 'rotate(45deg)'}}/>
    </div>
  );
}

const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&family=Baloo+2:wght@600;700;800&display=swap');
  .l911-wrapper * { font-family: 'Nunito', sans-serif !important; }
  .l911-wrapper h1, .l911-wrapper h2, .l911-fejcim { font-family: 'Baloo 2', 'Nunito', sans-serif !important; }
  .lecke-elrendezes { display: flex; gap: 2rem; align-items: flex-start; }
  .lecke-oldalsav { width: 200px; flex-shrink: 0; position: sticky; top: 80px; }
  @media (max-width: 768px) {
    .lecke-elrendezes { flex-direction: column; }
    .lecke-oldalsav { width: 100%; position: static; }
  }
  @keyframes felugrik911 { 0% { transform: translateY(24px) scale(0.97); opacity: 0; } 100% { transform: translateY(0) scale(1); opacity: 1; } }
  @keyframes pulzal911 { 0%,100% { transform: scale(1); } 50% { transform: scale(1.05); } }
  @keyframes ugorj911 { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
  @keyframes lapKiBal911 { 0% { transform: perspective(1400px) rotateY(0deg) scale(1); opacity: 1; } 100% { transform: perspective(1400px) rotateY(-90deg) scale(0.88); opacity: 0; } }
  @keyframes lapKiJobb911 { 0% { transform: perspective(1400px) rotateY(0deg) scale(1); opacity: 1; } 100% { transform: perspective(1400px) rotateY(90deg) scale(0.88); opacity: 0; } }
  @keyframes lapBe911 { 0% { transform: perspective(1400px) rotateY(90deg) scale(0.88); opacity: 0; } 100% { transform: perspective(1400px) rotateY(0deg) scale(1); opacity: 1; } }
  @keyframes csillog911 { 0%,100% { opacity: 0.7; } 50% { opacity: 1; } }
  @keyframes nagyitoBe { 0% { transform: scale(0.4) rotate(-15deg); opacity: 0; } 100% { transform: scale(1) rotate(0deg); opacity: 1; } }
  .lap-ki-bal911 { animation: lapKiBal911 0.4s cubic-bezier(0.4,0,1,1) forwards; }
  .lap-ki-jobb911 { animation: lapKiJobb911 0.4s cubic-bezier(0.4,0,1,1) forwards; }
  .lap-be911 { animation: lapBe911 0.45s cubic-bezier(0,0,0.2,1) forwards; }
  .k911-btn { transition: transform 0.18s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.18s ease, filter 0.18s ease !important; position: relative; overflow: hidden; }
  .k911-btn:hover { transform: translateY(-4px) scale(1.05) !important; filter: brightness(1.08) !important; }
  .k911-btn:active { transform: translateY(-1px) scale(0.97) !important; }
  .k911-btn::after { content: ''; position: absolute; inset: 0; background: linear-gradient(120deg, transparent 20%, rgba(255,255,255,0.55) 45%, transparent 70%); transform: translateX(-140%); transition: none; pointer-events: none; }
  .k911-btn:hover::after { animation: fenySepres 0.9s ease; }
  @keyframes fenySepres { 0% { transform: translateX(-140%); } 100% { transform: translateX(140%); } }
  .k911-kartya { transition: transform 0.3s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.3s ease !important; }
  .k911-kartya:hover { transform: translateY(-12px) scale(1.03) rotate(-0.5deg) !important; box-shadow: 0 28px 64px rgba(33,150,243,0.28) !important; }
  .k911-valasz { transition: all 0.2s cubic-bezier(0.34,1.56,0.64,1) !important; }
  .k911-valasz:hover:not([data-disabled]) { transform: translateY(-5px) scale(1.025) !important; box-shadow: 0 10px 24px rgba(33,150,243,0.18) !important; }
  .nyomozo-elem { transition: all 0.25s cubic-bezier(0.34,1.56,0.64,1) !important; }
  .nyomozo-elem:hover:not([data-disabled]) { transform: scale(1.05) !important; z-index: 5; box-shadow: 0 14px 36px rgba(33,150,243,0.3) !important; }
  .nyomozo-nagyito { animation: nagyitoBe 0.35s cubic-bezier(0.34,1.56,0.64,1); }
  .nyomozo-dokumentum, .nyomozo-dokumentum * { cursor: none !important; }
  @keyframes buborekVillog { 0%,100% { box-shadow: 0 0 0 0 rgba(25,118,210,0); } 50% { box-shadow: 0 0 16px 3px rgba(25,118,210,0.35); } }
  .agentx-buborek.villog { animation: buborekVillog 0.7s ease-in-out infinite; }
  @keyframes kurzorVillog { 0%,50% { opacity: 1; } 51%,100% { opacity: 0; } }
  .agentx-kurzor { animation: kurzorVillog 0.5s steps(1) infinite; margin-left: 1px; }
  @keyframes zoldVillan { 0%,100% { background: white; border-color: inherit; } 50% { background: #e8f5e9; box-shadow: 0 0 0 4px rgba(52,168,83,0.3); } }
  .jo-villog { animation: zoldVillan 0.6s ease-in-out 3; }
  @keyframes pirosVillan { 0%,100% { box-shadow: 0 0 0 0 rgba(234,67,53,0); } 30% { box-shadow: 0 0 0 8px rgba(234,67,53,0.45); } }
  .piros-villan { animation: pirosVillan 0.5s ease-out; }
  @keyframes gradientMozog { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
  .k911-bg-animalt { background-size: 200% 200% !important; animation: gradientMozog 12s ease infinite; }
  @keyframes lebeg911 { 0%,100% { transform: translateY(0) translateX(0) rotate(0deg); } 33% { transform: translateY(-18px) translateX(8px) rotate(4deg); } 66% { transform: translateY(10px) translateX(-8px) rotate(-4deg); } }
  .k911-lebego { animation: lebeg911 7s ease-in-out infinite; }
  @keyframes popBe911 { 0% { transform: scale(0.5); opacity: 0; } 60% { transform: scale(1.08); opacity: 1; } 100% { transform: scale(1); opacity: 1; } }
  .k911-pop { animation: popBe911 0.45s cubic-bezier(0.34,1.56,0.64,1); }
  @keyframes gyuruLokes { 0% { box-shadow: 0 0 0 0 rgba(52,168,83,0.55); } 100% { box-shadow: 0 0 0 26px rgba(52,168,83,0); } }
  .k911-siker { animation: gyuruLokes 0.7s ease-out, popBe911 0.4s cubic-bezier(0.34,1.56,0.64,1); }
  @keyframes neonPulzal { 0%,100% { box-shadow: 0 0 0 0 currentColor; } 50% { box-shadow: 0 0 22px 4px currentColor; } }
  .k911-neon { animation: neonPulzal 2s ease-in-out infinite; }
  @keyframes csillagPerdul { 0% { transform: rotate(0deg) scale(1); } 50% { transform: rotate(180deg) scale(1.2); } 100% { transform: rotate(360deg) scale(1); } }
  .k911-csillag-forog { animation: csillagPerdul 3s linear infinite; display: inline-block; }
  @keyframes szivdobbanas { 0%,100% { transform: scale(1); } 15% { transform: scale(1.18); } 30% { transform: scale(1); } 45% { transform: scale(1.12); } 60% { transform: scale(1); } }
  .k911-dobban { animation: szivdobbanas 2.4s ease-in-out infinite; }
`;

const kuldetesek = [
  {
    id: 1, cim: 'Digitális identitásom', ikon: '🪪', szin: '#1976d2',
    leiras: 'Ki vagyok én az interneten? Mit mutatok magamból és mit nem?',
    konyv: {
      cim: 'Az online én és a valódi én',
      oldalak: [
        { szoveg: 'Az interneten mindenki választhat magának egy digitális identitást. Ez a felhasználóneved, a profilképed, és amit megosztasz magadról. De vajon mindig mindent meg kell mutatni?', ikon: '🪪', illusztracio: '👤💻', haatter: 'linear-gradient(135deg, #e3f2fd, #e8eaf6)' },
        { szoveg: 'Vannak dolgok amiket biztonságosan megoszthatsz: a kedvenc zenéd, hobbid, kedvenc focicsapatod. De a lakcímed, telefonszámod, iskolád neve - ezek maradjanak titokban!', ikon: '🔒', illusztracio: '✅❌', haatter: 'linear-gradient(135deg, #e8f5e9, #e3f2fd)' },
        { szoveg: 'Az avatar - egy rajzolt kép, emoji vagy kitalált figura - biztonságosabb, mint a saját fotód. Senki nem köteles a saját arcképét felrakni!', ikon: '🎭', illusztracio: '🎭🛡️', haatter: 'linear-gradient(135deg, #f3e5f5, #e3f2fd)' },
        { szoveg: 'Mielőtt bármit megosztasz magadról, kérdezd meg: "Megmutatnám ezt egy idegennek az utcán?" Ha nem - az interneten sem szabad!', ikon: '🤔', illusztracio: '🤔💡', haatter: 'linear-gradient(135deg, #e3f2fd, #e8f5e9)' },
        { szoveg: 'A digitális lábnyom: minden amit feltöltesz, ott maradhat évekig. Egy rossz fotó, egy csúnya komment - évek múlva is megtalálható lehet!', ikon: '👣', illusztracio: '👣⚠️', haatter: 'linear-gradient(135deg, #fff8e1, #e3f2fd)', szabaly: 'Az online profilod csak annyit mutasson amennyit egy idegennek is megmutatnál! 🛡️' },
      ],
    },
    feladatok: [
      {
        id: 'k1_1', tipus: 'profil_epito_drag',
        cim: '🎨 Profilépítő',
        kerdes: 'Húzd át a bal oldali elemeket a profilodba, amiket érdemes megjeleníteni!',
        elemek: [
          { kep: '🦊', felirat: 'Profilkép (rajzolt avatar)', megjelenitheto: true, magyarazat: 'Kitalált avatar, nem árulja el, hogy nézel ki — biztonságos!' },
          { kep: '🐉', felirat: 'Felhasználónév', megjelenitheto: true, magyarazat: 'Kitalált becenév, nem a valódi neved — biztonságos!' },
          { kep: '📝', felirat: 'Bemutatkozás (hobbi)', megjelenitheto: true, magyarazat: 'Ártatlan hobbi-infó, nem azonosít téged — biztonságos!' },
          { kep: '📞', felirat: 'Telefonszám', megjelenitheto: false, magyarazat: 'Közvetlen kapcsolatot ad idegeneknek — soha ne tedd ki!' },
          { kep: '🏫', felirat: 'Iskola', megjelenitheto: false, magyarazat: 'Elárulja, hol találhatnak meg naponta — veszélyes!' },
          { kep: '🏠', felirat: 'Lakcím', megjelenitheto: false, magyarazat: 'Elárulja, hol laksz — soha ne oszd meg nyilvánosan!' },
        ],
        visszajelzes_jo: 'Pontosan! Így épül fel egy biztonságos profil! 🎨',
        visszajelzes_rossz: 'Gondold át! Melyik adat segítene megtalálni téged a valóságban? Azt ne tedd be a profilba!',
        jegyzet: '🎨 Egy jó profil felépítése\n\nA profilkép, a becenév és egy hobbi-szintű bemutatkozás nyugodtan lehet nyilvános — ezek nem árulnak el semmit arról, hol laksz vagy hogyan találhatnak meg. A telefonszám, iskola és lakcím viszont közvetlen "kaput" nyit a való életedhez — ezek MINDIG maradjanak titokban, ne kerüljenek be a profilba!'
      },
      {
        id: 'k1_2', tipus: 'nyomozo',
        cim: '🕵️ Cyber Detective',
        kerdes: 'Vizsgáld át a nyomokat! Ki a kamu profil? Melyik üzenet adathalász? Hol árul el túl sokat egy kép?',
        elemek: [
          { szoveg: '👤 Profil: "Kovács Panni, 10 éves, Petőfi suli 5.b" — saját fotóval', gyanús: true, magyarazat: '🚨 Kamu-biztonságú profil: túl sok valós, azonosító adatot mutat!' },
          { szoveg: '👤 Profil: "@dragonslayer_99" — kitalált avatarral, csak hobbikkal', gyanús: false, magyarazat: 'Ez egy jól felépített, biztonságos profil.' },
          { szoveg: '📧 Üzenet: "Kattints ide, és add meg a jelszavad az ellenőrzéshez!"', gyanús: true, magyarazat: '🚨 Klasszikus adathalász üzenet — jelszót soha nem kérnek így!' },
          { szoveg: '📧 Üzenet: "Szia! Holnap suli után focizunk?" — osztálytárstól', gyanús: false, magyarazat: 'Ez egy normális, hétköznapi üzenet.' },
          { szoveg: '🖼️ Kép: szelfi, ami mutatja a háttérben az utcatáblát és a házszámot', gyanús: true, magyarazat: '🚨 A kép háttere elárulja, pontosan hol laksz!' },
          { szoveg: '🖼️ Kép: rajzolt kép a kedvenc állatodról', gyanús: false, magyarazat: 'Ártatlan, semmilyen azonosító adatot nem árul el.' },
        ],
        visszajelzes_jo: 'Kiváló nyomozómunka, Agent X! Minden gyanús nyomot megtaláltál! 🕵️',
        visszajelzes_rossz: 'Vizsgáld át még egyszer a nyomokat — van, amit kihagytál!',
        jegyzet: '🕵️ A digitális nyomozás 3 alapkérdése\n\n1️⃣ Ki ez valójában? (profil-ellenőrzés)\n2️⃣ Mit akar tőlem? (üzenet-ellenőrzés)\n3️⃣ Mit árul el rólam ez a kép? (kép-ellenőrzés)\n\nHa ezt a 3 kérdést mindig feltesszük magunknak, sokkal nehezebb átverni minket online!'
      },
      {
        id: 'k1_3', tipus: 'memoria',
        cim: '🧠 Memória — nem a hagyományos!',
        parok: [
          { a: '📧 Adathalász email', b: 'Veszély' },
          { a: '🔒 Lakat ikon a böngészőben', b: 'Biztonságos oldal' },
          { a: '👤 Kamu profil', b: 'Jelentsd be!' },
          { a: '🦊 Rajzolt avatar', b: 'Biztonságos profilkép' },
          { a: '📍 Pontos cím megosztása', b: 'Veszélyes adat' },
        ],
        jegyzet: '🧠 Miért nem a hagyományos memóriajáték ez?\n\nEbben a játékban nem két egyforma képet keresel, hanem egy FOGALMAT és a hozzá tartozó JELENTÉST kell megtalálnod. Ez sokkal jobban megtanítja az összefüggéseket, mint ha csak egyforma párokat keresnél!'
      },
      {
        id: 'k1_4', tipus: 'parosito',
        cim: '🔗 Párosító: fogalom és jelentés',
        parok: [
          { a: '🪪 Profil', b: 'Az online megjelenésed' },
          { a: '👤 Felhasználónév', b: 'Az azonosítód, ami nem a valódi neved' },
          { a: '🎭 Avatar', b: 'Kitalált kép, ami nem az arcod' },
          { a: '📊 Adat', b: 'Bármilyen infó, amit megosztasz magadról' },
          { a: '🔒 Privát', b: 'Csak te (vagy engedélyezettek) láthatják' },
        ],
        jegyzet: '🎭 A jó álca 3 pillére\n\nEgy biztonságos profil: 1) Kitalált vizuális azonosító (nem a te arcod), 2) Semleges, kitalált becenév, 3) Csak hobbi-szintű infó a bemutatkozásban. Ha mindhárom megvan, a profilod érdekes marad, de senki nem tud belőle megtalálni téged a valóságban!'
      },
      {
        id: 'k1_5', tipus: 'szokereso',
        cim: '🔎 Digitális identitás szókereső',
        szavak: ['PROFIL', 'FELHASZNÁLÓNÉV', 'AVATAR', 'ADAT', 'PRIVÁT', 'BECENÉV', 'IDENTITÁS', 'BEMUTATKOZÁS'],
        jegyzet: '🔎 Ezek a szavak mind a digitális identitás alapfogalmai — ha ismered mindet, sokkal tudatosabban tudod felépíteni a saját online profilodat!'
      },
    ],
  },
  {
    id: 2, cim: 'Átverések felismerése', ikon: '🎣', szin: '#1565c0',
    leiras: 'Phishing, scam, fake news - felismered a csapdákat?',
    konyv: {
      cim: 'Az internetes csapdák',
      oldalak: [
        { szoveg: 'Az adathalászat (phishing) átverés, ahol valaki azt teszi, mintha cég lenne - hogy ellopja az adataidat. Ez lehet email, üzenet, vagy hamis weboldal!', ikon: '🎣', illusztracio: '🎣🚨', haatter: 'linear-gradient(135deg, #e3f2fd, #fce4ec)' },
        { szoveg: 'A "túl szép hogy igaz legyen" elv: ha valamit ingyen kínálnak, nyereményt ígérnek, vagy azt mondják "csak neked" - az szinte mindig átverés!', ikon: '🎁', illusztracio: '🎁❌', haatter: 'linear-gradient(135deg, #fff8e1, #e3f2fd)' },
        { szoveg: 'A hamis weboldalak úgy néznek ki, mint az igaziak- de ha megnézed az URL-t, van benne elírás vagy furcsa domain. Mindig ellenőrizd a lakat ikont és az URL-t!', ikon: '🌐', illusztracio: '🌐🔍', haatter: 'linear-gradient(135deg, #e8f5e9, #e3f2fd)' },
        { szoveg: 'A social engineering az emberi pszichológiát használja ki - sürgetéssel, félelemkeltéssel, vagy jutalommal próbálnak rávenni valamire. "Azonnal cselekedj!" "Csak ma!" - ezek manipulációs taktikák!', ikon: '🧠', illusztracio: '🧠⚠️', haatter: 'linear-gradient(135deg, #f3e5f5, #e3f2fd)' },
        { szoveg: 'Az álhírek (fake news) szándékosan félrevezető tartalmak. Mielőtt továbbküldöd: ellenőrizd a forrást, keress más oldalakon is, és nézd meg mikor jelent meg!', ikon: '📰', illusztracio: '📰🔍', haatter: 'linear-gradient(135deg, #e3f2fd, #e8f5e9)', szabaly: 'Ha túl szép hogy igaz legyen - biztosan átverés! Ellenőrizz mielőtt kattintasz! 🔍' },
      ],
    },
    feladatok: [
      {
        id: 'k2_1', tipus: 'valogatо',
        cim: '📰 Fake News Labor',
        kerdes: 'Húzd a megfelelő helyre — valódi vagy kamu hír?',
        elemek: [
          { kep: '📰', felirat: '"Kutatók szerint a csoki hivatalosan zöldség" — forrás nélkül', kategoria: 'kamu' },
          { kep: '📰', felirat: '"Iskolai szünidők a következő tanévre" — iskola honlapján', kategoria: 'valos' },
          { kep: '📰', felirat: '"SOKKOLÓ! Ezt senki nem hiszi el!"', kategoria: 'kamu' },
          { kep: '📰', felirat: '"Holnap eső várható" — ismert időjárás-oldalon', kategoria: 'valos' },
          { kep: '📰', felirat: '"Tudósok szerint..." — meg nem nevezett forrással', kategoria: 'kamu' },
          { kep: '📰', felirat: '"Új könyvtár nyílt a városban" — helyi hírportálon', kategoria: 'valos' },
        ],
        kategoriak: [
          { id: 'valos', felirat: '✅ Valódi', szin: '#34a853' },
          { id: 'kamu', felirat: '🚨 Kamu', szin: '#ea4335' },
        ],
        visszajelzes_jo: 'Szuper! Felismered a valós és kamu híreket! 📰',
        visszajelzes_rossz: 'Gondold át! Van forrás? Ellenőrizhető az állítás?',
        jegyzet: '📰 A Fake News lab 3 gyors ellenőrzési pontja\n\n1️⃣ VAN FORRÁS? — ha nincs megnevezve, honnan van az infó, gyanús\n2️⃣ TÚLZÓ-E A CÍM? — "sokkoló", "senki nem hiszi el" = figyelemfelkeltő csali\n3️⃣ MEGTALÁLHATÓ MÁSHOL IS? — ha csak egy ismeretlen oldalon van, valószínűleg álhír'
      },
      {
        id: 'k2_2', tipus: 'email_postafiok',
        cim: '📥 Phishing detektor',
        kerdes: 'Ez a postafiókod. Koppints minden gyanús, átverős emailre!',
        emailek: [
          { feladoNev: 'NetOkos Admin', targy: 'SÜRGŐS: Fiókod zárolva lesz!', elonezet: 'Kattints ide, és add meg a jelszavadat az ellenőrzéshez...', ido: '08:14', gyanús: true, magyarazat: 'Sürgetés + jelszó kérése = klasszikus adathalászat!' },
          { feladoNev: 'Anya', targy: 'Ne felejts el bevásárolni!', elonezet: 'Szia! Legyél szíves vegyél tejet hazafelé...', ido: '07:32', gyanús: false, magyarazat: 'Ismerős feladó, hétköznapi üzenet, semmi gyanús.' },
          { feladoNev: 'Nyeremény Központ', targy: 'GRATULÁLUNK! Nyertél egy telefont!', elonezet: 'Csak ma! Kattints ide és add meg adataidat...', ido: '09:03', gyanús: true, magyarazat: 'Véletlenszerű "nyeremény" + mesterséges határidő!' },
          { feladoNev: 'Iskola', targy: 'Emlékeztető: szülői értekezlet', elonezet: 'Kedves Szülők, holnap 17:00-kor...', ido: '06:50', gyanús: false, magyarazat: 'Ismert, hivatalos forrás, normális üzenet.' },
          { feladoNev: 'Fiókod Ellenőrzés', targy: 'Ha 24 órán belül nem válaszol, törlődik!', elonezet: 'Kedves Felhasználó, azonnali intézkedés szükséges...', ido: '11:47', gyanús: true, magyarazat: 'Mesterséges határidő + általános megszólítás = gyanús!' },
          { feladoNev: 'Spotify', targy: 'Havi zenei összesítőd elkészült', elonezet: 'Nézd meg, mit hallgattál a hónapban...', ido: '10:20', gyanús: false, magyarazat: 'Ismert szolgáltatótól érkező, normális értesítés.' },
          { feladoNev: 'Support Team', targy: 'Kattints ide a jelszó megerősítéséhez', elonezet: 'admin@netokos-biztonsag.info küldte...', ido: '13:05', gyanús: true, magyarazat: 'Furcsa, nem hivatalos domain + jelszót kér!' },
          { feladoNev: 'Nagyi', targy: 'Örülök hogy jól vagytok!', elonezet: 'Kedveseim, ölellek titeket mindannyiótokat...', ido: '14:12', gyanús: false, magyarazat: 'Ismerős, meleg hangvételű, hétköznapi üzenet.' },
        ],
        jegyzet: '🎣 A phishing email 5 klasszikus jele:\n\n1️⃣ SÜRGETÉS - "Azonnal!" "24 óra!" "Most!" = manipuláció\n2️⃣ HAMIS DOMAIN - furcsa, nem hivatalos email cím\n3️⃣ ÁLTALÁNOS MEGSZÓLÍTÁS - "Kedves Felhasználó" a neved helyett\n4️⃣ JELSZÓ KÉRÉS - valódi cégek SOHA nem kérik emailben\n5️⃣ TÚL JÓ AJÁNLAT - véletlenszerű nyeremény, ingyen ajándék'
      },
      {
        id: 'k2_3', tipus: 'chat_szimulacios',
        cim: '💬 Chat elemzés',
        leiras: 'Egy ismeretlen ír neked. Jelöld meg, mi gyanús, és válaszolj helyesen!',
        korok: [
          { menetek: [{ uzenet: 'GRATULÁLUNK! 🎉 Nyertél 50.000 Ft ajándékkártyát! Kattints IDE és add meg az adataidat az átvételhez, csak MA érvényes!',
            valaszok: [
              { szoveg: '🟢 Törlöm, bejelentem spamnek, szólok a szüleimnek', helyes: true, magyarazat: 'HELYES! Ez klasszikus átverés — sosem "nyertél" véletlenszerűen!' },
              { szoveg: '🔴 Megadom az adataimat, hiszen ingyen pénz', helyes: false, magyarazat: 'ROSSZ! Ez adatlopás — soha ne add meg az adataidat!' },
              { szoveg: '🟡 Megkérdezem, hogy valódi-e', helyes: false, magyarazat: 'ROSSZ! A csalók természetesen azt mondják, igen!' },
            ]}] },
          { menetek: [{ uzenet: 'Szia! Az osztálytársad vagyok, elfelejtettem a matek házit, elküldenéd a jelszavad a suli felülethez, hogy lemásoljam?',
            valaszok: [
              { szoveg: '🟢 "Nem oszthatom meg a jelszavamat, de elküldöm neked magát a feladatot"', helyes: true, magyarazat: 'HELYES! Segítesz, de a jelszót nem adod ki!' },
              { szoveg: '🔴 Elküldöm a jelszavam, hiszen osztálytárs', helyes: false, magyarazat: 'ROSSZ! A jelszót még ismerősnek se add meg!' },
              { szoveg: '🟡 Nem válaszolok semmit', helyes: false, magyarazat: 'JOBB, ha udvariasan elmagyarázod, miért nem teheted meg!' },
            ]}] },
          { menetek: [{ uzenet: 'Szia, ismeretlen vagyok, de láttam a Fortnite profilod. Ha elküldöd a fiókod adatait, adok neked ingyen skinket!',
            valaszok: [
              { szoveg: '🟢 Nem küldöm el, blokkolom, és szólok a szüleimnek', helyes: true, magyarazat: 'HELYES! Klasszikus fióklopási kísérlet!' },
              { szoveg: '🔴 Elküldöm, hiszen ingyen skint ígért', helyes: false, magyarazat: 'ROSSZ! Ez fióklopás — soha ne add meg az adataidat!' },
              { szoveg: '🟡 Megkérdezem, milyen skineket ad', helyes: false, magyarazat: 'ROSSZ! Ne kezdj el alkudozni egy gyanús ajánlatra!' },
            ]}] },
        ],
        jegyzet: '💳 Miért annyira veszélyes az adatok megadása?\n\nHa megadod az adataidat egy ilyen üzenetre, a csalók azonnal visszaélhetnek velük. A szabály egyszerű: ha "nyertél" valamit, amire nem is jelentkeztél, vagy valaki a jelszavadat kéri — az szinte biztosan átverés!'
      },
      {
        id: 'k2_4', tipus: 'chat_szimulacios',
        cim: '📱 SMS szimulátor',
        leiras: 'Ez egy valódi, oda-vissza SMS beszélgetés. Hogyan válaszolsz minden üzenetre?',
        stilus: 'sms',
        korok: [
          { menetek: [
            { uzenet: 'Szia! Itt a futárszolgálat. A csomagod úton van, de egy kis illeték hiányzik. Kattints ide a fizetéshez: bit.ly/csomag-fizetes',
              valaszok: [
                { szoveg: '🟢 Nem kattintok, ellenőrzöm a hivatalos futárcég oldalán', helyes: true, magyarazat: 'HELYES! Gyanús, rövidített link + fizetési kérés SMS-ben!' },
                { szoveg: '🔴 Rákattintok és kifizetem, hogy megkapjam a csomagot', helyes: false, magyarazat: 'ROSSZ! Ez klasszikus SMS-adathalászat (smishing)!' },
                { szoveg: '🟡 Visszaírok, hogy "melyik csomagról van szó?"', helyes: false, magyarazat: 'ROSSZ! Ne lépj kapcsolatba, csak ellenőrizz hivatalos forrásból!' },
              ]},
            { uzenet: 'De tényleg sürgős! Ha nem fizetsz most azonnal, visszaküldjük a csomagot, és elveszik a pénzed!',
              valaszok: [
                { szoveg: '🟢 Akkor sem kattintok ismeretlen linkre — szólok a szüleimnek erről az üzenetről', helyes: true, magyarazat: 'HELYES! A sürgetés fokozása is átverési jel — ne engedj a nyomásnak!' },
                { szoveg: '🔴 Jó, akkor gyorsan kifizetem, nehogy elvesszen', helyes: false, magyarazat: 'ROSSZ! Minél jobban sürgetnek, annál gyanúsabb!' },
                { szoveg: '🟡 Kérek egy telefonszámot, ahol felhívhatom őket', helyes: false, magyarazat: 'JOBB, ha te magad keresed meg a hivatalos elérhetőséget, nem az ő számukat!' },
              ]},
          ]},
          { menetek: [
            { uzenet: 'Szia, itt anya! Elvesztettem a telefonom, ezt egy barátom telefonjáról írom. Küldj sürgősen 5000 Ft-ot erre a számra, ne szólj apának!',
              valaszok: [
                { szoveg: '🟢 Felhívom anyát a saját, ismert számán, mielőtt bármit tennék', helyes: true, magyarazat: 'HELYES! A visszaellenőrzés az egyetlen biztos védekezés!' },
                { szoveg: '🔴 Azonnal küldöm a pénzt, hiszen anya kérte', helyes: false, magyarazat: 'ROSSZ! Ez lehet átverés — az üzenet is hamisítható!' },
                { szoveg: '🟡 Visszaírok: "biztos te vagy az?"', helyes: false, magyarazat: 'ROSSZ! Egy csaló erre is simán azt válaszolja: igen!' },
              ]},
            { uzenet: 'Ne hívj fel, nincs térerő itt, csak írj vissza, hogy oké és küldd el most!',
              valaszok: [
                { szoveg: '🟢 Nem küldöm el, amíg nem beszéltem élőben vagy telefonon anyával/apával', helyes: true, magyarazat: 'HELYES! Az, hogy "ne hívj fel" önmagában erős gyanújel!' },
                { szoveg: '🔴 Rendben, visszaírok, hogy "oké" és küldöm a pénzt', helyes: false, magyarazat: 'ROSSZ! Ez pontosan az, amit egy csaló szeretne hallani!' },
                { szoveg: '🟡 Megkérdezem, miért nincs térerő', helyes: false, magyarazat: 'ROSSZ! Ne alkudozz — inkább szólj apának/egy másik felnőttnek!' },
              ]},
          ]},
          { menetek: [
            { uzenet: 'GRATULÁLUNK! 🎉 A telefonszámod nyert egy iPhone-t! Igényléshez kattints: bit.ly/nyertem-iphone',
              valaszok: [
                { szoveg: '🟢 Nem kattintok, törlöm, hiszen nem is jelentkeztem semmilyen sorsolásra', helyes: true, magyarazat: 'HELYES! Amire nem jelentkeztél, azon nem is nyerhetsz!' },
                { szoveg: '🔴 Rákattintok, hátha tényleg nyertem', helyes: false, magyarazat: 'ROSSZ! Ez szinte biztosan átverés vagy kártevő link!' },
                { szoveg: '🟡 Visszaírok, hogy "biztos ez nem átverés?"', helyes: false, magyarazat: 'ROSSZ! Ne is válaszolj — ezzel jelzed, hogy a szám aktív!' },
              ]},
            { uzenet: 'Csak MA érvényes az ajánlat! Ne hagyd ki, kattints most, mielőtt lejár!',
              valaszok: [
                { szoveg: '🟢 Törlöm az üzenetet, és ha szeretném, bejelentem spamnek', helyes: true, magyarazat: 'HELYES! A mesterséges határidő is klasszikus manipuláció!' },
                { szoveg: '🔴 Na jó, gyorsan megnézem, mielőtt lejár', helyes: false, magyarazat: 'ROSSZ! Az "azonnal, mielőtt lejár" mindig gyanújel!' },
                { szoveg: '🟡 Megmutatom egy barátomnak, hátha ő tudja, mi ez', helyes: false, magyarazat: 'JOBB, ha egyszerűen törlöd, és ha kell, szólsz egy felnőttnek!' },
              ]},
          ]},
        ],
        jegyzet: '📱 A "smishing" (SMS phishing) egyre gyakoribb\n\nAz átverők ma már SMS-ben is próbálkoznak, mert sokan jobban megbíznak egy szöveges üzenetben, mint egy emailben. A szabály ugyanaz: sürgetés, gyanús link, pénzkérés vagy jelszókérés esetén — állj meg, ellenőrizz, és szólj egy felnőttnek! Ha egyszer gyanús volt az első üzenet, a folytatás is az marad, még ha jobban is nyomulnak!'
      },
      {
        id: 'k2_5', tipus: 'qr_vizsgalo',
        cim: '📷 QR-kód kihívás',
        kerdes: 'Koppints minden ROSSZ (gyanús) QR-kódra!',
        kodok: [
          { leiras: 'Suli hivatalos hirdetőtábláján, az órarendhez', rossz: false, magyarazat: '✅ Ismert, hivatalos helyről származik.' },
          { leiras: 'Utcán talált cetlin: "Olvasd be, és nyerj telefont!"', rossz: true, magyarazat: '🚨 Ismeretlen forrás + túl jó ígéret!' },
          { leiras: 'Barátod telefonján, amit ő mutat neked személyesen', rossz: false, magyarazat: '✅ Ismert személytől, személyesen.' },
          { leiras: 'Egy parkoló-automatán, hivatalos matricával', rossz: false, magyarazat: '✅ Hivatalos, jól látható helyen elhelyezett kód.' },
          { leiras: 'Egy leragasztott cetlin egy valódi hivatalos QR-kód felett', rossz: true, magyarazat: '🚨 Ráragasztott kód — valaki lecserélte az eredetit!' },
          { leiras: 'Emailben, ismeretlen feladótól, "olvasd be sürgősen!"', rossz: true, magyarazat: '🚨 Ismeretlen feladó + sürgetés = gyanús!' },
          { leiras: 'Éttermi asztalon, a menühöz, nyomtatott kártyán', rossz: false, magyarazat: '✅ Várt, helyben elhelyezett, hivatalos kód.' },
        ],
        jegyzet: '📷 Miért veszélyesek az ismeretlen QR-kódok?\n\nEgy QR-kód egy weboldalra vagy appra irányíthat — de amíg be nem olvasod, nem látod, hova visz! Az ismeretlen helyen talált, vagy eredeti kódra ráragasztott QR-kódok mögött gyakran adathalász oldalak vagy kártevők rejtőznek. A szabály: csak ismert, megbízható, várt forrásból származó QR-kódot olvass be!'
      },
    ],
  },
  {
    id: 3, cim: 'Cyberbullying stop!', ikon: '🛡️', szin: '#1976d2',
    leiras: 'Online zaklatás felismerése, kezelése és megelőzése!',
    konyv: {
      cim: 'Amikor az internet fáj',
      oldalak: [
        { szoveg: 'A cyberbullying (online zaklatás) azt jelenti, amikor valaki az interneten szándékosan bántja, megalázza, vagy fenyegeti a másikat. Ez éppúgy fáj mint a valódi zaklatás!', ikon: '💔', illusztracio: '💔💻', haatter: 'linear-gradient(135deg, #fce4ec, #e3f2fd)' },
        { szoveg: 'A cyberbullying formái: bántó üzenetek, kínos képek megosztása, kiközösítés online csoportokból, hamis profilok létrehozása, személyes adatok nyilvánosságra hozatala.', ikon: '📋', illusztracio: '📋⚠️', haatter: 'linear-gradient(135deg, #fff8e1, #fce4ec)' },
        { szoveg: 'Ha zaklatnak: NE válaszolj vissza! Mentsd el a bizonyítékokat (screenshot). Blokkold a személyt. Szólj egy megbízható felnőttnek. Jelents be a platformon!', ikon: '🛡️', illusztracio: '🛡️📸', haatter: 'linear-gradient(135deg, #e8f5e9, #e3f2fd)' },
        { szoveg: 'Ha mást zaklatnak és te látod: Te sem vagy semleges! A passzív nézés megerősíti a zaklatót. Egy privát üzenet az áldozatnak - "nem vagy egyedül" - hatalmas különbséget jelenthet!', ikon: '🤝', illusztracio: '🤝💪', haatter: 'linear-gradient(135deg, #e3f2fd, #e8f5e9)' },
        { szoveg: 'A mentális egészség fontos! Ha valami nagyon rosszul érint az interneten - ok és jogos hogy fájdalmas. Szólj egy felnőttnek ne tartsd magadban! A segítségkérés erősség nem gyengeség!', ikon: '💚', illusztracio: '💚🤗', haatter: 'linear-gradient(135deg, #e8f5e9, #e3f2fd)', szabaly: 'Mentsd, blokkold, jelents, szólj felnőttnek! Soha ne maradj egyedül! 🛡️' },
      ],
    },
    feladatok: [
      {
        id: 'k3_1', tipus: 'chat_szimulacios',
        cim: '💬 Chat folytatása',
        leiras: 'Valaki bántó üzenetet küld. Mit válaszolnál?',
        korok: [
          { menetek: [{ uzenet: 'Te egy total idióta vagy! Mindenki utál! Jobb lenne ha nem lennél itt! 😡',
            valaszok: [
              { szoveg: '🟢 Nem válaszolok, screenshotot csinálok, blokkolom és szólok egy felnőttnek', helyes: true, magyarazat: 'HELYES! Ez a helyes protokoll zaklatás esetén!' },
              { szoveg: '🔴 Visszaírok hasonló bántásokat', helyes: false, magyarazat: 'ROSSZ! Ez eszkalálja a helyzetet!' },
              { szoveg: '🟡 Megkérdezem miért dühös', helyes: false, magyarazat: 'ROSSZ! Ne engedd hogy belevonjanak a konfliktusba!' },
            ]}] },
          { menetek: [{ uzenet: 'Ha nem küldesz nekem pénzt, elmondom mindenkinek a titkodat, amit megosztottál velem!',
            valaszok: [
              { szoveg: '🟢 Nem fizetek, mentem bizonyítékként, és azonnal szólok egy felnőttnek', helyes: true, magyarazat: 'HELYES! Ez zsarolás — sose fizess, mindig szólj felnőttnek!' },
              { szoveg: '🔴 Küldök pénzt, hogy ne mondja el', helyes: false, magyarazat: 'ROSSZ! A zsarolók a fizetés után is folytathatják!' },
              { szoveg: '🟡 Megkérem, hogy ne mondja el, de nem szólok senkinek', helyes: false, magyarazat: 'ROSSZ! Ezt egyedül nem kell megoldanod — szólj felnőttnek!' },
            ]}] },
          { menetek: [{ uzenet: 'Az egész osztály csoportjában kitettek egy kínos fotót rólad, és mindenki nevet rajta.',
            valaszok: [
              { szoveg: '🟢 Screenshotot mentek, kérem a törlését, és szólok egy felnőttnek/tanárnak', helyes: true, magyarazat: 'HELYES! Bizonyíték + felnőtt bevonása a helyes lépés!' },
              { szoveg: '🔴 Kiteszek én is egy kínos fotót valaki másról bosszúból', helyes: false, magyarazat: 'ROSSZ! Ezzel te magad is zaklatóvá válsz!' },
              { szoveg: '🟡 Nem csinálok semmit, hátha elfelejtik', helyes: false, magyarazat: 'ROSSZ! A csoportban maradó tartalom tovább terjedhet!' },
            ]}] },
        ],
        jegyzet: '🧘 A STOP technika\n\n🛑 STOP - Ne válaszolj azonnal\n💨 LÉLEGEZZ - Vegyél mély levegőt\n📸 SCREENSHOT - Mentsd el a bizonyítékot\n👨‍👩‍👧 SZÓLJ - Keress megbízható felnőttet\n\nAz érzelmeid fontosak - de a biztonságod még fontosabb!'
      },
      {
        id: 'k3_2', tipus: 'erzelemfelismero',
        cim: '😢 Érzelemfelismerő',
        korok: [
          { kerdes: 'Ha valakit ismételten kicsúfolnak egy csoportban, valószínűleg így érzi magát:', opciok: [
            { emoji: '😊', felirat: 'Boldog', helyes: false, magyarazat: 'Nem valószínű — a kicsúfolás fájdalmas élmény.' },
            { emoji: '😢', felirat: 'Szomorú, magányos', helyes: true, magyarazat: 'HELYES! A zaklatás gyakran szomorúságot és magányt okoz.' },
            { emoji: '😴', felirat: 'Fáradt', helyes: false, magyarazat: 'Ez nem jellemző érzelmi reakció zaklatásra.' },
            { emoji: '😎', felirat: 'Magabiztos', helyes: false, magyarazat: 'A zaklatás inkább aláássa, mint erősíti a magabiztosságot.' },
          ]},
          { kerdes: 'Ha egy privát üzenetben azt írod valakinek, akit zaklatnak, hogy "nem vagy egyedül, itt vagyok neked" — ő valószínűleg így érzi magát:', opciok: [
            { emoji: '😌', felirat: 'Megkönnyebbült, támogatva érzi magát', helyes: true, magyarazat: 'HELYES! A támogatás hatalmas segítség egy nehéz helyzetben.' },
            { emoji: '😠', felirat: 'Dühös rád', helyes: false, magyarazat: 'Nem valószínű — a támogatás jó érzést kelt.' },
            { emoji: '😐', felirat: 'Semleges, nem érdekli', helyes: false, magyarazat: 'A támogatás szinte mindig számít valakinek.' },
          ]},
          { kerdes: 'Te magad hogyan érezheted magad, ha kiállsz valaki mellett, akit zaklatnak?', opciok: [
            { emoji: '💪', felirat: 'Büszke, hogy segítettél', helyes: true, magyarazat: 'HELYES! A segítségnyújtás jó érzést és büszkeséget ad!' },
            { emoji: '😢', felirat: 'Szomorú, hogy segítettél', helyes: false, magyarazat: 'A segítségnyújtás inkább pozitív érzést kelt.' },
            { emoji: '😴', felirat: 'Semmit nem érzek', helyes: false, magyarazat: 'A segítségnyújtás általában erős, pozitív érzelmet vált ki.' },
          ]},
        ],
        jegyzet: '❤️ Miért fontos felismerni mások (és a saját) érzéseit?\n\nHa felismered, mit érezhet valaki, aki zaklatást szenved el, sokkal nagyobb eséllyel nyújtasz neki támogatást — ahelyett hogy csak szemlélő maradnál. És az is fontos tudni: TE magad is jól érzed majd magad, ha segítesz valakin!'
      },
      {
        id: 'k3_3', tipus: 'boss_fight',
        cim: '⚡ Gyors döntés: segítenél?',
        kerdesek: [
          { kerdes: 'Valakit csúfolnak a csoportban. Segítesz neki privát üzenettel?', opciok: [{ szoveg: 'Igen', helyes: true }, { szoveg: 'Nem', helyes: false }] },
          { kerdes: 'Zaklatnak. Visszaírsz csúnyán?', opciok: [{ szoveg: 'Igen', helyes: false }, { szoveg: 'Nem', helyes: true }] },
          { kerdes: 'Bajban vagy. Szólsz egy megbízható felnőttnek?', opciok: [{ szoveg: 'Igen', helyes: true }, { szoveg: 'Nem', helyes: false }] },
          { kerdes: 'Zaklató üzenetet kapsz. Mented bizonyítékként?', opciok: [{ szoveg: 'Igen', helyes: true }, { szoveg: 'Nem', helyes: false }] },
          { kerdes: 'Valakit csúfolnak. Te is csatlakozol a nevetéshez?', opciok: [{ szoveg: 'Igen', helyes: false }, { szoveg: 'Nem', helyes: true }] },
          { kerdes: 'Rosszul esik valami online. Elég ok, hogy szólj?', opciok: [{ szoveg: 'Igen', helyes: true }, { szoveg: 'Nem', helyes: false }] },
          { kerdes: 'Egyedül próbálod megoldani, mert "nem elég komoly"?', opciok: [{ szoveg: 'Igen', helyes: false }, { szoveg: 'Nem', helyes: true }] },
        ],
        jegyzet: '⚡ Az ösztöneid már jól be vannak állítva!\n\nEz a gyors játék pontosan úgy működik, mint a valóság: nincs sok időd gondolkodni, amikor valaki bánt téged vagy mást online. Ha ezeket a döntéseket gyorsan, helyesen hoztad meg, az azt jelenti, hogy tényleg érted a lényeget!'
      },
      {
        id: 'k3_4', tipus: 'kepregeny',
        cim: '📖 Képregény',
        panelek: [
          { illusztracio: '😊📱', szoveg: 'Zoli örül, mert bekerült egy új osztályos csoportba a telefonján.' },
          { illusztracio: '😟💬', szoveg: 'Néhány nap múlva valaki elkezdi csúfolni a csoportban, mindenki előtt.' },
          { illusztracio: '🤔', szoveg: 'Zolinak döntenie kell: mi legyen a következő lépés?',
            opciok: [
              { szoveg: 'Visszacsúfolja őt is', helyes: false, magyarazat: 'ROSSZ! Ez csak rontana a helyzeten!' },
              { szoveg: 'Screenshotot csinál, majd szól a szüleinek', helyes: true, magyarazat: 'HELYES! Ez a helyes, bátor lépés!' },
            ]},
          { illusztracio: '💪🛡️', szoveg: 'Zoli szülei segítenek: jelentik az esetet, és a csúfolódás megszűnik. Zoli büszke, hogy szólt!' },
        ],
        jegyzet: '📖 A bátorság nem a hallgatásban van\n\nSokan azt hiszik, "kibírni" a zaklatást bátorság. Valójában a valódi bátorság a SEGÍTSÉGKÉRÉSBEN van — ez az, ami tényleg megoldja a helyzetet, nem a csendben szenvedés.'
      },
      {
        id: 'k3_5', tipus: 'kartyafordito',
        cim: '🃏 Jó vagy rossz döntés',
        kartyak: [
          { szoveg: 'Valaki bántó kommentet ír — visszaírsz ugyanolyan csúnyán', jo: false, magyarazat: '🚨 Rossz döntés! Ez csak eszkalálja a konfliktust.' },
          { szoveg: 'Látod, hogy valakit csúfolnak — privátban írsz neki támogatást', jo: true, magyarazat: '✅ Jó döntés! A privát támogatás sokat segít.' },
          { szoveg: 'Kapsz egy fenyegető üzenetet — mented bizonyítékként, majd szólsz felnőttnek', jo: true, magyarazat: '✅ Jó döntés! Ez a helyes protokoll.' },
          { szoveg: 'Egy csoportban csúfolják a padtársadat — te is csatlakozol a nevetéshez', jo: false, magyarazat: '🚨 Rossz döntés! Ezzel te is részt veszel a zaklatásban.' },
          { szoveg: 'Zaklatnak, de nem szólsz senkinek, mert "nem elég komoly"', jo: false, magyarazat: '🚨 Rossz döntés! Bármilyen rosszul eső dolog elég ok a segítségkérésre.' },
        ],
        jegyzet: '🃏 A jó döntések közös vonása\n\nA jó döntéseknél mindig van egy közös elem: vagy TÁMOGATÁST nyújtanak, vagy FELNŐTTET vonnak be. A rossz döntéseknél vagy eszkalálják a helyzetet, vagy elhallgatják — egyik sem old meg semmit!'
      },
    ],
  },
  {
    id: 4, cim: 'Digitális lábnyom', ikon: '👣', szin: '#0d47a1',
    leiras: 'Minden amit az interneten csinálsz, nyomot hagy - örökre!',
    konyv: {
      cim: 'Az internet nem felejt',
      oldalak: [
        { szoveg: 'A digitális lábnyom: minden amit az interneten csinálsz, nyomot hagy. Egy poszt, egy komment, egy feltöltött kép - mindez megmaradhat évekig, évtizedekig!', ikon: '👣', illusztracio: '👣🌐', haatter: 'linear-gradient(135deg, #e3f2fd, #e8eaf6)' },
        { szoveg: 'Kétféle digitális lábnyom van: aktív (amit te töltöttél fel) és passzív (amit mások gyűjtenek rólad - keresési előzmények, kattintások, helyadatok).', ikon: '📊', illusztracio: '📊👤', haatter: 'linear-gradient(135deg, #e8f5e9, #e3f2fd)' },
        { szoveg: 'Az internet nem felejt! Ha feltöltesz valamit azt screenshotolhatják, továbboszthatják. Még ha törölöd is - már lehet hogy valaki elmentette!', ikon: '⚠️', illusztracio: '⚠️💾', haatter: 'linear-gradient(135deg, #fff8e1, #fce4ec)' },
        { szoveg: 'Mielőtt posztolsz kérdezd meg magadtól: "Megmutatnám ezt a tanárnak? A szüleimnek? 10 év múlva is vállalnám?" Ha bármelyikre nem - ne töltsd fel!', ikon: '🤔', illusztracio: '🤔💡', haatter: 'linear-gradient(135deg, #f3e5f5, #e3f2fd)' },
        { szoveg: 'Az adatvédelem: a közösségi oldalak adatokat gyűjtenek rólad. Olvasd el az adatvédelmi beállításokat, állítsd privátba a profilod!', ikon: '🔒', illusztracio: '🔒⚙️', haatter: 'linear-gradient(135deg, #e3f2fd, #e8f5e9)', szabaly: 'Gondolkodj mielőtt posztolsz! A digitális lábnyomok örökre ott maradhatnak! 👣' },
      ],
    },
    feladatok: [
      {
        id: 'k4_1', tipus: 'labnyom_terkep',
        cim: '👣 Lábnyom térkép',
        kerdes: 'Kattints mindenre, ami digitális lábnyomot hagy!',
        elemek: [
          { szoveg: 'Fotó feltöltése', cel: true },
          { szoveg: 'Szoba, egyedül', cel: false },
          { szoveg: 'Google keresés', cel: true },
          { szoveg: 'Komment írás', cel: true },
          { szoveg: 'Séta telefon nélkül', cel: false },
          { szoveg: 'App letöltés', cel: true },
          { szoveg: 'Videó megnézése', cel: true },
          { szoveg: 'Alvás', cel: false },
          { szoveg: 'Poszt kedvelése (like)', cel: true },
          { szoveg: 'Olvasás papírkönyvből', cel: false },
        ],
        jegyzet: '👣 Aktív vs. passzív digitális lábnyom\n\nAz AKTÍV lábnyom az, amit TUDATOSAN töltesz fel (poszt, komment, fotó). A PASSZÍV lábnyom az, amit mások gyűjtenek rólad, gyakran anélkül, hogy észrevennéd — keresési előzmények, kattintások, helyadatok.'
      },
      {
        id: 'k4_2', tipus: 'posztolnad',
        cim: '📸 Posztolnád?',
        posztok: [
          { emoji: '😊', leiras: 'Vicces mém barátokról, mindenki engedélyével', helyes: 'like', magyarazat: '✅ Engedéllyel készült, ártatlan tartalom — nyugodtan posztolható!' },
          { emoji: '📸', leiras: 'Osztálytárs kínos fotója, engedély nélkül', helyes: 'kuka', magyarazat: '🚨 Engedély nélkül mások fotóját megosztani jogsértő is lehet!' },
          { emoji: '🏠', leiras: 'Otthonod, ami mutatja a pontos utcát, házszámot', helyes: 'kuka', magyarazat: '🚨 Ez elárulja, hol laksz!' },
          { emoji: '🏆', leiras: 'Saját sporteredményed', helyes: 'like', magyarazat: '✅ Ártatlan, személyes siker — bátran megoszthatod!' },
          { emoji: '😤', leiras: 'Dühös poszt valaki ellen, névvel', helyes: 'kuka', magyarazat: '🚨 Ez rágalmazásnak is minősülhet, és bántó!' },
          { emoji: '🎨', leiras: 'Saját rajzod vagy alkotásod', helyes: 'like', magyarazat: '✅ Kreatív, személyes tartalom — nyugodtan megoszthatod!' },
          { emoji: '📍', leiras: 'Élő helyzeted egy sztoriban, valós időben', helyes: 'kuka', magyarazat: '🚨 Elárulja, hol vagy éppen — kockázatos!' },
          { emoji: '🐶', leiras: 'Kedvenc állatod fotója', helyes: 'like', magyarazat: '✅ Ártatlan, személyes tartalom!' },
        ],
        jegyzet: '⚖️ A képjog - mások fotóját nem szabad engedély nélkül megosztani!\n\nMagyarországon (és az EU-ban) jogilag tilos valaki képét engedélye nélkül nyilvánosságra hozni - különösen kínos vagy bántó kontextusban.'
      },
      {
        id: 'k4_3', tipus: 'idoutazas',
        cim: '🔮 Időutazás',
        korok: [
          { kerdes: 'Le akarsz tölteni egy videót, ahol viccesen csúnyán beszélsz valakiről az osztályból. Mit gondolsz erről 5 év múlva?',
            valaszok: [
              { szoveg: '🤷 Nem gondolkodom rajta, feltöltöm, mert most vicces', helyes: false, magyarazat: 'ROSSZ! Ami most viccesnek tűnik, 5 év múlva kínos vagy bántó lehet!' },
              { szoveg: '🔮 Elképzelem, ki láthatja 5 év múlva, és csak akkor töltöm fel, ha azzal is jól érzem magam', helyes: true, magyarazat: 'HELYES! Ez a "jövőbeli én" teszt — mindig segít dönteni!' },
              { szoveg: '😅 Feltöltöm, majd törlöm, ha valaki szól', helyes: false, magyarazat: 'ROSSZ! Mire törölnéd, már lehet, hogy elmentették vagy megosztották!' },
            ]},
          { kerdes: 'Egy dühös, csúnya kommentet írnál valaki posztja alá, mert most éppen ideges vagy rá. Mit gondolsz erről 5 év múlva?',
            valaszok: [
              { szoveg: '🔮 Végiggondolom, hogy egy jövőbeli munkaadóm is láthatja majd — inkább nem írom meg', helyes: true, magyarazat: 'HELYES! A dühös kommentek évekig megmaradhatnak!' },
              { szoveg: '😤 Megírom, mert most így érzek', helyes: false, magyarazat: 'ROSSZ! A pillanatnyi harag maradandó nyomot hagyhat!' },
              { szoveg: '🤔 Megírom, majd holnap törlöm', helyes: false, magyarazat: 'ROSSZ! Mások láthatják és screenshotolhatják, mielőtt törölnéd!' },
            ]},
          { kerdes: 'Egy fotót akarsz posztolni magadról egy bulin, amin kicsit "félrement" a helyzet. Mit gondolsz erről 5 év múlva?',
            valaszok: [
              { szoveg: '🔮 Elgondolkodom: örülnék-e, ha ezt egy jövőbeli iskola vagy munkahely is látná? Ha nem, nem posztolom', helyes: true, magyarazat: 'HELYES! A jövőbeli én teszt itt is segít!' },
              { szoveg: '📸 Posztolom, mert vicces pillanat volt', helyes: false, magyarazat: 'ROSSZ! Amit most viccesnek gondolsz, később kínos lehet!' },
              { szoveg: '🙈 Csak a "sztorimba" teszem, az úgyis eltűnik', helyes: false, magyarazat: 'ROSSZ! Bárki screenshotolhatja, mielőtt eltűnne!' },
            ]},
          { kerdes: 'Egy régi posztod van, amiben 2 évvel ezelőtt kiírtad a teljes napirended és a suli nevét. Mit gondolsz erről most?',
            valaszok: [
              { szoveg: '🔮 Átnézem és törlöm, mert most már tudom, hogy ez veszélyes lehetett', helyes: true, magyarazat: 'HELYES! Sosem késő javítani a régi hibákon!' },
              { szoveg: '🤷 Hagyom, hiszen már rég feltöltöttem', helyes: false, magyarazat: 'ROSSZ! A régi, veszélyes adat ugyanolyan veszélyes marad!' },
              { szoveg: '😅 Csak akkor törlöm, ha valaki szól', helyes: false, magyarazat: 'JOBB, ha proaktívan magad nézed át időnként a régi posztjaidat!' },
            ]},
        ],
        jegyzet: '🔮 A "jövőbeli én" teszt\n\nMielőtt posztolsz valamit, kérdezd meg magadtól: "Örülnék neki, ha ezt 5 év múlva egy tanárom, egy jövőbeli munkaadóm, vagy a szüleim látnák?" Ha a válasz nem egyértelmű igen, jobb, ha nem töltöd fel.'
      },
      {
        id: 'k4_4', tipus: 'digitalis_takaritas',
        cim: '🧹 Digitális takarítás',
        kerdes: 'Húzd a kukába, amit törölnél vagy átállítanál a profilodon!',
        elemek: [
          { emoji: '📍', szoveg: 'Élő helymeghatározás', torlendo: true },
          { emoji: '🎨', szoveg: 'Saját rajzok', torlendo: false },
          { emoji: '🖼️', szoveg: 'Kínos fotó engedély nélkül', torlendo: true },
          { emoji: '⚽', szoveg: 'Kedvenc sport említése', torlendo: false },
          { emoji: '👤', szoveg: 'Ismeretlen "ismerősök"', torlendo: true },
          { emoji: '😤', szoveg: 'Régi dühös komment', torlendo: true },
          { emoji: '🎵', szoveg: 'Kedvenc zene megosztása', torlendo: false },
          { emoji: '📞', szoveg: 'Telefonszám a profilban', torlendo: true },
        ],
        visszajelzes_jo: 'Pontosan! Tudatosan takarítottad a profilodat! 🧹',
        visszajelzes_rossz: 'Gondold át! Mi az, ami veszélyt jelenthet, ha bent marad?',
        jegyzet: '🧹 Az évente egyszeri "digitális nagytakarítás"\n\nAhogy a szobádat is időnként rendbe teszed, a digitális jelenlétedet is érdemes évente átnézni. Ez egy egészséges szokás, amit érdemes felnőttként is folytatni!'
      },
      {
        id: 'k4_5', tipus: 'labnyom_analizator',
        cim: '📊 Lábnyom Elemző',
        helyzetek: [
          { szoveg: 'Feltöltesz egy fotót az élő helyzeteddel egy sztoriban.', opciok: [
            { szoveg: '📍 Megosztom, mindegy', hatas: 20 },
            { szoveg: '🚫 Nem osztom meg élőben', hatas: -10 },
          ]},
          { szoveg: 'Egy nyilvános profilt vagy privátra állítasz be?', opciok: [
            { szoveg: '🌍 Nyilvános marad', hatas: 20 },
            { szoveg: '🔒 Privátra állítom', hatas: -15 },
          ]},
          { szoveg: 'Egy kínos fotót töltenél fel valakiről engedély nélkül.', opciok: [
            { szoveg: '📸 Feltöltöm, vicces', hatas: 25 },
            { szoveg: '🙅 Nem, megkérdezem előbb', hatas: -15 },
          ]},
          { szoveg: 'Régi posztjaidat évente átnézed és rendet raksz?', opciok: [
            { szoveg: '🤷 Soha nem nézem át', hatas: 15 },
            { szoveg: '🧹 Igen, évente átnézem', hatas: -20 },
          ]},
          { szoveg: 'Ismeretlen "ismerősöket" fogadsz el a profilodon?', opciok: [
            { szoveg: '👤 Igen, mindegy ki az', hatas: 20 },
            { szoveg: '🚫 Csak akiket ismerek valóban', hatas: -15 },
          ]},
        ],
        jegyzet: '📊 A lábnyom-mérő üzenete\n\nMinél TÖBB adatot osztasz meg tudatlanul (élő helyzet, nyilvános profil, mások engedély nélküli fotói, ismeretlenek elfogadása), annál NAGYOBB a digitális lábnyomod, és annál sebezhetőbb vagy. A tudatos döntések (privát profil, rendszeres átnézés, engedélykérés) kicsivé és biztonságossá teszik a lábnyomodat!'
      },
    ],
  },
  {
    id: 5, cim: 'Biztonságos gaming', ikon: '🎮', szin: '#1565c0',
    leiras: 'Online játékok, in-game vásárlások és gaming közösségek!',
    konyv: {
      cim: 'A gaming világ árnyoldalai',
      oldalak: [
        { szoveg: 'Az online játékok fantasztikusak - de vannak veszélyei! A gaming közösségekben idegenekkel kerülsz kapcsolatba akikről nem tudod kik valójában!', ikon: '🎮', illusztracio: '🎮⚠️', haatter: 'linear-gradient(135deg, #e3f2fd, #e8f5e9)' },
        { szoveg: 'A gaming csapdák: "Ingyenes skin"-ek amelyek jelszót kérnek, "Admin"-ok akik fiókadatokat kérnek, "Pro coach"-ok akik személyes találkozót ajánlanak.', ikon: '🕵️', illusztracio: '🕵️🎮', haatter: 'linear-gradient(135deg, #fff8e1, #e3f2fd)' },
        { szoveg: 'Az in-game vásárlások VALÓDI pénzbe kerülnek! A szülők engedélye kötelező! A loot box-ok és véletlenszerű nyeremények pszichológiailag addiktívak lehetnek!', ikon: '💰', illusztracio: '💰⚠️', haatter: 'linear-gradient(135deg, #fce4ec, #e3f2fd)' },
        { szoveg: 'A gaming identitás: a nicknévedből ne derüljenek ki személyes adataid. "PeterBudapest2012" helyett legyen "DragonSlayer_99". Soha ne add meg a valódi neved!', ikon: '🎭', illusztracio: '🎭🛡️', haatter: 'linear-gradient(135deg, #e8f5e9, #e3f2fd)' },
        { szoveg: 'A gaming toxicitás: a csapat kommunikációban előfordulhat bántás, rasszizmus, zaklatás. Soha ne toleráld! Blokkold, jelents, és ne adj nekik "ingyenes slotot az agyadban"!', ikon: '🛡️', illusztracio: '🛡️💪', haatter: 'linear-gradient(135deg, #e3f2fd, #f3e5f5)', szabaly: 'A gaming névből ne derüljenek ki adataid! Soha ne adj pénzt vagy jelszót gaming ismerősnek! 🎮' },
      ],
    },
    feladatok: [
      {
        id: 'k5_1', tipus: 'gamer_chat',
        cim: '🎮 Gamer szoba',
        kerdes: 'Kattints a veszélyes üzenetekre a gamer chatben!',
        uzenetek: [
          { nev: 'ProGamer_22', avatar: '🎮', uzenet: 'Adok neked 1000 V-bucksot, ha megadod a fiókadataidat!', gyanús: true, magyarazat: '🚨 Klasszikus fióklopási kísérlet!' },
          { nev: 'PixelWolf', avatar: '🐺', uzenet: 'Hé, melyik pályán vagy? Csatlakozom!', gyanús: false, magyarazat: 'Ez normális játékos kérdés.' },
          { nev: 'AdminHelper99', avatar: '🛡️', uzenet: 'Én az Admin vagyok, add meg a jelszavadat ellenőrzéshez!', gyanús: true, magyarazat: '🚨 A valódi adminok soha nem kérik a jelszót!' },
          { nev: 'SkinMaster', avatar: '🦊', uzenet: 'Találkozzunk személyesen, én egy profi gamer vagyok!', gyanús: true, magyarazat: '🚨 Soha ne találkozz gaming ismerőssel személyesen!' },
          { nev: 'PixelWolf', avatar: '🐺', uzenet: 'Melyik karaktert használod ma este?', gyanús: false, magyarazat: 'Ez normális játékos kérdés.' },
          { nev: 'FreeVBucks_x', avatar: '💎', uzenet: 'Küldj pénzt és ingyen szintet adok a Fortnite-ban!', gyanús: true, magyarazat: '🚨 A valódi jutalmakhoz nem kell pénz!' },
          { nev: 'TeamCaptain', avatar: '⭐', uzenet: 'Szuper meccs volt srácok, gratulálok mindenkinek!', gyanús: false, magyarazat: 'Barátságos, normális csapat-üzenet.' },
        ],
        jegyzet: '🎮 A "grooming" veszélye online játékokban\n\nA "grooming" azt jelenti, amikor egy felnőtt fokozatosan közelebb kerül egy gyerekhez az interneten — általában gaming platformokon. Tipikus jelek: gyors "legjobb barát" közeledés, ajándékok, titoktartás kérése, személyes találkozó ajánlása. Ha bármelyiket tapasztalod: azonnal szólj egy felnőttnek!'
      },
      {
        id: 'k5_2', tipus: 'ingame_bolt',
        cim: '🛒 In-game bolt',
        kerdes: 'Mit vennél meg — melyik ajánlatok biztonságosak?',
        termekek: [
          { emoji: '⚔️', nev: 'Karakter-skin', ar: '500 Ft', helyes: true, magyarazat: '✅ Normál, szülői engedéllyel vásárolható tétel.' },
          { emoji: '💎', nev: '"5000 gyémánt, csak 10 percig!"', ar: 'félár', helyes: false, magyarazat: '🚨 Mesterséges időnyomás — gondolkodás nélküli vásárlásra ösztönöz!' },
          { emoji: '🎁', nev: 'Loot box (véletlen jutalom)', ar: '1000 Ft', helyes: false, magyarazat: '🚨 Véletlenszerű jutalom pénzért — ez szerencsejáték-szerű mechanika!' },
          { emoji: '🎫', nev: 'Szezonbérlet', ar: '2000 Ft', helyes: true, magyarazat: '✅ Átlátható, fix tartalmú vásárlás — szülői engedéllyel rendben.' },
          { emoji: '🏆', nev: 'Extra pálya-csomag', ar: '800 Ft', helyes: true, magyarazat: '✅ Egyértelmű, fix tartalom — szülői engedéllyel rendben.' },
          { emoji: '🍀', nev: '"Szerencsés láda — 90% esély ritka tárgyra!"', ar: '1500 Ft', helyes: false, magyarazat: '🚨 Kétes "esély"-ígéret, valójában szerencsejáték!' },
          { emoji: '🖌️', nev: 'Egyedi karakter-testreszabás', ar: '600 Ft', helyes: true, magyarazat: '✅ Átlátható, fix tartalom — szülői engedéllyel rendben.' },
          { emoji: '⏰', nev: '"Utolsó esély, csak 5 perc, kattints most!"', ar: '2500 Ft', helyes: false, magyarazat: '🚨 Extrém időnyomás — soha ne dönts kapkodva vásárlásnál!' },
        ],
        visszajelzes_jo: 'Pontosan! Az átlátható, nyomás nélküli ajánlatok a biztonságosak! 🛒',
        visszajelzes_rossz: 'Gondold át! Melyik ajánlat próbál sietségre vagy szerencsére építeni?',
        jegyzet: '💳 Miért olyan hatásosak a "csak most" ajánlatok?\n\nA játékfejlesztők tudatosan használnak időnyomást és véletlenszerű jutalmakat (loot box), hogy gyors, átgondolatlan vásárlásra ösztönözzenek. A szabály egyszerű: minden fizetős vásárlás csak szülői engedéllyel és jelenléttel történhet!'
      },
      {
        id: 'k5_3', tipus: 'celbalovo',
        cim: '🎯 Célbalövő',
        kerdes: 'Csak a VESZÉLYES lufikat lődd ki — a biztonságosakat hagyd repülni!',
        lufik: [
          { szoveg: 'Ingyen V-Bucks!', veszelyes: true },
          { szoveg: 'Jó meccs volt!', veszelyes: false },
          { szoveg: 'Add meg a jelszavad', veszelyes: true },
          { szoveg: 'Melyik pályán vagy?', veszelyes: false },
          { szoveg: 'Klikkelj ide gyorsan!', veszelyes: true },
          { szoveg: 'Csináljunk klánt!', veszelyes: false },
          { szoveg: 'Add meg a telefonszámod', veszelyes: true },
          { szoveg: 'Szuper stratégia volt!', veszelyes: false },
        ],
        jegyzet: '🎯 A gaming-csalások közös jellemzője\n\nA gaming csalók szinte mindig valamilyen "ingyen" ajánlattal vagy sietséggel jönnek, cserébe a fiókadataidért vagy pénzért. Ha valaki túl jó ajánlatot tesz, és cserébe adatot vagy pénzt kér — az szinte biztosan átverés!'
      },
      {
        id: 'k5_4', tipus: 'memoria',
        cim: '🧠 Gaming memória',
        parok: [
          { a: '🔐 Erős gamer jelszó', b: '12+ karakter, jelek, számok' },
          { a: '🚫 Fiók megosztása', b: 'Soha, még ismerőssel sem' },
          { a: '💰 Loot box', b: 'Véletlenszerű, fizetős jutalom' },
          { a: '🎭 Jó nickname', b: 'Kitalált, nem a valódi neved' },
          { a: '👨‍👩‍👧 Vásárlás előtt', b: 'Mindig szülői engedély' },
          { a: '🚩 Személyes találkozó', b: 'Soha online ismerőssel' },
          { a: '🛑 Toxikus játékos', b: 'Blokkolás és bejelentés' },
          { a: '⏰ "Csak most!" ajánlat', b: 'Mesterséges időnyomás' },
        ],
        jegyzet: '🔐 Miért érdemes külön, erős jelszót adni a gaming fiókodnak?\n\nA gaming fiókok (Roblox, Fortnite, Minecraft) sokszor évek munkáját tartalmazzák — ritka skineket, elért szinteket, virtuális pénzt. Egy feltört fiókot a dark weben pénzért adnak-vesznek!'
      },
      {
        id: 'k5_5', tipus: 'szerencsekerek',
        cim: '🎡 Szerencsekerék: Gaming szabályok',
        kerdesek: [
          { kerdes: 'Mit tegyél, ha egy "admin" a jelszavadat kéri?', opciok: [
            { szoveg: 'Megadom, hiszen admin', helyes: false },
            { szoveg: 'Soha nem adom meg — a valódi adminok nem kérik!', helyes: true },
          ]},
          { kerdes: 'Mi legyen a gaming nicknevedben?', opciok: [
            { szoveg: 'A valódi neved és korod', helyes: false },
            { szoveg: 'Egy kitalált, semleges becenév', helyes: true },
          ]},
          { kerdes: 'Egy online ismerős találkozót javasol. Mit teszel?', opciok: [
            { szoveg: 'Elmegyek, hiszen régóta ismerem online', helyes: false },
            { szoveg: 'Visszautasítom, és szólok a szüleimnek', helyes: true },
          ]},
          { kerdes: 'Toxikus, csúnyán beszélő játékossal mit teszel?', opciok: [
            { szoveg: 'Visszaszólok neki ugyanolyan csúnyán', helyes: false },
            { szoveg: 'Blokkolom és jelentem', helyes: true },
          ]},
          { kerdes: 'Egy loot box "90% eséllyel" ritka tárgyat ígér. Ez valójában micsoda?', opciok: [
            { szoveg: 'Biztos, garantált nyeremény', helyes: false },
            { szoveg: 'Szerencsejáték-szerű mechanika', helyes: true },
          ]},
          { kerdes: 'Vásárolnál egy in-game tárgyat szülői engedély nélkül?', opciok: [
            { szoveg: 'Igen, ha van rajta kártyaadat mentve', helyes: false },
            { szoveg: 'Nem, mindig kell szülői engedély', helyes: true },
          ]},
          { kerdes: 'Egy ismeretlen küld egy linket "ingyen skinért". Mit teszel?', opciok: [
            { szoveg: 'Rákattintok, hátha igaz', helyes: false },
            { szoveg: 'Nem kattintok, gyanús', helyes: true },
          ]},
        ],
        jegyzet: '🎮 A biztonságos gamer aranyszabályai\n\n1️⃣ NICKNAME — soha ne legyen benne a valódi neved\n2️⃣ JELSZÓ — soha ne oszd meg, még "adminnal" sem\n3️⃣ TALÁLKOZÓ — online ismerőssel soha személyesen\n4️⃣ TOXICITÁS — blokkolás és bejelentés, ne reagálj!'
      },
    ],
  },
  {
    id: 6, cim: 'AI és a jövő', ikon: '🤖', szin: '#1976d2',
    leiras: 'Mesterséges intelligencia, deepfake és az AI felelős használata!',
    konyv: {
      cim: 'Az AI kora - lehetőségek és veszélyek',
      oldalak: [
        { szoveg: 'A mesterséges intelligencia (AI) hatalmas adatokból tanul és képes szövegeket írni, képeket generálni, hangokat utánozni - szinte megkülönböztethetetlenül az igazitól!', ikon: '🤖', illusztracio: '🤖✨', haatter: 'linear-gradient(135deg, #e3f2fd, #e8eaf6)' },
        { szoveg: 'A deepfake videó vagy hang, amely egy valódi személyt ábrázol, de amit soha nem mondott vagy csinált. Ma már szinte lehetetlen megkülönböztetni az igazitól!', ikon: '🎭', illusztracio: '🎭⚠️', haatter: 'linear-gradient(135deg, #fce4ec, #e3f2fd)' },
        { szoveg: 'Az AI-alapú csalások: hangutánzás ("anya bajban vagyok küldj pénzt!"), deepfake videók, AI-írt adathalász emailek amelyek személyre szabottak.', ikon: '⚠️', illusztracio: '⚠️🚨', haatter: 'linear-gradient(135deg, #fff8e1, #fce4ec)' },
        { szoveg: 'Az AI pozitív felhasználása: tanulási segítség, fordítás, kreatív alkotás, orvosi kutatás. Az AI egy eszköz - attól függ jó vagy rossz hogyan használják!', ikon: '💡', illusztracio: '💡🌟', haatter: 'linear-gradient(135deg, #e8f5e9, #e3f2fd)' },
        { szoveg: 'Az AI felelős használata: ne adj meg személyes adatokat AI chatbotoknak, ellenőrizd az AI által generált tartalmakat, légy kritikus!', ikon: '🧠', illusztracio: '🧠🤖', haatter: 'linear-gradient(135deg, #e3f2fd, #f3e5f5)', szabaly: 'Az AI eszköz - te döntöd el hogyan használod! Mindig ellenőrizz soha ne higgy vakon! 🤖' },
      ],
    },
    feladatok: [
      {
        id: 'k6_1', tipus: 'ai_vagy_ember',
        cim: '🤖 AI vagy ember?',
        kerdes: 'Koppints minden AI-generált képre!',
        kepek: [
          { tipus: 'kez6', leiras: 'Kéz, 6 ujjal', ai: true, magyarazat: 'Az AI gyakran rosszul generálja az ujjak számát!' },
          { tipus: 'termeszet', leiras: 'Hegyi táj, valódi fotó', ai: false, magyarazat: 'Természetes fényviszonyok, valódi textúrák.' },
          { tipus: 'szoveg_ai', leiras: 'Tökéletesen egyenletes, hibátlan szöveg', ai: true, magyarazat: 'Az AI-szöveg jellemzően "túl tökéletes"!' },
          { tipus: 'kutya', leiras: 'Kutya fotó, kertben', ai: false, magyarazat: 'Természetes háttér, valósághű árnyékok.' },
          { tipus: 'szoveg_ai', leiras: 'Kép, ahol a háttér-felirat olvashatatlanul elmosódik', ai: true, magyarazat: 'Az AI gyakran nem tud helyesen szöveget generálni!' },
          { tipus: 'naplemente', leiras: 'Naplemente fotó, barátoktól', ai: false, magyarazat: 'Valódi, természetes fényviszonyok.' },
        ],
        jegyzet: '🤖 A "6 ujj szindróma" és más AI-jelek\n\nAz AI-modellek a kezeket, ujjakat és apró szöveges részleteket még mindig nehezen generálják tökéletesen. Ha valami "majdnem tökéletesnek" tűnik, de van benne egy furcsa részlet — az gyanús lehet.'
      },
      {
        id: 'k6_2', tipus: 'digitalis_tukor',
        cim: '🎭 Deepfake felismerés',
        karakterNelkul: true,
        korok: [
          { kerdes: 'Egy videó-előnézetet látsz egy ismert emberről, aki valami döbbenetes dolgot mond. Mit teszel?',
            valaszok: [
              { szoveg: '🔍 Megnézem, hogy a szájmozgás passzol-e a hanghoz, és keresek más forrást is, mielőtt elhinném', helyes: true, magyarazat: 'HELYES! Mindig ellenőrizz, mielőtt elhiszel vagy megosztasz valami döbbenetes videót!' },
              { szoveg: '📤 Azonnal továbbküldöm, mert döbbenetes', helyes: false, magyarazat: 'ROSSZ! Lehet, hogy deepfake — ellenőrizd, mielőtt megosztod!' },
              { szoveg: '😱 Teljesen elhiszem, hiszen a saját szememmel látom', helyes: false, magyarazat: 'ROSSZ! A deepfake videók ma már nagyon meggyőzőek lehetnek!' },
            ]},
          { kerdes: 'Egy hangüzenetet kapsz, ami pontosan úgy hangzik, mint egy családtagod hangja, és pénzt kér. Mit teszel?',
            valaszok: [
              { szoveg: '📞 Visszahívom a családtagomat a saját, ismert számán, mielőtt bármit tennék', helyes: true, magyarazat: 'HELYES! Az AI ma már hangot is tud klónozni pár másodperces mintából!' },
              { szoveg: '💸 Azonnal küldöm a pénzt, hiszen felismerem a hangját', helyes: false, magyarazat: 'ROSSZ! A hang is hamisítható AI-val!' },
              { szoveg: '🤔 Visszaírok szöveges üzenetben, hogy megerősítse', helyes: false, magyarazat: 'ROSSZ! Az üzenet is jöhet a csalótól — hívd fel a saját, ismert számán!' },
            ]},
          { kerdes: 'Egy kép terjed a neten, ami egy ismert személyt mutat egy furcsa helyzetben. Mit teszel, mielőtt megosztod?',
            valaszok: [
              { szoveg: '🔍 Megkeresem, van-e róla hír megbízható híroldalon is', helyes: true, magyarazat: 'HELYES! Ha csak egy helyen van, az gyanús jel!' },
              { szoveg: '📤 Megosztom, mert érdekes és sokan látták már', helyes: false, magyarazat: 'ROSSZ! A "sokan látták" nem jelenti, hogy igaz!' },
              { szoveg: '😮 Kommentelek alá, hogy hihetetlen', helyes: false, magyarazat: 'JOBB, ha előbb ellenőrzöd, mielőtt reagálsz vagy megosztod!' },
            ]},
        ],
        jegyzet: '🎭 Miért nem elég, hogy "látod" vagy "hallod"?\n\nA modern AI-technológia szinte tökéletesen tudja utánozni valakinek az arcát és hangját. Az egyetlen védekezés a kritikus gondolkodás: nézd meg a részleteket, és mindig keress megerősítést más, megbízható forrásból vagy ismert csatornán (pl. visszahívás)!'
      },
      {
        id: 'k6_3', tipus: 'valogatо',
        cim: '🧠 AI segít? — kártyák rendezése',
        kerdes: 'Húzd a megfelelő helyre!',
        elemek: [
          { kep: '📚', felirat: 'AI segít megérteni egy tananyagot', kategoria: 'jo' },
          { kep: '📝', felirat: 'AI írja meg helyettem a dolgozatot', kategoria: 'rossz' },
          { kep: '🌍', felirat: 'AI segít fordítani egy szöveget', kategoria: 'jo' },
          { kep: '🎭', felirat: 'AI-val deepfake videót csinálok valakiről', kategoria: 'rossz' },
          { kep: '🎨', felirat: 'AI segít kreatív ötletek generálásában', kategoria: 'jo' },
          { kep: '🔑', felirat: 'Személyes adatokat adok meg AI chatbotnak', kategoria: 'rossz' },
          { kep: '💡', felirat: 'AI segít brainstormingban egy projekthez', kategoria: 'jo' },
          { kep: '🎯', felirat: 'AI-val csalok egy online teszten', kategoria: 'rossz' },
        ],
        kategoriak: [
          { id: 'jo', felirat: '✅ Okos AI-használat', szin: '#34a853' },
          { id: 'rossz', felirat: '🚨 Felelőtlen!', szin: '#ea4335' },
        ],
        visszajelzes_jo: 'Pontosan! Tudod hogyan kell felelősen AI-t használni! 🧠',
        visszajelzes_rossz: 'Gondold át! Mi a felelős AI használat?',
        jegyzet: '🎓 AI az iskolában - hol a határ?\n\n✅ MEGENGEDETT: Megértés segítése, ötletelés, fordítás, tervezés\n❌ NEM MEGENGEDETT: Teljes dolgozat megíratása, tesztre való csalizás\n\nAz AI az eszköz - te tanulsz vagy az AI? Ha az AI elvégzi helyetted a feladatot, te nem tanulod meg.'
      },
      {
        id: 'k6_4', tipus: 'prompt_epito',
        cim: '✍️ Prompt építő — csevegj a ChatGPT-vel!',
        korok: [
          { kerdes: 'Témád: TÖRTÉNELEM. Válogasd össze a szavakból egy JÓ, egyértelmű AI-utasítást!',
            kotelezoElemek: ['magyarazd', 'egyszeruen', 'tortenelem', 'pelda'],
            szavak: [
              { id: 'magyarazd', szo: 'Magyarázd el' },
              { id: 'egyszeruen', szo: 'egyszerűen,' },
              { id: 'tortenelem', szo: 'ahogy egy 10 évesnek,' },
              { id: 'pelda', szo: 'a francia forradalmat, egy példával.' },
              { id: 'zavaros', szo: 'valami' },
              { id: 'homalyos', szo: 'dolgot' },
            ],
            visszajelzes_jo: 'Szuper! Ez egy világos, jó prompt — pontosan tudja az AI, mit várunk tőle! ✍️',
            visszajelzes_rossz: 'Gondold át! Egy jó promptban van: mit kérünk, milyen szinten, és hogyan (pl. példával)!',
            aiValasz: 'A francia forradalom (1789) az volt, amikor a francia nép fellázadt a király ellen, mert éheztek és igazságtalannak érezték, hogy csak a gazdagoknak van joguk dönteni. Képzeld el, mintha az osztályod fellázadna, ha mindig csak néhány gyerek dönthetne mindenről!' },
          { kerdes: 'Témád: TERMÉSZETTUDOMÁNY. Válogasd össze a szavakból egy JÓ, egyértelmű AI-utasítást!',
            kotelezoElemek: ['sorold', 'roviden', 'foto', 'okok'],
            szavak: [
              { id: 'sorold', szo: 'Sorold fel' },
              { id: 'roviden', szo: 'röviden,' },
              { id: 'foto', szo: 'listaszerűen,' },
              { id: 'okok', szo: 'miért fontos a fotoszintézis a növényeknek.' },
              { id: 'zavaros2', szo: 'izé' },
              { id: 'homalyos2', szo: 'akármi' },
            ],
            visszajelzes_jo: 'Pontosan! Ez is egy világos, jól felépített prompt! ✍️',
            visszajelzes_rossz: 'Gondold át! Mit kérünk, milyen formában, és milyen témáról?',
            aiValasz: '1. Ez adja a növény energiáját\n2. Ez termeli az oxigént, amit belélegzünk\n3. Ez segít a növénynek növekedni\n4. Ez az alapja szinte minden élelemnek a Földön' },
          { kerdes: 'Témád: FÖLDRAJZ. Válogasd össze a szavakból egy JÓ, egyértelmű AI-utasítást!',
            kotelezoElemek: ['mesld', 'kepszeruen', 'hegy', 'kerdessel'],
            szavak: [
              { id: 'mesld', szo: 'Meséld el' },
              { id: 'kepszeruen', szo: 'képszerűen,' },
              { id: 'hegy', szo: 'hogyan keletkeznek a hegyek,' },
              { id: 'kerdessel', szo: 'és tégy fel egy gondolkodtató kérdést a végén.' },
              { id: 'zavaros3', szo: 'hát' },
              { id: 'homalyos3', szo: 'amit tudsz' },
            ],
            visszajelzes_jo: 'Kiváló! Ez egy nagyon jól megfogalmazott, kreatív prompt! ✍️',
            visszajelzes_rossz: 'Gondold át! Mit kérünk pontosan, milyen stílusban, és mi legyen a vége?',
            aiValasz: 'A hegyek úgy keletkeznek, mint amikor két szőnyeget egymás felé tolsz az asztalon — a föld lemezei összenyomódnak, és felgyűrődnek! Vajon szerinted mi történne, ha a Föld lemezei soha nem mozognának?' },
        ],
        jegyzet: '✍️ Mitől jó egy AI-prompt?\n\nEgy jó, világos utasítás megmondja: 1) MIT szeretnél (pl. magyarázatot vagy felsorolást), 2) MILYEN FORMÁBAN (pl. egyszerűen, listaszerűen), 3) MIRŐL PONTOSAN. Minél pontosabb a kérésed, annál hasznosabb választ kapsz — ez ugyanúgy igaz emberi kommunikációban is!'
      },
      {
        id: 'k6_5', tipus: 'ai_labirintus',
        cim: '🌀 AI labirintus',
        kerdesek: [
          { kerdes: 'Az AI mindig pontos és megbízható információt ad?', opciok: [
            { szoveg: 'Igen, mindig hihetsz neki', helyes: false, magyarazat: 'ROSSZ! Az AI "hallucination"-t is produkál — időnként kitalál dolgokat!' },
            { szoveg: 'Nem, mindig ellenőrizni kell', helyes: true, magyarazat: 'HELYES! Az AI állításait mindig érdemes ellenőrizni megbízható forrásból!' },
          ]},
          { kerdes: 'Biztonságos-e megadni a személyes adataidat egy AI chatbotnak?', opciok: [
            { szoveg: 'Igen, az AI biztonságosan kezeli', helyes: false, magyarazat: 'ROSSZ! Nem tudhatod biztosan, mit csinál a rendszer az adataiddal!' },
            { szoveg: 'Nem, soha ne add meg', helyes: true, magyarazat: 'HELYES! Az AI chatbotoknak sem szabad személyes adatot megadni!' },
          ]},
          { kerdes: 'Ha egy AI-generált kép "majdnem tökéletesnek" tűnik, mit tegyél?', opciok: [
            { szoveg: 'Elhiszem, hiszen jól néz ki', helyes: false, magyarazat: 'ROSSZ! Nézd meg alaposan a részleteket (kéz, háttér, szöveg)!' },
            { szoveg: 'Megvizsgálom a részleteket, mielőtt elhiszem', helyes: true, magyarazat: 'HELYES! A kritikus gondolkodás mindig segít!' },
          ]},
          { kerdes: 'Egy AI megírja helyetted a teljes házi dolgozatot. Ez rendben van?', opciok: [
            { szoveg: 'Igen, gyorsabb így', helyes: false, magyarazat: 'ROSSZ! Így nem tanulod meg az anyagot!' },
            { szoveg: 'Nem, ez nem felelős AI-használat', helyes: true, magyarazat: 'HELYES! Az AI segíthet, de nem helyettesítheti a saját munkát!' },
          ]},
          { kerdes: 'Egy AI-hang pontosan úgy szól, mint egy családtagod, és pénzt kér. Mit teszel?', opciok: [
            { szoveg: 'Elhiszem és küldöm a pénzt', helyes: false, magyarazat: 'ROSSZ! Ez lehet AI-hangklónozás átveréshez!' },
            { szoveg: 'Visszahívom a saját, ismert számán', helyes: true, magyarazat: 'HELYES! A visszahívás az egyetlen biztos ellenőrzés!' },
          ]},
          { kerdes: 'Egy AI-chatbot azt állítja, hogy "hivatalos rendőrségi asszisztens". Elhiszed?', opciok: [
            { szoveg: 'Igen, hiszen ezt mondja magáról', helyes: false, magyarazat: 'ROSSZ! Bárki bármit állíthat egy chatbot "névjegyében"!' },
            { szoveg: 'Nem, ellenőrzöm hivatalos forrásból', helyes: true, magyarazat: 'HELYES! Soha ne higgy vakon egy AI önmeghatározásának!' },
          ]},
          { kerdes: 'Használhatsz AI-t arra, hogy segítsen megérteni egy nehéz házi feladatot?', opciok: [
            { szoveg: 'Igen, ez felelős, okos használat', helyes: true, magyarazat: 'HELYES! A megértés segítése kiváló AI-használat!' },
            { szoveg: 'Nem, az AI-t soha nem szabad használni tanuláshoz', helyes: false, magyarazat: 'ROSSZ! Az AI remek segítő tud lenni, ha felelősen használod!' },
          ]},
          { kerdes: 'Egy AI-videó azt mutatja, hogy egy politikus valami elképesztőt mond. Mit teszel, mielőtt megosztod?', opciok: [
            { szoveg: 'Azonnal megosztom, mert fontos hír', helyes: false, magyarazat: 'ROSSZ! Ellenőrzés nélkül könnyen álhírt terjesztesz!' },
            { szoveg: 'Ellenőrzöm megbízható híroldalakon, mielőtt bármit teszek', helyes: true, magyarazat: 'HELYES! Mindig ellenőrizz, mielőtt hiszel vagy megosztasz!' },
          ]},
        ],
        jegyzet: '🌀 Kiértél a labirintusból!\n\nAz AI egyre fejlettebb lesz, és egyre nehezebb lesz megkülönböztetni a valóditól. A kritikus gondolkodás, az ellenőrzés és az adatvédelem tudatossága a legjobb "térkép", amivel bármilyen AI-labirintusból ki tudsz jutni!'
      },
    ],
  },
  {
    id: 7, cim: 'Agent X záróvizsga', ikon: '🏅', szin: '#0d47a1',
    leiras: 'Teljesítsd a záróvizsgát és szerezd meg a Digitális Őr rangot!',
    konyv: {
      cim: 'Az Agent X eskütétele',
      oldalak: [
        { szoveg: 'Gratulálok! Elvégezted mind a 6 küldetést! Most jön a záróvizsga ahol mindent bizonyíthatsz amit tanultál!', ikon: '🏅', illusztracio: '🏅✨', haatter: 'linear-gradient(135deg, #e3f2fd, #e8eaf6)' },
        { szoveg: 'A Digitális Őr tudja: hogyan védje az adatait, hogyan ismerje fel az átveréseket, hogyan kezelje a cyberbullyingot, hogyan gondolkodjon kritikusan az online tartalomról.', ikon: '🛡️', illusztracio: '🛡️💪', haatter: 'linear-gradient(135deg, #e8f5e9, #e3f2fd)' },
        { szoveg: 'A Digitális Őr eskü: "Megfogadom hogy felelősen és kritikusan használom az internetet, megvédem az adataimat, segítek másoknak ha bajban vannak online!"', ikon: '✊', illusztracio: '✊🌟', haatter: 'linear-gradient(135deg, #f3e5f5, #e3f2fd)' },
        { szoveg: 'Most jön a záróvizsga! Bizonyítsd be hogy valódi Agent X vagy! 🏅', ikon: '🎯', illusztracio: '🎯🏆', haatter: 'linear-gradient(135deg, #e3f2fd, #e8f5e9)', szabaly: 'A Digitális Őr megvédi magát és másokat is az online veszélyektől! 🏅' },
      ],
    },
    feladatok: [
      {
        id: 'k7_1', tipus: 'szerencsekerek',
        cim: '🎡 Tudáskerék',
        kerdesek: [
          { kerdes: 'Mit ne tegyél be soha egy nyilvános profilba?', opciok: [
            { szoveg: 'Kedvenc színed', helyes: false }, { szoveg: 'A pontos lakcímed', helyes: true },
          ]},
          { kerdes: 'Melyik jelszó a legerősebb?', opciok: [
            { szoveg: 'kutya123', helyes: false }, { szoveg: 'K@vics#Nap!42Zebra', helyes: true },
          ]},
          { kerdes: 'Mit tegyél, ha egy email sürgetve kéri a jelszavadat?', opciok: [
            { szoveg: 'Nem adom meg, gyanúsnak tartom', helyes: true }, { szoveg: 'Megadom, hiszen sürgős', helyes: false },
          ]},
          { kerdes: 'Zaklatás esetén mi az első lépés?', opciok: [
            { szoveg: 'Visszaírok ugyanolyan csúnyán', helyes: false }, { szoveg: 'Screenshotot mentek bizonyítékként', helyes: true },
          ]},
          { kerdes: 'Posztolnál egy kínos fotót valakiről engedély nélkül?', opciok: [
            { szoveg: 'Igen, ha vicces', helyes: false }, { szoveg: 'Nem, ez nem az én döntésem', helyes: true },
          ]},
          { kerdes: 'Egy "admin" a gaming fiókod jelszavát kéri. Megadod?', opciok: [
            { szoveg: 'Igen, hiszen admin', helyes: false }, { szoveg: 'Nem, a valódi adminok nem kérik', helyes: true },
          ]},
          { kerdes: 'Egy AI-videó döbbenetes dolgot mutat egy ismert emberről. Mit teszel?', opciok: [
            { szoveg: 'Azonnal elhiszem és megosztom', helyes: false }, { szoveg: 'Ellenőrzöm más forrásból is', helyes: true },
          ]},
        ],
        jegyzet: '🎓 A záróvizsga első próbája a "gyorstalpaló" — minden témakörből egy villámkérdés!'
      },
      {
        id: 'k7_2', tipus: 'boss_fight',
        cim: '👾 Boss Fight',
        kerdesek: [
          { kerdes: 'Kiadod a jelszavad a legjobb barátodnak?', opciok: [{ szoveg: 'Igen', helyes: false }, { szoveg: 'Nem', helyes: true }] },
          { kerdes: 'Megadod a lakcímed egy új online ismerősnek?', opciok: [{ szoveg: 'Igen', helyes: false }, { szoveg: 'Nem', helyes: true }] },
          { kerdes: 'Egy "nyeremény" üzenetre rákattintasz?', opciok: [{ szoveg: 'Igen', helyes: false }, { szoveg: 'Nem', helyes: true }] },
          { kerdes: 'Bekapcsolod a kétlépéses azonosítást?', opciok: [{ szoveg: 'Igen', helyes: true }, { szoveg: 'Nem', helyes: false }] },
          { kerdes: 'Visszaírsz egy zaklató üzenetére csúnyán?', opciok: [{ szoveg: 'Igen', helyes: false }, { szoveg: 'Nem', helyes: true }] },
          { kerdes: 'Elmész találkozni egy online gaming ismerőssel egyedül?', opciok: [{ szoveg: 'Igen', helyes: false }, { szoveg: 'Nem', helyes: true }] },
          { kerdes: 'Ellenőrzöd egy hír forrását, mielőtt megosztod?', opciok: [{ szoveg: 'Igen', helyes: true }, { szoveg: 'Nem', helyes: false }] },
          { kerdes: 'Megadod a jelszavad egy "adminnak"?', opciok: [{ szoveg: 'Igen', helyes: false }, { szoveg: 'Nem', helyes: true }] },
          { kerdes: 'Szólsz felnőttnek, ha valami gyanús történik veled online?', opciok: [{ szoveg: 'Igen', helyes: true }, { szoveg: 'Nem', helyes: false }] },
          { kerdes: 'Gondolkodás nélkül elhiszel egy döbbenetes AI-videót?', opciok: [{ szoveg: 'Igen', helyes: false }, { szoveg: 'Nem', helyes: true }] },
        ],
        jegyzet: '👾 Legyőzted a Boss-t!\n\n10 gyors döntés — pontosan úgy, ahogy a valóságban is: gyorsan kell reagálnod, amikor online veszéllyel találkozol. Ha mindegyiket jól tudtad, az azt jelenti, hogy az ösztöneid is jól be vannak állítva!'
      },
      {
        id: 'k7_3', tipus: 'cyber_szef',
        cim: '🔐 Cyber széf',
        kerdesek: [
          { kerdes: 'Mit tegyél, ha egy fiókodat feltörték?', szamjegy: '7', opciok: [
            { szoveg: 'Szólok egy felnőttnek és jelszót változtatok', helyes: true }, { szoveg: 'Nem csinálok semmit', helyes: false },
          ]},
          { kerdes: 'Milyen profilkép a biztonságos?', szamjegy: '3', opciok: [
            { szoveg: 'Saját, felismerhető arckép', helyes: false }, { szoveg: 'Kitalált avatar', helyes: true },
          ]},
          { kerdes: 'Ki kérheti el a jelszavadat?', szamjegy: '9', opciok: [
            { szoveg: 'Senki', helyes: true }, { szoveg: 'Egy "admin"', helyes: false },
          ]},
          { kerdes: 'Mi a teendő egy gyanús üzenettel?', szamjegy: '1', opciok: [
            { szoveg: 'Ellenőrzöm, és ha gyanús, szólok felnőttnek', helyes: true }, { szoveg: 'Válaszolok rá azonnal', helyes: false },
          ]},
        ],
        jegyzet: '🔐 Gratulálok, kinyitottad a Cyber Széfet!\n\nMinden helyes válasz egy számjegyet adott — pontosan úgy, ahogy a valóságban is: minden helyes biztonsági döntésed egy "számjeggyel" közelebb visz a teljes digitális biztonsághoz!'
      },
      {
        id: 'k7_4', tipus: 'kincsvadaszat',
        cim: '📦 Kincsvadászat',
        elemek: [
          { id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 },
        ],
        jegyzet: '📦 Megtaláltad az összes elrejtett Agent X jelvényt!\n\nEz a kincsvadászat jelképezi az egész Agent X Akadémiát — minden leckében egy-egy "jelvényt" (tudást) gyűjtöttél össze, és most mindet megtaláltad!'
      },
      {
        id: 'k7_5', tipus: 'rang_animacio',
        cim: '🏅 Záróvizsga 5: Rangosztó ceremónia',
        rangNev: 'Digitális Őr',
        xpOsszeg: 100,
      },
    ],
  },
];

// ============ KÖNYV ============
function KonyvOlvaso({ konyv, kuldes, onKesz }) {
  const [aktOldal, setAktOldal] = useState(0);
  const [animacio, setAnimacio] = useState('');
  const [animFut, setAnimFut] = useState(false);
  const aktualOldal = konyv.oldalak[aktOldal];
  const utolsoOldal = aktOldal === konyv.oldalak.length - 1;

  const lapoz = (irany) => {
    if (animFut) return;
    const ujIndex = irany === 'elore' ? aktOldal + 1 : aktOldal - 1;
    if (ujIndex < 0 || ujIndex >= konyv.oldalak.length) return;
    setAnimFut(true);
    setAnimacio(irany === 'elore' ? 'lap-ki-bal911' : 'lap-ki-jobb911');
    setTimeout(() => {
      setAktOldal(ujIndex);
      setAnimacio('lap-be911');
      setTimeout(() => { setAnimacio(''); setAnimFut(false); }, 450);
    }, 400);
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1.5rem'}}>
      <div style={{textAlign: 'center', width: '100%', maxWidth: '820px'}}>
        <div style={{display: 'inline-flex', alignItems: 'center', gap: '10px', background: `${kuldes.szin}15`, border: `2px solid ${kuldes.szin}40`, borderRadius: '50px', padding: '10px 24px', fontSize: '17px', fontWeight: '800', color: kuldes.szin, marginBottom: '1rem'}}>
          📖 {konyv.cim}
        </div>
        <div style={{display: 'flex', gap: '8px', justifyContent: 'center', alignItems: 'center'}}>
          {konyv.oldalak.map((_, i) => (
            <div key={i} onClick={() => { if (i > aktOldal) lapoz('elore'); else if (i < aktOldal) lapoz('vissza'); }}
              style={{width: i === aktOldal ? '36px' : '12px', height: '12px', borderRadius: '6px', background: i <= aktOldal ? kuldes.szin : '#e0e0e0', cursor: 'pointer', transition: 'all 0.4s cubic-bezier(0.34,1.56,0.64,1)'}}/>
          ))}
          <span style={{fontSize: '15px', color: '#90a4ae', fontWeight: '700', marginLeft: '8px'}}>{aktOldal + 1}/{konyv.oldalak.length}</span>
        </div>
      </div>
      <div style={{width: '100%', maxWidth: '820px', filter: 'drop-shadow(0 24px 48px rgba(33,150,243,0.12))'}}>
        <div className={animacio} style={{background: aktualOldal.haatter, borderRadius: '32px', minHeight: '460px', border: `2px solid ${kuldes.szin}20`, overflow: 'hidden', position: 'relative', display: 'flex', flexDirection: 'column', boxShadow: `0 2px 0 ${kuldes.szin}25, 5px 5px 0 ${kuldes.szin}12`}}>
          <div style={{position: 'absolute', left: 0, top: 0, bottom: 0, width: '12px', background: `linear-gradient(180deg, ${kuldes.szin}ee, ${kuldes.szin}99)`}}/>
          <div style={{flex: 1, padding: '2.5rem 3rem 1.5rem 4rem', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1.75rem'}}>
            <div style={{fontSize: '80px', lineHeight: 1, animation: 'pulzal911 3s ease-in-out infinite', textAlign: 'center'}}>{aktualOldal.illusztracio}</div>
            <p style={{fontSize: '23px', color: '#2d3748', lineHeight: '1.9', textAlign: 'center', fontWeight: '700', margin: 0, maxWidth: '600px'}}>{aktualOldal.szoveg}</p>
            {aktualOldal.szabaly && (
              <div style={{background: `linear-gradient(135deg, ${kuldes.szin}20, ${kuldes.szin}10)`, border: `2.5px solid ${kuldes.szin}`, borderRadius: '22px', padding: '1.4rem 1.9rem', textAlign: 'center', width: '100%', animation: 'csillog911 2.5s ease-in-out infinite'}}>
                <p style={{fontSize: '21px', fontWeight: '900', color: kuldes.szin, margin: 0}}>⭐ {aktualOldal.szabaly}</p>
              </div>
            )}
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1.25rem 2.5rem 2rem 4rem', borderTop: `1px solid ${kuldes.szin}15`}}>
            <button onClick={() => lapoz('vissza')} disabled={aktOldal === 0 || animFut} className="k911-btn"
              style={{background: aktOldal === 0 ? 'transparent' : 'var(--bg-card-transparent)', border: `2px solid ${aktOldal === 0 ? '#e0e0e0' : kuldes.szin}`, borderRadius: '50px', padding: '10px 24px', cursor: aktOldal === 0 ? 'not-allowed' : 'pointer', fontSize: '16px', fontWeight: '800', color: aktOldal === 0 ? '#ccc' : kuldes.szin}}>
              ← Előző
            </button>
            <div style={{fontSize: '36px'}}>{aktualOldal.ikon}</div>
            {!utolsoOldal ? (
              <button onClick={() => lapoz('elore')} disabled={animFut} className="k911-btn"
                style={{background: `linear-gradient(135deg, ${kuldes.szin}, ${kuldes.szin}cc)`, border: 'none', borderRadius: '50px', padding: '10px 24px', cursor: 'pointer', fontSize: '16px', fontWeight: '800', color: 'white', boxShadow: `0 4px 16px ${kuldes.szin}40`}}>
                Következő →
              </button>
            ) : (
              <button onClick={onKesz} className="k911-btn"
                style={{background: 'linear-gradient(135deg, #34a853, #66bb6a)', border: 'none', borderRadius: '50px', padding: '10px 24px', cursor: 'pointer', fontSize: '16px', fontWeight: '800', color: 'white'}}>
                Feladatok! 🎯
              </button>
            )}
          </div>
        </div>
      </div>
      <p style={{fontSize: '15px', color: '#90a4ae', fontWeight: '700', textAlign: 'center', animation: 'csillog911 2s ease-in-out infinite'}}>
        {utolsoOldal ? '🎉 Vége az olvasmánynak! Nyomd meg a Feladatok gombot!' : '📖 Lapozz a nyilakkal!'}
      </p>
    </div>
  );
}

// ============ IGAZ/HAMIS ============
function IgazHamisFeladat({ feladat, onKesz, kuldes }) {
  const [valaszok, setValaszok] = useState({});
  const [ellenorzott, setEllenorzott] = useState(false);
  const [helyes, setHelyes] = useState(false);
  const szin = kuldes?.szin || '#1976d2';

  const toggle = (i, ertek) => { if (ellenorzott) return; setValaszok(prev => ({ ...prev, [i]: ertek })); };
  const ellenorzes = () => { setHelyes(feladat.allitasok.every((a, i) => valaszok[i] === a.helyes)); setEllenorzott(true); };
  const ujra = () => { setValaszok({}); setEllenorzott(false); setHelyes(false); };
  const mindenMegvalaszolva = feladat.allitasok.every((_, i) => valaszok[i] !== undefined);

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: 'var(--text-primary)', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
      </div>
      <div style={{display: 'flex', flexDirection: 'column', gap: '0.875rem'}}>
        {feladat.allitasok.map((a, i) => {
          const valasz = valaszok[i];
          const helyesE = ellenorzott && valasz === a.helyes;
          const rosszE = ellenorzott && valasz !== undefined && valasz !== a.helyes;
          return (
            <div key={i} style={{background: helyesE ? 'linear-gradient(135deg, #e8f5e9, #f1f8e9)' : rosszE ? 'linear-gradient(135deg, #fce8e6, #fff3e0)' : 'var(--bg-card)', borderRadius: '20px', padding: '1.4rem 1.9rem', border: `2px solid ${helyesE ? '#34a853' : rosszE ? '#ea4335' : `${szin}20`}`, transition: 'all 0.2s'}}>
              <div style={{display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap'}}>
                <p style={{fontSize: '21px', fontWeight: '700', color: '#2d3748', margin: 0, flex: 1}}>{a.szoveg}</p>
                <div style={{display: 'flex', gap: '8px', flexShrink: 0}}>
                  <button onClick={() => toggle(i, true)} className="k911-btn"
                    style={{padding: '9px 22px', background: valasz === true ? (ellenorzott ? (a.helyes ? '#34a853' : '#ea4335') : szin) : 'var(--bg-card)', color: valasz === true ? 'white' : '#555', border: `2px solid ${valasz === true ? (ellenorzott ? (a.helyes ? '#34a853' : '#ea4335') : szin) : '#e0e0e0'}`, borderRadius: '50px', fontSize: '16px', fontWeight: '800', cursor: ellenorzott ? 'default' : 'pointer'}}>
                    ✓ Igaz
                  </button>
                  <button onClick={() => toggle(i, false)} className="k911-btn"
                    style={{padding: '9px 22px', background: valasz === false ? (ellenorzott ? (!a.helyes ? '#34a853' : '#ea4335') : '#64748b') : 'var(--bg-card)', color: valasz === false ? 'white' : '#555', border: `2px solid ${valasz === false ? (ellenorzott ? (!a.helyes ? '#34a853' : '#ea4335') : '#64748b') : '#e0e0e0'}`, borderRadius: '50px', fontSize: '16px', fontWeight: '800', cursor: ellenorzott ? 'default' : 'pointer'}}>
                    ✗ Hamis
                  </button>
                </div>
              </div>
              {ellenorzott && <p style={{fontSize: '15px', fontWeight: '700', color: helyesE ? '#1e7e34' : '#c62828', margin: '8px 0 0', padding: '6px 12px', background: helyesE ? '#e8f5e9' : '#fce8e6', borderRadius: '10px'}}>{a.magyarazat}</p>}
            </div>
          );
        })}
      </div>
      {ellenorzott && (
        <div className="k911-pop" style={{background: helyes ? '#e8f5e9' : '#fce8e6', border: `2px solid ${helyes ? '#34a853' : '#ea4335'}`, borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '21px', fontWeight: '900', color: helyes ? '#1e7e34' : '#c62828', margin: 0}}>{helyes ? feladat.visszajelzes_jo : feladat.visszajelzes_rossz}</p>
        </div>
      )}
      {helyes && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      <div style={{display: 'flex', justifyContent: 'center'}}>
        {!ellenorzott ? (
          <button onClick={ellenorzes} disabled={!mindenMegvalaszolva} className="k911-btn"
            style={{padding: '18px 48px', background: !mindenMegvalaszolva ? '#f0f4f8' : `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: !mindenMegvalaszolva ? '#94a3b8' : 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: !mindenMegvalaszolva ? 'not-allowed' : 'pointer', boxShadow: !mindenMegvalaszolva ? 'none' : `0 8px 24px ${szin}35`}}>
            ✅ Ellenőrzés
          </button>
        ) : helyes ? (
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        ) : (
          <button onClick={ujra} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(249,171,0,0.35)'}}>🔄 Próbáld újra!</button>
        )}
      </div>
    </div>
  );
}

// ============ NYOMOZÓ ============
function NyomozoFeladat({ feladat, onKesz, kuldes }) {
  const [kivalasztott, setKivalasztott] = useState([]);
  const [ellenorzott, setEllenorzott] = useState(false);
  const [helyes, setHelyes] = useState(false);
  const [lencsePoz, setLencsePoz] = useState(null);
  const dokRef = useRef(null);
  const szin = kuldes?.szin || '#1976d2';
  const LENCSE_MERET = 190;
  const NAGYITAS = 1.9;

  const toggle = (i) => { if (ellenorzott) return; setKivalasztott(prev => prev.includes(i) ? prev.filter(x => x !== i) : [...prev, i]); };
  const ellenorzes = () => {
    const gyanusak = feladat.elemek.map((e, i) => e.gyanús ? i : -1).filter(i => i !== -1);
    setHelyes(gyanusak.every(i => kivalasztott.includes(i)) && kivalasztott.every(i => feladat.elemek[i].gyanús));
    setEllenorzott(true);
  };
  const ujra = () => { setKivalasztott([]); setEllenorzott(false); setHelyes(false); };

  const lencseMozgas = (e) => {
    const rect = dokRef.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    setLencsePoz({ x: p.clientX - rect.left, y: p.clientY - rect.top });
  };

  const fejlec = (kicsi) => feladat.stilus === 'tiktok' ? (
    <div style={{textAlign: 'center', marginBottom: '1.25rem', paddingBottom: '1.25rem', borderBottom: `1px solid ${szin}15`}}>
      <div style={{width: kicsi ? '64px' : '84px', height: kicsi ? '64px' : '84px', borderRadius: '50%', background: `linear-gradient(135deg, ${szin}, ${szin}99)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: kicsi ? '32px' : '42px', margin: '0 auto 10px', border: '3px solid white', boxShadow: '0 4px 16px rgba(0,0,0,0.15)'}}>{feladat.profilAvatar || '🧑'}</div>
      <p style={{fontSize: '19px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 2px'}}>{feladat.profilNev || '@felhasznalo'}</p>
      <p style={{fontSize: '14px', color: '#94a3b8', fontWeight: '700', margin: '0 0 12px'}}>{feladat.profilCim || 'TikTok profil'}</p>
      <div style={{display: 'flex', justifyContent: 'center', gap: '28px', marginBottom: '12px'}}>
        <div><p style={{fontSize: '17px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>128</p><p style={{fontSize: '13px', color: '#94a3b8', margin: 0, fontWeight: '700'}}>Követett</p></div>
        <div><p style={{fontSize: '17px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>2.431</p><p style={{fontSize: '13px', color: '#94a3b8', margin: 0, fontWeight: '700'}}>Követő</p></div>
        <div><p style={{fontSize: '17px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>18.2k</p><p style={{fontSize: '13px', color: '#94a3b8', margin: 0, fontWeight: '700'}}>Kedvelés</p></div>
      </div>
      <div style={{display: 'inline-block', background: `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: 'white', fontSize: '15px', fontWeight: '800', padding: '8px 28px', borderRadius: '10px'}}>Követés</div>
      <p style={{fontSize: '13px', color: '#94a3b8', fontWeight: '800', marginTop: '14px', letterSpacing: '0.5px', textTransform: 'uppercase'}}>📋 Bemutatkozás</p>
    </div>
  ) : (
    <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1rem', paddingBottom: '0.75rem', borderBottom: `1px dashed ${szin}25`}}>
      <div style={{width: '36px', height: '36px', borderRadius: '10px', background: `${szin}18`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '21px'}}>📋</div>
      <p style={{fontSize: '15px', fontWeight: '800', color: '#94a3b8', margin: 0, letterSpacing: '0.5px', textTransform: 'uppercase'}}>Agent X akta</p>
    </div>
  );

  const sorRenderAkta = (aktiv) => feladat.elemek.map((e, i) => {
    const kiv = kivalasztott.includes(i);
    const helyesE = ellenorzott && e.gyanús && kiv;
    const kihagyottE = ellenorzott && e.gyanús && !kiv;
    const rosszE = ellenorzott && !e.gyanús && kiv;
    return (
      <div key={i} onClick={aktiv ? () => toggle(i) : undefined} className={aktiv ? 'nyomozo-elem k911-valasz' : ''} data-disabled={ellenorzott ? 'true' : undefined}
        style={{background: helyesE || kihagyottE ? '#fce8e6' : rosszE ? '#fff8e1' : kiv ? `${szin}12` : 'var(--bg-card)', border: `2.5px solid ${helyesE || kihagyottE ? '#ea4335' : rosszE ? '#f9ab00' : kiv ? szin : `${szin}15`}`, borderRadius: '18px', padding: '1rem 1.5rem', cursor: aktiv && !ellenorzott ? 'pointer' : 'default', display: 'flex', alignItems: 'flex-start', gap: '14px', marginBottom: '0.75rem'}}>
        <div style={{flex: 1}}>
          <p style={{fontSize: '21px', fontWeight: '700', color: '#2d3748', margin: 0, whiteSpace: 'pre-line'}}>{e.szoveg}</p>
          {ellenorzott && e.gyanús && (
            <div style={{marginTop: '10px', background: 'var(--bg-card)', border: '2px solid #ea4335', borderRadius: '14px', padding: '10px 14px', display: 'flex', alignItems: 'center', gap: '10px'}}>
              <span style={{fontSize: '23px'}}>🚨</span>
              <p style={{fontSize: '16px', fontWeight: '800', color: '#c62828', margin: 0}}>{e.magyarazat}</p>
            </div>
          )}
          {ellenorzott && !e.gyanús && kiv && (
            <div style={{marginTop: '10px', background: 'var(--bg-card)', border: '2px solid #f9ab00', borderRadius: '14px', padding: '10px 14px', display: 'flex', alignItems: 'center', gap: '10px'}}>
              <span style={{fontSize: '23px'}}>⚠️</span>
              <p style={{fontSize: '16px', fontWeight: '800', color: '#f57f17', margin: 0}}>Ez rendben van: {e.magyarazat}</p>
            </div>
          )}
          {ellenorzott && !e.gyanús && !kiv && (
            <div style={{marginTop: '10px', background: 'var(--bg-card)', border: '2px solid #34a853', borderRadius: '14px', padding: '10px 14px', display: 'flex', alignItems: 'center', gap: '10px'}}>
              <span style={{fontSize: '23px'}}>✅</span>
              <p style={{fontSize: '16px', fontWeight: '800', color: '#1e7e34', margin: 0}}>{e.magyarazat}</p>
            </div>
          )}
        </div>
        {aktiv && <div style={{fontSize: '27px', flexShrink: 0}}>{ellenorzott ? (e.gyanús ? '🚨' : '✅') : kiv ? '📌' : '○'}</div>}
      </div>
    );
  });

  const sorRenderBio = (aktiv) => (
    <div style={{padding: '0.5rem 0.25rem'}}>
      {feladat.elemek.map((e, i) => {
        const kiv = kivalasztott.includes(i);
        const rossz = ellenorzott && e.gyanús;
        const jo = ellenorzott && !e.gyanús;
        return (
          <div key={i} onClick={aktiv ? () => toggle(i) : undefined} data-disabled={ellenorzott ? 'true' : undefined}
            style={{padding: '8px 12px', borderRadius: '10px', cursor: aktiv && !ellenorzott ? 'pointer' : 'default', background: !ellenorzott && kiv ? `${szin}15` : ellenorzott ? (rossz ? '#fce8e6' : jo && kiv ? '#fff8e1' : 'transparent') : 'transparent', marginBottom: '2px', transition: 'background 0.15s'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
              <p style={{fontSize: '21px', fontWeight: '700', color: '#2d3748', margin: 0, flex: 1}}>{e.szoveg}</p>
              {ellenorzott && <span style={{fontSize: '21px'}}>{e.gyanús ? '🚨' : (kiv ? '⚠️' : '✅')}</span>}
              {!ellenorzott && aktiv && kiv && <span style={{fontSize: '17px'}}>📌</span>}
            </div>
            {aktiv && ellenorzott && (
              <p style={{fontSize: '15px', fontWeight: '800', color: e.gyanús ? '#c62828' : (kiv ? '#f57f17' : '#1e7e34'), margin: '4px 0 0'}}>
                {e.gyanús ? e.magyarazat : (kiv ? `Ez rendben van: ${e.magyarazat}` : e.magyarazat)}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );

  const sorRender = (aktiv) => {
    if (feladat.stilus === 'tiktok') return sorRenderBio(aktiv);
    if (feladat.elrendezes === 'racs') {
      return <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.9rem'}}>{sorRenderAkta(aktiv)}</div>;
    }
    return sorRenderAkta(aktiv);
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '0.75rem'}}>
          <div style={{fontSize: '46px', animation: 'pulzal911 2.5s ease-in-out infinite'}}>🔍</div>
          <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>{feladat.cim}</p>
        </div>
        <p style={{fontSize: '18px', color: '#64748b', margin: '0 0 0.5rem', fontWeight: '600'}}>{feladat.kerdes}</p>
        <p style={{fontSize: '15px', color: '#94a3b8', fontWeight: '700'}}>🔎 Mozgasd a nagyítót az akta felett, hogy közelről vizsgáld meg — koppints az elemekre, amiket gyanúsnak találsz!</p>
      </div>

      <div ref={dokRef} onMouseMove={lencseMozgas} onMouseLeave={() => setLencsePoz(null)}
        onTouchMove={lencseMozgas} onTouchEnd={() => setLencsePoz(null)} className="nyomozo-dokumentum"
        style={{position: 'relative', background: '#f8fafc', border: `2px solid ${szin}15`, borderRadius: '24px', padding: '1.5rem', overflow: 'hidden', cursor: 'none'}}>
        {fejlec(false)}
        {sorRender(true)}

        {lencsePoz && dokRef.current && (() => {
          const docW = dokRef.current.offsetWidth;
          const docH = dokRef.current.offsetHeight;
          return (
            <div style={{
              position: 'absolute', left: lencsePoz.x - LENCSE_MERET / 2, top: lencsePoz.y - LENCSE_MERET / 2,
              width: LENCSE_MERET, height: LENCSE_MERET, borderRadius: '50%', overflow: 'hidden',
              border: `7px solid ${szin}`, boxShadow: `0 8px 28px rgba(0,0,0,0.35), inset 0 0 20px rgba(0,0,0,0.1)`,
              pointerEvents: 'none', zIndex: 20, background: 'white',
            }}>
              <div style={{
                position: 'absolute',
                left: -(lencsePoz.x - LENCSE_MERET / 2), top: -(lencsePoz.y - LENCSE_MERET / 2),
                width: docW, height: docH, padding: '1.5rem', boxSizing: 'border-box',
                transform: `scale(${NAGYITAS})`, transformOrigin: `${lencsePoz.x}px ${lencsePoz.y}px`,
              }}>
                {fejlec(true)}
                {sorRender(false)}
              </div>
            </div>
          );
        })()}
        {lencsePoz && (
          <div style={{
            position: 'absolute', left: lencsePoz.x + LENCSE_MERET * 0.28, top: lencsePoz.y + LENCSE_MERET * 0.28,
            width: '10px', height: '58px', background: `linear-gradient(180deg, ${szin}, #3a3a3a)`, borderRadius: '6px',
            transform: 'rotate(45deg)', transformOrigin: 'top center', pointerEvents: 'none', zIndex: 19,
            boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
          }}/>
        )}
      </div>

      {ellenorzott && (
        <div className="k911-pop" style={{background: helyes ? '#e8f5e9' : '#fce8e6', border: `2px solid ${helyes ? '#34a853' : '#ea4335'}`, borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '21px', fontWeight: '900', color: helyes ? '#1e7e34' : '#c62828', margin: 0}}>{helyes ? feladat.visszajelzes_jo : feladat.visszajelzes_rossz}</p>
        </div>
      )}
      {helyes && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      <div style={{display: 'flex', justifyContent: 'center'}}>
        {!ellenorzott ? (
          <button onClick={ellenorzes} disabled={kivalasztott.length === 0} className="k911-btn"
            style={{padding: '18px 48px', background: kivalasztott.length === 0 ? '#f0f4f8' : `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: kivalasztott.length === 0 ? '#94a3b8' : 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: kivalasztott.length === 0 ? 'not-allowed' : 'pointer', boxShadow: kivalasztott.length === 0 ? 'none' : `0 8px 24px ${szin}35`}}>
            🔎 Ellenőrzés
          </button>
        ) : helyes ? (
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        ) : (
          <button onClick={ujra} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(249,171,0,0.35)'}}>🔄 Próbáld újra!</button>
        )}
      </div>
    </div>
  );
}

// ============ PROFIL NYOMOZÓ (valódi profil, azonnali visszajelzéssel) ============
function ProfilNyomozo({ feladat, onKesz, kuldes }) {
  const [felfedve, setFelfedve] = useState([]);
  const [kesz, setKesz] = useState(false);
  const [lencsePoz, setLencsePoz] = useState(null);
  const dokRef = useRef(null);
  const szin = kuldes?.szin || '#1976d2';
  const LENCSE_MERET = 190;
  const NAGYITAS = 1.9;

  const nevAdat = feladat.felhasznalonevAdat;
  const avatarAdat = feladat.avatarAdat;
  const nevFelfedve = felfedve.includes('nev');
  const avatarFelfedve = felfedve.includes('avatar');

  const celDarab = feladat.elemek.filter(e => e.gyanús).length + (nevAdat?.gyanús ? 1 : 0) + (avatarAdat?.gyanús ? 1 : 0);

  const kattint = (kulcs, adat) => {
    if (!adat || !adat.gyanús || felfedve.includes(kulcs)) return;
    const uj = [...felfedve, kulcs];
    setFelfedve(uj);
    if (uj.length === celDarab) {
      setKesz(true);
    }
  };

  const lencseMozgas = (e) => {
    const rect = dokRef.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    setLencsePoz({ x: p.clientX - rect.left, y: p.clientY - rect.top });
  };

  const profilTartalom = (aktiv) => (
    <>
      {feladat.stilus === 'tiktok' ? (
        <div style={{textAlign: 'center', marginBottom: '1.25rem', paddingBottom: '1.25rem', borderBottom: `1px solid ${szin}15`}}>
          <div onClick={aktiv && avatarAdat ? () => kattint('avatar', avatarAdat) : undefined}
            className={aktiv && avatarAdat && avatarAdat.gyanús && !avatarFelfedve ? 'nyomozo-elem' : avatarFelfedve && avatarAdat.gyanús ? 'piros-villan' : kesz && avatarAdat && !avatarAdat.gyanús ? 'jo-villog' : ''}
            style={{width: '84px', height: '84px', borderRadius: '50%', background: `linear-gradient(135deg, ${szin}, ${szin}99)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '42px', margin: '0 auto 10px', border: avatarFelfedve ? `3px solid ${avatarAdat.gyanús ? '#ea4335' : '#34a853'}` : '3px solid white', boxShadow: '0 4px 16px rgba(0,0,0,0.15)', cursor: aktiv && avatarAdat && avatarAdat.gyanús && !avatarFelfedve ? 'pointer' : 'default', position: 'relative'}}>
            {feladat.profilAvatar || '🧑'}
            {avatarFelfedve && <span style={{position: 'absolute', bottom: '-4px', right: '-4px', fontSize: '23px'}}>{avatarAdat.gyanús ? '🚨' : '✅'}</span>}
          </div>
          {avatarFelfedve && (
            <p style={{fontSize: '14px', fontWeight: '800', color: avatarAdat.gyanús ? '#c62828' : '#1e7e34', margin: '0 0 8px'}}>
              {avatarAdat.gyanús ? 'Veszélyes: ' : 'Biztonságos: '}{avatarAdat.magyarazat}
            </p>
          )}

          {nevAdat ? (
            <span onClick={aktiv ? () => kattint('nev', nevAdat) : undefined} className={aktiv && nevAdat.gyanús && !nevFelfedve ? 'nyomozo-elem' : nevFelfedve && nevAdat.gyanús ? 'piros-villan' : kesz && !nevAdat.gyanús ? 'jo-villog' : ''}
              style={{display: 'inline-block', fontSize: '21px', fontWeight: '900', margin: '0 0 2px', cursor: aktiv && nevAdat.gyanús && !nevFelfedve ? 'pointer' : 'default', padding: '4px 12px', borderRadius: '10px', color: nevFelfedve ? (nevAdat.gyanús ? '#c62828' : '#1e7e34') : '#1a1a2e', background: nevFelfedve ? (nevAdat.gyanús ? '#fce8e6' : '#e8f5e9') : 'transparent', border: nevFelfedve ? `2px solid ${nevAdat.gyanús ? '#ea4335' : '#34a853'}` : '2px solid transparent'}}>
              {nevFelfedve && <span style={{marginRight: '6px'}}>{nevAdat.gyanús ? '🚨' : '✅'}</span>}
              {feladat.profilNev || '@felhasznalo'}
            </span>
          ) : (
            <p style={{fontSize: '21px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 2px'}}>{feladat.profilNev || '@felhasznalo'}</p>
          )}
          {nevFelfedve && (
            <p style={{fontSize: '15px', fontWeight: '800', color: nevAdat.gyanús ? '#c62828' : '#1e7e34', margin: '6px 0 0'}}>
              {nevAdat.gyanús ? 'Veszélyes: ' : 'Biztonságos: '}{nevAdat.magyarazat}
            </p>
          )}

          <p style={{fontSize: '14px', color: '#94a3b8', fontWeight: '700', margin: '12px 0 12px'}}>{feladat.profilCim || 'Profil'}</p>
          <div style={{display: 'flex', justifyContent: 'center', gap: '28px', marginBottom: '12px'}}>
            <div><p style={{fontSize: '17px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>128</p><p style={{fontSize: '13px', color: '#94a3b8', margin: 0, fontWeight: '700'}}>Követett</p></div>
            <div><p style={{fontSize: '17px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>2.431</p><p style={{fontSize: '13px', color: '#94a3b8', margin: 0, fontWeight: '700'}}>Követő</p></div>
            <div><p style={{fontSize: '17px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>18.2k</p><p style={{fontSize: '13px', color: '#94a3b8', margin: 0, fontWeight: '700'}}>Kedvelés</p></div>
          </div>
          <div style={{display: 'inline-block', background: `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: 'white', fontSize: '15px', fontWeight: '800', padding: '8px 28px', borderRadius: '10px'}}>Követés</div>
        </div>
      ) : (
        <div style={{display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '1.25rem', paddingBottom: '1.25rem', borderBottom: `1px solid ${szin}15`}}>
          <div style={{width: '48px', height: '48px', borderRadius: '14px', background: `${szin}18`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '27px', flexShrink: 0}}>{feladat.profilAvatar || '📄'}</div>
          <div>
            <p style={{fontSize: '19px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>{feladat.profilNev || 'Dokumentum'}</p>
            <p style={{fontSize: '14px', color: '#94a3b8', fontWeight: '700', margin: 0}}>{feladat.profilCim || ''}</p>
          </div>
        </div>
      )}

      <p style={{fontSize: '13px', color: '#94a3b8', fontWeight: '800', margin: '0 0 8px', letterSpacing: '0.5px', textTransform: 'uppercase'}}>{feladat.stilus === 'tiktok' ? '📝 Bemutatkozás' : '📋 Tartalom'}</p>
      <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'flex-start'}}>
        {feladat.elemek.map((e, i) => {
          const felfedettE = felfedve.includes(i);
          const kattinthato = aktiv && e.gyanús && !felfedettE;
          return (
            <span key={i} style={{display: 'inline-flex', flexDirection: 'column'}}>
              <span onClick={kattinthato ? () => kattint(i, e) : undefined} className={kattinthato ? 'nyomozo-elem' : felfedettE && e.gyanús ? 'piros-villan' : kesz && !e.gyanús ? 'jo-villog' : ''}
                style={{fontSize: '18px', fontWeight: '700', color: felfedettE ? (e.gyanús ? '#c62828' : '#1e7e34') : '#2d3748', cursor: kattinthato ? 'pointer' : 'default', padding: '5px 10px', borderRadius: '8px', background: felfedettE ? (e.gyanús ? '#fce8e6' : '#e8f5e9') : `${szin}08`}}>
                {felfedettE && <span style={{marginRight: '4px'}}>{e.gyanús ? '🚨' : '✅'}</span>}
                {kesz && !e.gyanús && !felfedettE && <span style={{marginRight: '4px'}}>✅</span>}
                {e.szoveg}
              </span>
              {felfedettE && (
                <span style={{fontSize: '14px', fontWeight: '800', color: e.gyanús ? '#c62828' : '#1e7e34', margin: '3px 2px 0', maxWidth: '220px'}}>
                  {e.gyanús ? 'Veszélyes: ' : 'Biztonságos: '}{e.magyarazat}
                </span>
              )}
            </span>
          );
        })}
      </div>
    </>
  );

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '0.75rem'}}>
          <div style={{fontSize: '46px', animation: 'pulzal911 2.5s ease-in-out infinite'}}>🔍</div>
          <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>{feladat.cim}</p>
        </div>
        <p style={{fontSize: '18px', color: '#64748b', margin: '0 0 0.5rem', fontWeight: '600'}}>{feladat.kerdes}</p>
        <p style={{fontSize: '15px', color: '#94a3b8', fontWeight: '700'}}>🔎 Mozgasd a nagyítót a profil felett, és koppints a VESZÉLYES adatokra — a biztonságosak a végén zölden felvillannak!</p>
        <p style={{fontSize: '15px', color: szin, fontWeight: '800', marginTop: '4px'}}>{felfedve.length}/{celDarab} veszélyes adat megtalálva</p>
      </div>

      <div ref={dokRef} onMouseMove={lencseMozgas} onMouseLeave={() => setLencsePoz(null)}
        onTouchMove={lencseMozgas} onTouchEnd={() => setLencsePoz(null)} className="nyomozo-dokumentum"
        style={{position: 'relative', background: '#f8fafc', border: `2px solid ${szin}15`, borderRadius: '24px', padding: '1.5rem', overflow: 'hidden', cursor: 'none'}}>
        {profilTartalom(true)}

        {lencsePoz && dokRef.current && (() => {
          const docW = dokRef.current.offsetWidth;
          const docH = dokRef.current.offsetHeight;
          return (
            <div style={{
              position: 'absolute', left: lencsePoz.x - LENCSE_MERET / 2, top: lencsePoz.y - LENCSE_MERET / 2,
              width: LENCSE_MERET, height: LENCSE_MERET, borderRadius: '50%', overflow: 'hidden',
              border: `7px solid ${szin}`, boxShadow: `0 8px 28px rgba(0,0,0,0.35), inset 0 0 20px rgba(0,0,0,0.1)`,
              pointerEvents: 'none', zIndex: 20, background: 'white',
            }}>
              <div style={{
                position: 'absolute',
                left: -(lencsePoz.x - LENCSE_MERET / 2), top: -(lencsePoz.y - LENCSE_MERET / 2),
                width: docW, height: docH, padding: '1.5rem', boxSizing: 'border-box',
                transform: `scale(${NAGYITAS})`, transformOrigin: `${lencsePoz.x}px ${lencsePoz.y}px`,
              }}>
                {profilTartalom(false)}
              </div>
            </div>
          );
        })()}
        {lencsePoz && (
          <div style={{
            position: 'absolute', left: lencsePoz.x + LENCSE_MERET * 0.28, top: lencsePoz.y + LENCSE_MERET * 0.28,
            width: '10px', height: '58px', background: `linear-gradient(180deg, ${szin}, #3a3a3a)`, borderRadius: '6px',
            transform: 'rotate(45deg)', transformOrigin: 'top center', pointerEvents: 'none', zIndex: 19,
            boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
          }}/>
        )}
      </div>

      {kesz && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
    </div>
  );
}

// ============ PROFIL ÉPÍTŐ (több körös, választásos) ============
function ProfilEpito({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1976d2';
  const [korIndex, setKorIndex] = useState(0);
  const [kivalasztott, setKivalasztott] = useState(null);
  const [hiba, setHiba] = useState(false);
  const kor = feladat.korok[korIndex];

  const valaszt = (opt, i) => {
    if (kivalasztott !== null) return;
    if (opt.helyes) {
      setKivalasztott(i);
      setTimeout(() => {
        if (korIndex + 1 < feladat.korok.length) { setKorIndex(k => k + 1); setKivalasztott(null); }
        else onKesz();
      }, 1100);
    } else {
      setHiba(i);
      setTimeout(() => setHiba(false), 700);
    }
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{kor.kerdes}</p>
        <p style={{fontSize: '15px', color: szin, fontWeight: '800', marginTop: '8px'}}>Lépés {korIndex + 1}/{feladat.korok.length}</p>
      </div>
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '1rem'}}>
        {kor.opciok.map((o, i) => (
          <div key={i} onClick={() => valaszt(o, i)} className="k911-valasz" data-disabled={kivalasztott !== null ? 'true' : undefined}
            style={{background: kivalasztott === i ? '#e8f5e9' : hiba === i ? '#fce8e6' : 'var(--bg-card)', border: `2.5px solid ${kivalasztott === i ? '#34a853' : hiba === i ? '#ea4335' : `${szin}15`}`, borderRadius: '20px', padding: '1.5rem 1rem', textAlign: 'center', cursor: kivalasztott !== null ? 'default' : 'pointer'}}>
            <div style={{fontSize: '44px', marginBottom: '8px'}}>{o.emoji}</div>
            <p style={{fontSize: '16px', fontWeight: '800', color: '#2d3748', margin: 0}}>{o.felirat}</p>
            {(kivalasztott === i || hiba === i) && (
              <p style={{fontSize: '14px', fontWeight: '800', color: o.helyes ? '#1e7e34' : '#c62828', margin: '8px 0 0'}}>{o.magyarazat}</p>
            )}
          </div>
        ))}
      </div>
      {korIndex === feladat.korok.length - 1 && kivalasztott !== null && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
    </div>
  );
}

// ============ AGENT X NAPLÓ (reflexiós checklist) ============
function AgentXNaplo({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1976d2';
  const [kivalasztott, setKivalasztott] = useState([]);
  const [mentve, setMentve] = useState(false);
  const CEL = feladat.celDarab || 3;

  const toggle = (i) => {
    if (mentve) return;
    setKivalasztott(prev => prev.includes(i) ? prev.filter(x => x !== i) : (prev.length < CEL ? [...prev, i] : prev));
  };
  const mentes = () => { setMentve(true); };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '0.75rem'}}>
          <div style={{fontSize: '46px'}}>📝</div>
          <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>{feladat.cim}</p>
        </div>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
        <p style={{fontSize: '15px', color: szin, fontWeight: '800', marginTop: '8px'}}>Válassz ki pontosan {CEL}-at! ({kivalasztott.length}/{CEL})</p>
      </div>
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem'}}>
        {feladat.elemek.map((e, i) => {
          const kiv = kivalasztott.includes(i);
          return (
            <div key={i} onClick={() => toggle(i)} className="k911-valasz"
              style={{background: kiv ? `${szin}12` : 'var(--bg-card)', border: `2.5px solid ${kiv ? szin : `${szin}15`}`, borderRadius: '18px', padding: '1.1rem 1.25rem', cursor: mentve ? 'default' : 'pointer', display: 'flex', alignItems: 'center', gap: '12px'}}>
              <span style={{fontSize: '29px'}}>{e.emoji}</span>
              <span style={{fontSize: '19px', fontWeight: '700', color: '#2d3748', flex: 1}}>{e.szoveg}</span>
              {kiv && <span style={{fontSize: '21px'}}>✅</span>}
            </div>
          );
        })}
      </div>
      {mentve && (
        <div style={{background: '#e8f5e9', border: '2px solid #34a853', borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '21px', fontWeight: '900', color: '#1e7e34', margin: 0}}>📝 Naplóba mentve! Ezt a {CEL}-at ezentúl mindig titokban tartod.</p>
        </div>
      )}
      {mentve && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {mentve && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        </div>
      )}
      {!mentve && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={mentes} disabled={kivalasztott.length !== CEL} className="k911-btn"
            style={{padding: '18px 48px', background: kivalasztott.length !== CEL ? '#f0f4f8' : `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: kivalasztott.length !== CEL ? '#94a3b8' : 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: kivalasztott.length !== CEL ? 'not-allowed' : 'pointer', boxShadow: kivalasztott.length !== CEL ? 'none' : `0 8px 24px ${szin}35`}}>
            📝 Mentés a naplóba
          </button>
        </div>
      )}
    </div>
  );
}

// ============ SZÓKERESŐ ============
function generaltRacs(szavakLista, meret) {
  const grid = Array.from({ length: meret }, () => Array(meret).fill(null));
  const iranyok = [[0,1],[1,0]];
  const elhelyezesek = [];
  const rendezett = [...szavakLista].sort((a, b) => b.length - a.length);
  rendezett.forEach(szo => {
    const betuk = szo.toUpperCase().split('');
    let kesz = false, probak = 0;
    while (!kesz && probak < 1000) {
      probak++;
      const irany = iranyok[Math.floor(Math.random() * iranyok.length)];
      const sr = Math.floor(Math.random() * meret);
      const sc = Math.floor(Math.random() * meret);
      const er = sr + irany[0] * (betuk.length - 1);
      const ec = sc + irany[1] * (betuk.length - 1);
      if (er < 0 || er >= meret || ec < 0 || ec >= meret) continue;
      let illik = true;
      for (let i = 0; i < betuk.length; i++) {
        const r = sr + irany[0] * i, c = sc + irany[1] * i;
        if (grid[r][c] !== null && grid[r][c] !== betuk[i]) { illik = false; break; }
      }
      if (!illik) continue;
      for (let i = 0; i < betuk.length; i++) {
        const r = sr + irany[0] * i, c = sc + irany[1] * i;
        grid[r][c] = betuk[i];
      }
      elhelyezesek.push({ szo: szo.toUpperCase(), start: [sr, sc], irany, hossz: betuk.length });
      kesz = true;
    }
  });
  const toltok = 'ABCDEFGHIJKLMNOPQRSTUVWXYZÁÉÍÓÖŐÚÜŰ';
  for (let r = 0; r < meret; r++) for (let c = 0; c < meret; c++) if (!grid[r][c]) grid[r][c] = toltok[Math.floor(Math.random() * toltok.length)];
  return { grid, elhelyezesek };
}

function SzoKereso({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1976d2';
  const MERET = Math.max(10, Math.max(...feladat.szavak.map(s => s.length)) + 2, feladat.szavak.length + 5);
  const [{ grid, elhelyezesek }] = useState(() => generaltRacs(feladat.szavak, MERET));
  const [megtalalt, setMegtalalt] = useState([]);
  const [megtalaltCellak, setMegtalaltCellak] = useState(new Set());
  const [kezdo, setKezdo] = useState(null);
  const [aktualis, setAktualis] = useState(null);
  const [toast, setToast] = useState(null);
  const huzas = useRef(false);
  const racsRef = useRef(null);

  const cellaKulcs = (r, c) => `${r},${c}`;

  const vonalCellak = (start, veg) => {
    if (!start || !veg) return [];
    const dr = veg[0] - start[0], dc = veg[1] - start[1];
    if (dr === 0 && dc === 0) return [start];
    if (dr !== 0 && dc !== 0 && Math.abs(dr) !== Math.abs(dc)) return [start];
    const lepesek = Math.max(Math.abs(dr), Math.abs(dc));
    const irR = dr === 0 ? 0 : dr / Math.abs(dr);
    const irC = dc === 0 ? 0 : dc / Math.abs(dc);
    return Array.from({ length: lepesek + 1 }, (_, i) => [start[0] + irR * i, start[1] + irC * i]);
  };

  const cellaPoziciobol = (x, y) => {
    const el = document.elementFromPoint(x, y);
    if (!el || !el.dataset || el.dataset.r === undefined) return null;
    return [Number(el.dataset.r), Number(el.dataset.c)];
  };

  const kezdes = (r, c) => { huzas.current = true; setKezdo([r, c]); setAktualis([r, c]); };
  const mozgas = (e) => {
    if (!huzas.current) return;
    const p = e.touches ? e.touches[0] : e;
    const cella = e.touches ? cellaPoziciobol(p.clientX, p.clientY) : null;
    if (cella) setAktualis(cella);
  };
  const egerMozgas = (r, c) => { if (huzas.current) setAktualis([r, c]); };

  const vege = () => {
    if (!huzas.current || !kezdo || !aktualis) { huzas.current = false; return; }
    huzas.current = false;
    const vonal = vonalCellak(kezdo, aktualis);
    const betuk = vonal.map(([r, c]) => grid[r][c]).join('');
    const forditva = betuk.split('').reverse().join('');
    const talalat = elhelyezesek.find(e => !megtalalt.includes(e.szo) && (e.szo === betuk || e.szo === forditva));
    if (talalat) {
      setMegtalalt(prev => [...prev, talalat.szo]);
      setMegtalaltCellak(prev => {
        const uj = new Set(prev);
        vonal.forEach(([r, c]) => uj.add(cellaKulcs(r, c)));
        return uj;
      });
      setToast(talalat.szo);
      setTimeout(() => setToast(null), 1300);
      if (megtalalt.length + 1 === feladat.szavak.length) { /* várunk a gombra */ }
    }
    setKezdo(null); setAktualis(null);
  };

  const kijeloltCellak = new Set(vonalCellak(kezdo, aktualis).map(([r, c]) => cellaKulcs(r, c)));

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}} onMouseUp={vege} onMouseLeave={vege}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '0.75rem'}}>
          <div style={{fontSize: '46px'}}>🔤</div>
          <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>{feladat.cim}</p>
        </div>
        <p style={{fontSize: '18px', color: '#64748b', margin: 0, fontWeight: '600'}}>Húzd végig az ujjad/egeret a szavakon — csak jobbra vagy lefelé bújhatnak meg!</p>
        <p style={{fontSize: '15px', color: szin, fontWeight: '800', marginTop: '8px'}}>{megtalalt.length}/{feladat.szavak.length} szó megtalálva</p>
      </div>

      <div style={{display: 'flex', gap: '1.5rem', flexWrap: 'wrap', alignItems: 'flex-start'}}>
        <div ref={racsRef} onTouchMove={mozgas} onTouchEnd={vege}
          style={{position: 'relative', display: 'grid', gridTemplateColumns: `repeat(${MERET}, minmax(0, 1fr))`, gap: '4px', background: '#f8fafc', border: `2px solid ${szin}15`, borderRadius: '24px', padding: '16px', flex: '1 1 600px', maxWidth: '780px', userSelect: 'none', touchAction: 'none'}}>
          {grid.map((sor, r) => sor.map((betu, c) => {
            const kulcs = cellaKulcs(r, c);
            const megvan = megtalaltCellak.has(kulcs);
            const kijelolve = kijeloltCellak.has(kulcs);
            return (
              <div key={kulcs} data-r={r} data-c={c}
                onMouseDown={() => kezdes(r, c)} onMouseEnter={() => egerMozgas(r, c)}
                onTouchStart={() => kezdes(r, c)}
                style={{aspectRatio: '1', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '27px', fontWeight: '800', borderRadius: '9px', cursor: 'pointer', color: megvan ? 'white' : kijelolve ? szin : '#2d3748', background: megvan ? '#34a853' : kijelolve ? `${szin}25` : 'white', transition: 'background 0.15s, color 0.15s'}}>
                {betu}
              </div>
            );
          }))}
          {toast && (
            <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', background: 'rgba(52,168,83,0.95)', color: 'white', padding: '14px 28px', borderRadius: '18px', fontSize: '19px', fontWeight: '900', animation: 'felugrik911 0.3s ease-out', boxShadow: '0 8px 28px rgba(0,0,0,0.25)', zIndex: 10}}>
              ✅ {toast}! +10 XP
            </div>
          )}
        </div>

        <div style={{flex: '1 1 200px', display: 'flex', flexDirection: 'column', gap: '8px'}}>
          {feladat.szavak.map((szo, i) => {
            const megvan = megtalalt.includes(szo.toUpperCase());
            return (
              <div key={i} style={{display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 16px', borderRadius: '14px', background: megvan ? '#e8f5e9' : 'var(--bg-card)', border: `2px solid ${megvan ? '#34a853' : `${szin}15`}`}}>
                <span style={{fontSize: '21px'}}>{megvan ? '✅' : '🔎'}</span>
                <span style={{fontSize: '17px', fontWeight: '800', color: megvan ? '#1e7e34' : '#2d3748', textDecoration: megvan ? 'line-through' : 'none'}}>{szo}</span>
              </div>
            );
          })}
        </div>
      </div>

      {megtalalt.length === feladat.szavak.length && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {megtalalt.length === feladat.szavak.length && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ PROFILÉPÍTŐ (húzd a profilba, ami megjeleníthető) ============
function ProfilEpitoDrag({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1976d2';
  const [profilban, setProfilban] = useState([]);
  const [dragolt, setDragolt] = useState(null);
  const [ellenorzott, setEllenorzott] = useState(false);
  const [helyes, setHelyes] = useState(false);

  const pool = feladat.elemek.map((e, i) => ({ ...e, i })).filter(e => !profilban.includes(e.i));

  const dobas = () => {
    if (dragolt === null || profilban.includes(dragolt)) return;
    setProfilban(prev => [...prev, dragolt]);
    setDragolt(null);
  };
  const visszavesz = (i) => { if (!ellenorzott) setProfilban(prev => prev.filter(x => x !== i)); };
  const ellenorzes = () => {
    const jo = feladat.elemek.every((e, i) => profilban.includes(i) === e.megjelenitheto);
    setHelyes(jo); setEllenorzott(true);
  };
  const ujra = () => { setProfilban([]); setEllenorzott(false); setHelyes(false); };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
      </div>
      <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', alignItems: 'start'}}>
        <div>
          <p style={{fontSize: '15px', fontWeight: '800', color: '#94a3b8', margin: '0 0 10px', textTransform: 'uppercase', letterSpacing: '0.5px'}}>Elemek</p>
          <div style={{background: '#f8fafc', borderRadius: '20px', padding: '1.25rem', border: `2px dashed ${szin}30`, minHeight: '260px', display: 'flex', flexWrap: 'wrap', gap: '10px', alignContent: 'flex-start'}}>
            {pool.map(e => (
              <div key={e.i} draggable={!ellenorzott} onDragStart={() => setDragolt(e.i)} className="k911-btn"
                style={{background: 'var(--bg-card)', border: `2px solid ${szin}30`, borderRadius: '16px', padding: '12px 18px', cursor: 'grab', fontSize: '17px', fontWeight: '800', color: '#2d3748', display: 'flex', alignItems: 'center', gap: '8px', boxShadow: `0 2px 8px ${szin}15`}}>
                <span style={{fontSize: '27px'}}>{e.kep}</span>{e.felirat}
              </div>
            ))}
            {pool.length === 0 && <p style={{color: '#94a3b8', fontWeight: '700', fontSize: '15px'}}>Minden elem elhelyezve.</p>}
          </div>
        </div>
        <div>
          <p style={{fontSize: '15px', fontWeight: '800', color: '#94a3b8', margin: '0 0 10px', textTransform: 'uppercase', letterSpacing: '0.5px'}}>A profilod</p>
          <div onDragOver={e => e.preventDefault()} onDrop={dobas}
            style={{background: 'var(--bg-card)', borderRadius: '18px', minHeight: '260px', border: `2px solid ${szin}20`, boxShadow: '0 8px 24px rgba(0,0,0,0.08)', overflow: 'hidden'}}>
            <div style={{height: '90px', background: `linear-gradient(120deg, ${szin}, #64b5f6, ${szin}cc)`, position: 'relative'}}>
              <div style={{position: 'absolute', bottom: '-32px', left: '20px', width: '72px', height: '72px', borderRadius: '50%', background: `linear-gradient(135deg, ${szin}, #64b5f6)`, border: '4px solid white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '32px', boxShadow: '0 4px 12px rgba(0,0,0,0.2)'}}>🕵️</div>
            </div>
            <div style={{padding: '44px 20px 20px'}}>
              <p style={{fontSize: '19px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 2px'}}>Agent X profilja</p>
              <p style={{fontSize: '14px', color: '#94a3b8', fontWeight: '700', margin: '0 0 14px'}}>📋 Intro / Bemutatkozás</p>
              <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                {profilban.map(i => {
                  const e = feladat.elemek[i];
                  const jo = ellenorzott && e.megjelenitheto;
                  const rossz = ellenorzott && !e.megjelenitheto;
                  return (
                    <div key={i} onClick={() => visszavesz(i)}
                      style={{background: jo ? '#e8f5e9' : rossz ? '#fce8e6' : '#f0f4f8', border: `2px solid ${jo ? '#34a853' : rossz ? '#ea4335' : `${szin}20`}`, borderRadius: '14px', padding: '10px 14px', fontSize: '16px', fontWeight: '800', color: '#2d3748', cursor: ellenorzott ? 'default' : 'pointer', display: 'flex', alignItems: 'center', gap: '8px'}}>
                      <span style={{fontSize: '21px'}}>{e.kep}</span>{e.felirat}
                      {ellenorzott && <span style={{marginLeft: 'auto'}}>{jo ? '✅' : '❌'}</span>}
                    </div>
                  );
                })}
                {profilban.length === 0 && <p style={{color: '#94a3b8', fontSize: '15px', fontWeight: '700'}}>Húzz ide elemeket a bal oldalról, hogy megjelenjenek a profilodon!</p>}
              </div>
            </div>
          </div>
        </div>
      </div>
      {ellenorzott && (
        <div className="k911-pop" style={{background: helyes ? '#e8f5e9' : '#fce8e6', border: `2px solid ${helyes ? '#34a853' : '#ea4335'}`, borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '21px', fontWeight: '900', color: helyes ? '#1e7e34' : '#c62828', margin: 0}}>{helyes ? feladat.visszajelzes_jo : feladat.visszajelzes_rossz}</p>
        </div>
      )}
      {ellenorzott && (
        <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
          {feladat.elemek.map((e, i) => {
            const bennVan = profilban.includes(i);
            const helyesE = bennVan === e.megjelenitheto;
            return (
              <p key={i} style={{fontSize: '15px', fontWeight: '700', color: helyesE ? '#1e7e34' : '#c62828', background: helyesE ? '#e8f5e9' : '#fce8e6', borderRadius: '10px', padding: '8px 14px', margin: 0}}>
                {helyesE ? '✅' : '❌'} {e.kep} {e.felirat}: {e.magyarazat}
              </p>
            );
          })}
        </div>
      )}
      {helyes && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      <div style={{display: 'flex', justifyContent: 'center'}}>
        {!ellenorzott ? (
          <button onClick={ellenorzes} className="k911-btn" style={{padding: '18px 48px', background: `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: `0 8px 24px ${szin}35`}}>✅ Kész vagyok</button>
        ) : helyes ? (
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        ) : (
          <button onClick={ujra} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(249,171,0,0.35)'}}>🔄 Próbáld újra!</button>
        )}
      </div>
    </div>
  );
}

// ============ PROFILVIZSGÁLÓ (sima profil, nagyító nélkül, piros villanás) ============
function ProfilVizsgalo({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1976d2';
  const [felfedve, setFelfedve] = useState([]);
  const celDarab = feladat.elemek.filter(e => e.gyanús).length;

  const kattint = (i, e) => {
    if (!e.gyanús || felfedve.includes(i)) return;
    const uj = [...felfedve, i];
    setFelfedve(uj);
    if (uj.length === celDarab) { /* várunk a gombra */ }
  };
  const kesz = felfedve.length === celDarab;

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
        <p style={{fontSize: '15px', color: szin, fontWeight: '800', marginTop: '8px'}}>{felfedve.length}/{celDarab} veszélyes adat megtalálva</p>
      </div>
      <div style={{background: `linear-gradient(160deg, #0f1f3d, #16264a)`, borderRadius: '28px', padding: '2rem', border: `2px solid ${szin}`, boxShadow: `0 0 30px ${szin}25`}}>
        <div style={{textAlign: 'center', marginBottom: '1.5rem'}}>
          <div style={{width: '80px', height: '80px', borderRadius: '50%', background: `linear-gradient(135deg, ${szin}, #64b5f6)`, margin: '0 auto 10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '38px', boxShadow: `0 0 18px ${szin}80`}}>{feladat.profilAvatar || '🦊'}</div>
          <p style={{color: 'white', fontWeight: '900', fontSize: '21px', margin: 0}}>{feladat.profilNev}</p>
        </div>
        <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center'}}>
          {feladat.elemek.map((e, i) => {
            const felfedettE = felfedve.includes(i);
            const kattinthato = e.gyanús && !felfedettE;
            return (
              <div key={i} onClick={() => kattint(i, e)} className={kattinthato ? 'nyomozo-elem' : felfedettE && e.gyanús ? 'piros-villan' : ''}
                style={{background: felfedettE ? (e.gyanús ? 'rgba(234,67,53,0.25)' : 'rgba(52,168,83,0.25)') : 'rgba(255,255,255,0.1)', border: `2px solid ${felfedettE ? (e.gyanús ? '#ea4335' : '#34a853') : 'rgba(255,255,255,0.25)'}`, borderRadius: '14px', padding: '10px 16px', fontSize: '16px', fontWeight: '800', color: 'white', cursor: kattinthato ? 'pointer' : 'default'}}>
                {felfedettE && <span style={{marginRight: '6px'}}>{e.gyanús ? '🚨' : '✅'}</span>}
                {e.szoveg}
              </div>
            );
          })}
        </div>
        {felfedve.length > 0 && (
          <div style={{marginTop: '1.25rem', display: 'flex', flexDirection: 'column', gap: '8px'}}>
            {felfedve.map(i => (
              <p key={i} style={{fontSize: '15px', fontWeight: '800', color: '#ffcdd2', margin: 0, background: 'rgba(234,67,53,0.15)', padding: '8px 12px', borderRadius: '10px'}}>🚨 {feladat.elemek[i].magyarazat}</p>
            ))}
          </div>
        )}
      </div>
      {kesz && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {kesz && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ AI VAGY EMBER (kép-mockupokkal) ============
function MiniIllusztracio({ tipus }) {
  const jelenetek = {
    kez6: (
      <svg viewBox="0 0 120 90" width="100%" height="100%">
        <rect width="120" height="90" fill="#fce4ec"/>
        <ellipse cx="60" cy="65" rx="26" ry="18" fill="#ffccbc"/>
        {[0,1,2,3,4,5].map(i => (
          <rect key={i} x={26 + i * 12} y={20} width="9" height="34" rx="4" fill="#ffccbc" stroke="#e57373" strokeWidth="1.5"/>
        ))}
      </svg>
    ),
    termeszet: (
      <svg viewBox="0 0 120 90" width="100%" height="100%">
        <rect width="120" height="90" fill="#bbdefb"/>
        <circle cx="95" cy="20" r="12" fill="#fff59d"/>
        <polygon points="0,90 35,35 60,65 80,40 120,90" fill="#81c784"/>
        <polygon points="20,90 45,50 70,90" fill="#66bb6a"/>
      </svg>
    ),
    kutya: (
      <svg viewBox="0 0 120 90" width="100%" height="100%">
        <rect width="120" height="90" fill="#dcedc8"/>
        <ellipse cx="60" cy="60" rx="28" ry="18" fill="#a1887f"/>
        <circle cx="38" cy="45" r="14" fill="#a1887f"/>
        <ellipse cx="30" cy="38" rx="6" ry="10" fill="#795548" transform="rotate(-30 30 38)"/>
        <ellipse cx="46" cy="38" rx="6" ry="10" fill="#795548" transform="rotate(20 46 38)"/>
      </svg>
    ),
    naplemente: (
      <svg viewBox="0 0 120 90" width="100%" height="100%">
        <rect width="120" height="90" fill="#ffe0b2"/>
        <circle cx="60" cy="55" r="20" fill="#ff8a65"/>
        <rect y="70" width="120" height="20" fill="#8d6e63" opacity="0.4"/>
      </svg>
    ),
    szoveg_ai: (
      <svg viewBox="0 0 120 90" width="100%" height="100%">
        <rect width="120" height="90" fill="#ede7f6"/>
        {[20, 34, 48, 62].map((y, i) => (
          <path key={i} d={`M14 ${y} Q 30 ${y - (i % 2 === 0 ? 6 : 2)}, 46 ${y} T 78 ${y} T 106 ${y}`} stroke="#7e57c2" strokeWidth="4" fill="none" strokeLinecap="round" opacity={i === 2 ? 0.35 : 0.8}/>
        ))}
      </svg>
    ),
    szoveg_ok: (
      <svg viewBox="0 0 120 90" width="100%" height="100%">
        <rect width="120" height="90" fill="#e0f2f1"/>
        {[20, 32, 44, 56, 68].map((y, i) => (
          <rect key={i} x="14" y={y} width={i === 4 ? 50 : 92} height="6" rx="3" fill="#26a69a" opacity="0.7"/>
        ))}
      </svg>
    ),
  };
  return jelenetek[tipus] || jelenetek.termeszet;
}

function AIVagyEmber({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1976d2';
  const [felfedve, setFelfedve] = useState([]);
  const celDarab = feladat.kepek.filter(k => k.ai).length;

  const kattint = (i, k) => {
    if (!k.ai || felfedve.includes(i)) return;
    const uj = [...felfedve, i];
    setFelfedve(uj);
    if (uj.length === celDarab) { /* várunk a gombra */ }
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
        <p style={{fontSize: '15px', color: szin, fontWeight: '800', marginTop: '8px'}}>{felfedve.length}/{celDarab} AI-kép megtalálva</p>
      </div>
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1.25rem'}}>
        {feladat.kepek.map((k, i) => {
          const felfedettE = felfedve.includes(i);
          const kattinthato = k.ai && !felfedettE;
          return (
            <div key={i} onClick={() => kattint(i, k)} className={kattinthato ? 'nyomozo-elem' : ''}
              style={{background: 'var(--bg-card)', border: `2.5px solid ${felfedettE ? (k.ai ? '#ea4335' : '#34a853') : `${szin}20`}`, borderRadius: '18px', overflow: 'hidden', cursor: kattinthato ? 'pointer' : 'default', boxShadow: '0 4px 14px rgba(0,0,0,0.08)'}}>
              <div style={{height: '130px', position: 'relative'}}>
                <MiniIllusztracio tipus={k.tipus}/>
                {felfedettE && <div style={{position: 'absolute', top: '8px', right: '8px', background: k.ai ? '#ea4335' : '#34a853', color: 'white', borderRadius: '50%', width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', boxShadow: '0 2px 8px rgba(0,0,0,0.3)'}}>{k.ai ? '🤖' : '✅'}</div>}
              </div>
              <div style={{padding: '12px 14px'}}>
                <p style={{fontSize: '15px', fontWeight: '700', color: '#2d3748', margin: 0}}>{k.leiras}</p>
                {felfedettE && <p style={{fontSize: '14px', fontWeight: '800', color: k.ai ? '#c62828' : '#1e7e34', margin: '6px 0 0'}}>{k.magyarazat}</p>}
              </div>
            </div>
          );
        })}
      </div>
      {felfedve.length === celDarab && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {felfedve.length === celDarab && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ GAMER CHAT SZOBA (chat-alkalmazás kinézettel) ============
function GamerChatSzoba({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1565c0';
  const [felfedve, setFelfedve] = useState([]);
  const celDarab = feladat.uzenetek.filter(u => u.gyanús).length;

  const kattint = (i, u) => {
    if (!u.gyanús || felfedve.includes(i)) return;
    const uj = [...felfedve, i];
    setFelfedve(uj);
    if (uj.length === celDarab) { /* várunk a gombra */ }
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
        <p style={{fontSize: '15px', color: szin, fontWeight: '800', marginTop: '8px'}}>{felfedve.length}/{celDarab} gyanús üzenet megtalálva</p>
      </div>
      <div style={{background: '#36393f', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 8px 24px rgba(0,0,0,0.2)'}}>
        <div style={{background: '#2f3136', padding: '14px 20px', display: 'flex', alignItems: 'center', gap: '10px'}}>
          <span style={{fontSize: '21px'}}>🎮</span>
          <p style={{color: 'white', fontWeight: '900', fontSize: '16px', margin: 0}}># gamer-lobby-chat</p>
        </div>
        <div style={{padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: '4px'}}>
          {feladat.uzenetek.map((u, i) => {
            const felfedettE = felfedve.includes(i);
            const kattinthato = u.gyanús && !felfedettE;
            return (
              <div key={i} onClick={() => kattint(i, u)} className={kattinthato ? 'nyomozo-elem' : ''}
                style={{display: 'flex', gap: '12px', padding: '8px 10px', borderRadius: '8px', cursor: kattinthato ? 'pointer' : 'default', background: felfedettE ? (u.gyanús ? 'rgba(234,67,53,0.2)' : 'rgba(52,168,83,0.2)') : 'transparent'}}>
                <div style={{width: '36px', height: '36px', borderRadius: '50%', background: `linear-gradient(135deg, ${szin}, #64b5f6)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0}}>{u.avatar || '🎮'}</div>
                <div style={{flex: 1}}>
                  <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    <p style={{color: felfedettE ? (u.gyanús ? '#f28b82' : '#81c995') : '#00b0f4', fontWeight: '800', fontSize: '15px', margin: 0}}>{u.nev}</p>
                    {felfedettE && <span style={{fontSize: '15px'}}>{u.gyanús ? '🚨' : '✅'}</span>}
                  </div>
                  <p style={{color: '#dcddde', fontSize: '16px', margin: '2px 0 0', lineHeight: 1.4}}>{u.uzenet}</p>
                  {felfedettE && <p style={{color: u.gyanús ? '#f28b82' : '#81c995', fontSize: '14px', fontWeight: '700', margin: '4px 0 0'}}>{u.magyarazat}</p>}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {felfedve.length === celDarab && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {felfedve.length === celDarab && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ EMAIL POSTAFIÓK (levelezőprogram kinézet) ============
function EmailPostafiok({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1565c0';
  const [felfedve, setFelfedve] = useState([]);
  const celDarab = feladat.emailek.filter(e => e.gyanús).length;

  const kattint = (i, e) => {
    if (!e.gyanús || felfedve.includes(i)) return;
    const uj = [...felfedve, i];
    setFelfedve(uj);
    if (uj.length === celDarab) { /* várunk a gombra */ }
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
        <p style={{fontSize: '15px', color: szin, fontWeight: '800', marginTop: '8px'}}>{felfedve.length}/{celDarab} gyanús email megtalálva</p>
      </div>
      <div style={{background: 'var(--bg-card)', borderRadius: '20px', border: `2px solid ${szin}20`, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.06)'}}>
        <div style={{background: '#f8fafc', padding: '14px 20px', borderBottom: `2px solid ${szin}15`, display: 'flex', alignItems: 'center', gap: '10px'}}>
          <span style={{fontSize: '23px'}}>📥</span>
          <p style={{fontSize: '16px', fontWeight: '900', color: '#2d3748', margin: 0}}>Beérkezett üzenetek</p>
        </div>
        {feladat.emailek.map((e, i) => {
          const felfedettE = felfedve.includes(i);
          const kattinthato = e.gyanús && !felfedettE;
          return (
            <div key={i} onClick={() => kattint(i, e)} className={kattinthato ? 'nyomozo-elem' : ''}
              style={{display: 'flex', alignItems: 'flex-start', gap: '12px', padding: '14px 20px', borderBottom: `1px solid ${szin}10`, cursor: kattinthato ? 'pointer' : 'default', background: felfedettE ? (e.gyanús ? '#fce8e6' : '#e8f5e9') : 'var(--bg-card)'}}>
              <div style={{width: '38px', height: '38px', borderRadius: '50%', background: felfedettE ? (e.gyanús ? '#ea4335' : '#34a853') : `${szin}20`, color: felfedettE ? 'white' : szin, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', fontWeight: '900', flexShrink: 0}}>
                {felfedettE ? (e.gyanús ? '🚨' : '✅') : e.feladoNev.charAt(0).toUpperCase()}
              </div>
              <div style={{flex: 1, minWidth: 0}}>
                <div style={{display: 'flex', justifyContent: 'space-between', gap: '8px'}}>
                  <p style={{fontSize: '16px', fontWeight: '900', color: '#2d3748', margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{e.feladoNev}</p>
                  <span style={{fontSize: '13px', color: '#94a3b8', fontWeight: '700', flexShrink: 0}}>{e.ido}</span>
                </div>
                <p style={{fontSize: '15px', fontWeight: '800', color: '#2d3748', margin: '2px 0'}}>{e.targy}</p>
                <p style={{fontSize: '14px', color: '#94a3b8', margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{e.elonezet}</p>
                {felfedettE && <p style={{fontSize: '14px', fontWeight: '800', color: e.gyanús ? '#c62828' : '#1e7e34', margin: '6px 0 0'}}>{e.gyanús ? '🚨' : '✅'} {e.magyarazat}</p>}
              </div>
            </div>
          );
        })}
      </div>
      {felfedve.length === celDarab && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {felfedve.length === celDarab && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ QR-KÓD VIZSGÁLÓ (vizuális QR-mintákkal) ============
function QRKodVizsgalo({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1565c0';
  const [felfedve, setFelfedve] = useState([]);
  const celDarab = feladat.kodok.filter(k => k.rossz).length;
  const mintak = useState(() => feladat.kodok.map(() => Array.from({ length: 25 }, () => Math.random() > 0.45)))[0];

  const kattint = (i, k) => {
    if (!k.rossz || felfedve.includes(i)) return;
    const uj = [...felfedve, i];
    setFelfedve(uj);
    if (uj.length === celDarab) { /* várunk a gombra */ }
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
        <p style={{fontSize: '15px', color: szin, fontWeight: '800', marginTop: '8px'}}>{felfedve.length}/{celDarab} rossz QR-kód megtalálva</p>
      </div>
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '1.25rem'}}>
        {feladat.kodok.map((k, i) => {
          const felfedettE = felfedve.includes(i);
          const kattinthato = k.rossz && !felfedettE;
          return (
            <div key={i} onClick={() => kattint(i, k)} className={kattinthato ? 'nyomozo-elem' : ''}
              style={{background: felfedettE ? (k.rossz ? '#fce8e6' : '#e8f5e9') : 'var(--bg-card)', border: `2.5px solid ${felfedettE ? (k.rossz ? '#ea4335' : '#34a853') : `${szin}20`}`, borderRadius: '18px', padding: '1.25rem', textAlign: 'center', cursor: kattinthato ? 'pointer' : 'default'}}>
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '2px', width: '90px', margin: '0 auto 10px', background: 'white', padding: '6px', borderRadius: '8px', border: '2px solid #1a1a2e'}}>
                {mintak[i].map((fekete, j) => <div key={j} style={{aspectRatio: '1', background: fekete ? '#1a1a2e' : 'white'}}/>)}
              </div>
              <p style={{fontSize: '15px', fontWeight: '700', color: '#2d3748', margin: 0}}>{k.leiras}</p>
              {felfedettE && <p style={{fontSize: '14px', fontWeight: '800', color: k.rossz ? '#c62828' : '#1e7e34', marginTop: '8px'}}>{k.magyarazat}</p>}
            </div>
          );
        })}
      </div>
      {felfedve.length === celDarab && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {felfedve.length === celDarab && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ DIGITÁLIS TÜKÖR (karakter + beszéd-buborékok) ============
function DigitalisTukor({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1976d2';
  const korok = feladat.korok || [{ kerdes: feladat.kerdes, valaszok: feladat.valaszok }];
  const [korIndex, setKorIndex] = useState(0);
  const [kivalasztott, setKivalasztott] = useState(null);
  const kor = korok[korIndex];
  const helyes = kivalasztott !== null && kor.valaszok[kivalasztott]?.helyes;
  const karakterNelkul = feladat.karakterNelkul;

  const valaszt = (i) => { if (kivalasztott === null) setKivalasztott(i); };
  const tovabb = () => {
    if (korIndex + 1 < korok.length) { setKorIndex(k => k + 1); setKivalasztott(null); }
    else onKesz();
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem'}}>
          <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>{feladat.cim}</p>
          {korok.length > 1 && <span style={{fontSize: '15px', fontWeight: '900', color: szin, background: `${szin}12`, padding: '5px 14px', borderRadius: '50px'}}>{korIndex + 1}/{korok.length}</span>}
        </div>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{kor.kerdes}</p>
      </div>
      <div style={{display: 'flex', gap: '1.5rem', alignItems: 'center', flexWrap: 'wrap'}}>
        {!karakterNelkul && (
          <div style={{flexShrink: 0, textAlign: 'center'}}>
            <div style={{width: '110px', height: '110px', borderRadius: '50%', background: `linear-gradient(135deg, ${szin}, #64b5f6)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '54px', margin: '0 auto', animation: 'pulzal911 2.5s ease-in-out infinite', boxShadow: `0 0 24px ${szin}50`}}>🕵️</div>
            <p style={{fontSize: '15px', fontWeight: '800', color: '#94a3b8', marginTop: '8px'}}>Agent X</p>
          </div>
        )}
        <div style={{flex: 1, minWidth: '260px', display: 'flex', flexDirection: 'column', gap: '0.9rem'}}>
          {kor.valaszok.map((v, i) => {
            const kiv = kivalasztott === i;
            const jo = kivalasztott !== null && v.helyes;
            const rossz = kivalasztott !== null && kiv && !v.helyes;
            return (
              <div key={i} onClick={() => valaszt(i)} className="k911-valasz"
                style={{position: 'relative', background: jo && kiv ? '#e8f5e9' : rossz ? '#fce8e6' : 'var(--bg-card)', border: `2.5px solid ${jo && kiv ? '#34a853' : rossz ? '#ea4335' : `${szin}20`}`, borderRadius: '20px', borderTopLeftRadius: karakterNelkul ? '20px' : '4px', padding: '1.3rem 1.7rem', cursor: kivalasztott === null ? 'pointer' : 'default'}}>
                {!karakterNelkul && <div style={{position: 'absolute', top: '-9px', left: '20px', width: '14px', height: '14px', background: 'inherit', borderTop: `2.5px solid ${jo && kiv ? '#34a853' : rossz ? '#ea4335' : `${szin}20`}`, borderLeft: `2.5px solid ${jo && kiv ? '#34a853' : rossz ? '#ea4335' : `${szin}20`}`, transform: 'rotate(45deg)', backgroundColor: jo && kiv ? '#e8f5e9' : rossz ? '#fce8e6' : 'var(--bg-card)'}}/>}
                <p style={{fontSize: '22px', fontWeight: '700', color: '#2d3748', margin: 0, lineHeight: 1.5}}>{v.szoveg}</p>
                {kivalasztott !== null && kiv && <p style={{fontSize: '15px', fontWeight: '800', color: jo ? '#1e7e34' : '#c62828', margin: '8px 0 0'}}>{v.magyarazat}</p>}
              </div>
            );
          })}
        </div>
      </div>
      {kivalasztott !== null && !helyes && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={() => setKivalasztott(null)} className="k911-btn" style={{padding: '14px 36px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '17px', fontWeight: '800', cursor: 'pointer'}}>🔄 Próbáld újra!</button>
        </div>
      )}
      {helyes && korIndex === korok.length - 1 && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {helyes && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={tovabb} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>{korIndex + 1 < korok.length ? 'Következő! →' : 'Tovább! 🚀'}</button>
        </div>
      )}
    </div>
  );
}

// ============ MEMÓRIA (fogalom-párosítós) ============
function MemoriaFeladat({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1976d2';
  const [megtalalt, setMegtalalt] = useState([]);
  const [felfedett, setFelfedett] = useState([]);
  const [elso, setElso] = useState(null);
  const [blokkolt, setBlokkolt] = useState(false);

  const kartyak = useState(() => {
    const osszes = feladat.parok.flatMap((p, i) => [
      { id: `a${i}`, tartalom: p.a, par: i },
      { id: `b${i}`, tartalom: p.b, par: i },
    ]);
    return osszes.sort(() => Math.random() - 0.5);
  })[0];

  const kattint = (kartya) => {
    if (blokkolt || felfedett.includes(kartya.id) || megtalalt.some(m => m.includes(kartya.id))) return;
    const uj = [...felfedett, kartya.id];
    setFelfedett(uj);
    if (!elso) { setElso(kartya); return; }
    if (elso.par === kartya.par && elso.id !== kartya.id) {
      const ujMegtalalt = [...megtalalt, [elso.id, kartya.id]];
      setMegtalalt(ujMegtalalt);
      setElso(null); setFelfedett([]);
      if (ujMegtalalt.length === feladat.parok.length) { /* várunk a gombra */ }
    } else {
      setBlokkolt(true);
      setTimeout(() => { setFelfedett([]); setElso(null); setBlokkolt(false); }, 900);
    }
  };

  const megtalaltIds = megtalalt.flat();

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '0.5rem'}}>
          <div style={{fontSize: '46px'}}>🧠</div>
          <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>{feladat.cim}</p>
        </div>
        <p style={{fontSize: '18px', color: '#64748b', margin: 0, fontWeight: '600'}}>Keresd meg az összetartozó párokat!</p>
        <p style={{fontSize: '15px', color: szin, fontWeight: '800', marginTop: '8px'}}>{megtalalt.length}/{feladat.parok.length} pár megtalálva</p>
      </div>
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px'}}>
        {kartyak.map(k => {
          const latszik = felfedett.includes(k.id) || megtalaltIds.includes(k.id);
          const megvan = megtalaltIds.includes(k.id);
          return (
            <div key={k.id} onClick={() => kattint(k)}
              style={{height: '96px', borderRadius: '18px', cursor: latszik ? 'default' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: latszik ? '16px' : '30px', fontWeight: '800', textAlign: 'center', padding: '8px', transition: 'all 0.25s', background: megvan ? '#e8f5e9' : latszik ? 'var(--bg-card)' : `linear-gradient(135deg, ${szin}, ${szin}cc)`, border: `2.5px solid ${megvan ? '#34a853' : latszik ? `${szin}40` : szin}`, color: latszik ? '#2d3748' : 'white'}}>
              {latszik ? k.tartalom : '❓'}
            </div>
          );
        })}
      </div>
      {megtalalt.length === feladat.parok.length && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {megtalalt.length === feladat.parok.length && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ PÁROSÍTÓ ============
function ParositoFeladat({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1976d2';
  const jobbOldal = useState(() => feladat.parok.map((p, i) => ({ szoveg: p.b, i })).sort(() => Math.random() - 0.5))[0];
  const [balValasztott, setBalValasztott] = useState(null);
  const [kesz, setKesz] = useState([]);
  const [hiba, setHiba] = useState(null);

  const balKattint = i => { if (!kesz.includes(i)) setBalValasztott(i); };
  const jobbKattint = jobbElem => {
    if (balValasztott === null || kesz.includes(balValasztott)) return;
    if (jobbElem.i === balValasztott) {
      const uj = [...kesz, balValasztott];
      setKesz(uj); setBalValasztott(null);
      if (uj.length === feladat.parok.length) { /* várunk a gombra */ }
    } else {
      setHiba(jobbElem.i);
      setTimeout(() => setHiba(null), 500);
      setBalValasztott(null);
    }
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '0.5rem'}}>
          <div style={{fontSize: '46px'}}>🔗</div>
          <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>{feladat.cim}</p>
        </div>
        <p style={{fontSize: '18px', color: '#64748b', margin: 0, fontWeight: '600'}}>Koppints egy fogalomra balra, majd a hozzá tartozóra jobbra!</p>
      </div>
      <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem'}}>
        <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
          {feladat.parok.map((p, i) => (
            <div key={i} onClick={() => balKattint(i)}
              style={{padding: '1.1rem 1.25rem', borderRadius: '16px', fontSize: '17px', fontWeight: '800', cursor: kesz.includes(i) ? 'default' : 'pointer',
                background: kesz.includes(i) ? '#e8f5e9' : balValasztott === i ? `${szin}20` : 'var(--bg-card)',
                border: `2.5px solid ${kesz.includes(i) ? '#34a853' : balValasztott === i ? szin : `${szin}20`}`, color: '#2d3748'}}>
              {p.a}
            </div>
          ))}
        </div>
        <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
          {jobbOldal.map((jobbElem, idx) => (
            <div key={idx} onClick={() => jobbKattint(jobbElem)}
              style={{padding: '1.1rem 1.25rem', borderRadius: '16px', fontSize: '17px', fontWeight: '800', cursor: kesz.includes(jobbElem.i) ? 'default' : 'pointer',
                background: kesz.includes(jobbElem.i) ? '#e8f5e9' : hiba === jobbElem.i ? '#fce8e6' : 'var(--bg-card)',
                border: `2.5px solid ${kesz.includes(jobbElem.i) ? '#34a853' : hiba === jobbElem.i ? '#ea4335' : `${szin}20`}`, color: '#2d3748'}}>
              {jobbElem.szoveg}
            </div>
          ))}
        </div>
      </div>
      {kesz.length === feladat.parok.length && (
        <div style={{background: '#e8f5e9', border: '2px solid #34a853', borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '21px', fontWeight: '900', color: '#1e7e34', margin: 0}}>🎉 Minden pár összekötve!</p>
        </div>
      )}
      {kesz.length === feladat.parok.length && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {kesz.length === feladat.parok.length && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ IDŐRE MENŐ KIHÍVÁS ============
function IdoreMenoFeladat({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1976d2';
  const IDOKERET = feladat.masodperc || 30;
  const [hatra, setHatra] = useState(IDOKERET);
  const [kivalasztott, setKivalasztott] = useState([]);
  const [vege, setVege] = useState(null);

  useEffect(() => {
    if (vege) return;
    if (hatra <= 0) { setVege('vesztett'); return; }
    const t = setTimeout(() => setHatra(h => h - 1), 1000);
    return () => clearTimeout(t);
  }, [hatra, vege]);

  const kattint = (i) => {
    if (vege || kivalasztott.includes(i)) return;
    const elem = feladat.elemek[i];
    if (!elem.cel) return;
    const uj = [...kivalasztott, i];
    setKivalasztott(uj);
    if (uj.length === feladat.elemek.filter(e => e.cel).length) setTimeout(() => { setVege('nyert'); }, 300);
  };

  const celDarab = feladat.elemek.filter(e => e.cel).length;

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '0.5rem'}}>
          <div style={{fontSize: '46px'}}>⏱️</div>
          <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>{feladat.cim}</p>
        </div>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
        <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px'}}>
          <div style={{flex: 1, background: '#f0f4f8', borderRadius: '10px', height: '12px', overflow: 'hidden'}}>
            <div style={{width: `${(hatra / IDOKERET) * 100}%`, height: '100%', background: hatra <= 10 ? '#ea4335' : szin, transition: 'width 1s linear'}}/>
          </div>
          <span style={{fontSize: '21px', fontWeight: '900', color: hatra <= 10 ? '#ea4335' : szin, minWidth: '40px'}}>{hatra}s</span>
        </div>
      </div>
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '1rem'}}>
        {feladat.elemek.map((e, i) => {
          const kiv = kivalasztott.includes(i);
          return (
            <div key={i} onClick={() => kattint(i)}
              style={{padding: '1.25rem 1rem', borderRadius: '18px', textAlign: 'center', cursor: vege || kiv ? 'default' : 'pointer',
                background: kiv ? '#e8f5e9' : 'var(--bg-card)', border: `2.5px solid ${kiv ? '#34a853' : `${szin}20`}`, opacity: vege === 'vesztett' && !kiv ? 0.5 : 1}}>
              <p style={{fontSize: '19px', fontWeight: '800', color: '#2d3748', margin: 0}}>{e.szoveg}</p>
              {kiv && <span style={{fontSize: '21px'}}>✅</span>}
            </div>
          );
        })}
      </div>
      {vege === 'nyert' && (
        <div style={{background: '#e8f5e9', border: '2px solid #34a853', borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '21px', fontWeight: '900', color: '#1e7e34', margin: 0}}>⚡ Szuper! Időben megtaláltad mind a {celDarab}-at!</p>
        </div>
      )}
      {vege === 'vesztett' && (
        <div style={{background: '#fff8e1', border: '2px solid #f9ab00', borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '21px', fontWeight: '900', color: '#a86200', margin: '0 0 1rem'}}>⏰ Lejárt az idő! Próbáld újra!</p>
          <button onClick={() => { setHatra(IDOKERET); setKivalasztott([]); setVege(null); }} className="k911-btn"
            style={{padding: '14px 36px', background: `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: 'white', border: 'none', borderRadius: '50px', fontSize: '17px', fontWeight: '800', cursor: 'pointer'}}>
            🔄 Újra!
          </button>
        </div>
      )}
      {vege === 'nyert' && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {vege === 'nyert' && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ PUZZLE (kép-felfedő) ============
function PuzzleFeladat({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1976d2';
  const oszlopok = feladat.oszlopok || 4;
  const darab = feladat.darabszam || 16;
  const tray = useState(() => Array.from({ length: darab }, (_, i) => i).sort(() => Math.random() - 0.5))[0];
  const [helyre, setHelyre] = useState({});
  const [dragolt, setDragolt] = useState(null);
  const [hiba, setHiba] = useState(null);
  const kesz = Object.keys(helyre).length === darab;

  const dobas = (celPoz) => {
    if (dragolt === null || helyre[celPoz] !== undefined) return;
    if (dragolt === celPoz) {
      const uj = { ...helyre, [celPoz]: dragolt };
      setHelyre(uj);
      setDragolt(null);
      if (Object.keys(uj).length === darab) { /* várunk a gombra */ }
    } else {
      setHiba(celPoz);
      setTimeout(() => setHiba(null), 500);
      setDragolt(null);
    }
  };

  const trayMost = tray.filter(t => !Object.values(helyre).includes(t));

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '0.5rem'}}>
          <div style={{fontSize: '46px'}}>🧩</div>
          <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>{feladat.cim}</p>
        </div>
        <p style={{fontSize: '18px', color: '#64748b', margin: 0, fontWeight: '600'}}>Húzd a lenti számozott darabokat a rácson a HELYES pozíciójukba!</p>
        <p style={{fontSize: '15px', color: szin, fontWeight: '800', marginTop: '8px'}}>{Object.keys(helyre).length}/{darab} darab a helyén</p>
      </div>
      <div style={{position: 'relative', borderRadius: '24px', overflow: 'hidden', boxShadow: '0 8px 32px rgba(0,0,0,0.15)'}}>
        <div style={{position: 'absolute', inset: 0, background: `linear-gradient(135deg, ${szin}35, ${szin}15)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '110px'}}>
          {feladat.kepEmoji || '🕵️'}
        </div>
        <div style={{position: 'relative', display: 'grid', gridTemplateColumns: `repeat(${oszlopok}, 1fr)`, gap: '4px', padding: '4px'}}>
          {Array.from({ length: darab }, (_, poz) => {
            const van = helyre[poz] !== undefined;
            return (
              <div key={poz} onDragOver={e => e.preventDefault()} onDrop={() => dobas(poz)}
                style={{height: `${280 / oszlopok}px`, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  background: van ? 'transparent' : hiba === poz ? 'rgba(234,67,53,0.5)' : `${szin}55`,
                  border: van ? 'none' : `2px dashed ${hiba === poz ? '#ea4335' : 'rgba(255,255,255,0.5)'}`,
                  color: 'white', fontSize: '25px', fontWeight: '900', transition: 'all 0.3s'}}>
                {!van && (poz + 1)}
              </div>
            );
          })}
        </div>
      </div>
      <div>
        <p style={{fontSize: '15px', fontWeight: '800', color: '#94a3b8', margin: '0 0 10px', textTransform: 'uppercase', letterSpacing: '0.5px'}}>Darabok</p>
        <div style={{background: '#f8fafc', borderRadius: '18px', padding: '1.25rem', border: `2px dashed ${szin}30`, minHeight: '70px', display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center'}}>
          {trayMost.map(t => (
            <div key={t} draggable onDragStart={() => setDragolt(t)} className="k911-btn"
              style={{width: '52px', height: '52px', borderRadius: '12px', background: `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: 'white', fontSize: '21px', fontWeight: '900', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'grab', boxShadow: `0 3px 10px ${szin}40`}}>
              {t + 1}
            </div>
          ))}
          {trayMost.length === 0 && <p style={{color: '#34a853', fontWeight: '800', fontSize: '15px', margin: 0}}>✅ Minden darab elhelyezve!</p>}
        </div>
      </div>
      {kesz && (
        <div style={{background: '#e8f5e9', border: '2px solid #34a853', borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '23px', fontWeight: '900', color: '#1e7e34', margin: 0}}>🎉 Összeraktad! Szuper voltál!</p>
        </div>
      )}
      {kesz && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {kesz && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ JELSZÓÉPÍTŐ (kattintással, élő erősségmérő) ============
function JelszoEpito2({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#0d47a1';
  const [kivalasztott, setKivalasztott] = useState([]);
  const kesz = feladat.kotelezok.every(k => kivalasztott.includes(k));
  const szazalek = Math.round((kivalasztott.filter(k => feladat.kotelezok.includes(k)).length / feladat.kotelezok.length) * 100);
  const szin_csik = szazalek < 40 ? '#ea4335' : szazalek < 100 ? '#f9ab00' : '#34a853';

  const valaszt = (opt) => { if (!kivalasztott.includes(opt.id)) setKivalasztott(prev => [...prev, opt.id]); };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
      </div>
      <div style={{background: `linear-gradient(160deg, #0f1f3d, #16264a)`, borderRadius: '24px', padding: '2rem', border: `2px solid ${szin}`}}>
        <div style={{background: 'rgba(255,255,255,0.08)', borderRadius: '16px', padding: '1.25rem', textAlign: 'center', marginBottom: '1.25rem', minHeight: '54px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <p style={{color: 'white', fontSize: '25px', fontWeight: '900', letterSpacing: '2px', margin: 0, fontFamily: 'monospace'}}>{kivalasztott.map(id => feladat.opciok.find(o => o.id === id)?.jel).join('') || '••••••'}</p>
        </div>
        <div style={{background: 'rgba(255,255,255,0.15)', borderRadius: '10px', height: '16px', overflow: 'hidden', marginBottom: '1.5rem'}}>
          <div style={{width: `${szazalek}%`, height: '100%', background: szin_csik, transition: 'width 0.4s, background 0.4s'}}/>
        </div>
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '1rem'}}>
          {feladat.opciok.map(o => {
            const kiv = kivalasztott.includes(o.id);
            return (
              <div key={o.id} onClick={() => valaszt(o)} className="k911-valasz"
                style={{background: kiv ? 'rgba(52,168,83,0.2)' : 'rgba(255,255,255,0.08)', border: `2px solid ${kiv ? '#34a853' : 'rgba(255,255,255,0.25)'}`, borderRadius: '16px', padding: '1.25rem', textAlign: 'center', cursor: kiv ? 'default' : 'pointer'}}>
                <div style={{fontSize: '29px', marginBottom: '4px'}}>{o.emoji}</div>
                <p style={{color: 'white', fontSize: '15px', fontWeight: '800', margin: 0}}>{o.felirat}</p>
              </div>
            );
          })}
        </div>
      </div>
      {kesz && (
        <div style={{background: '#e8f5e9', border: '2px solid #34a853', borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '21px', fontWeight: '900', color: '#1e7e34', margin: 0}}>🔓 A lakat kinyílt! Erős jelszót építettél!</p>
        </div>
      )}
      {kesz && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {kesz && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ ERŐSSÉGMÉRŐ ============
function ErosessegMero({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#0d47a1';
  const [index, setIndex] = useState(0);
  const [csik, setCsik] = useState(0);
  const [mutatva, setMutatva] = useState(false);
  const jelszo = feladat.jelszavak[index];

  useEffect(() => {
    setCsik(0); setMutatva(false);
    const t = setTimeout(() => { setCsik(jelszo.erosseg); setMutatva(true); }, 300);
    return () => clearTimeout(t);
  }, [index]);

  const tovabb = () => {
    if (index + 1 < feladat.jelszavak.length) setIndex(i => i + 1);
    else onKesz();
  };
  const szin_csik = csik < 40 ? '#ea4335' : csik < 75 ? '#f9ab00' : '#34a853';
  const cimke = csik < 40 ? '🟥 Gyenge' : csik < 75 ? '🟨 Közepes' : '🟩 Erős';

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
        <p style={{fontSize: '15px', color: szin, fontWeight: '800', marginTop: '8px'}}>{index + 1}/{feladat.jelszavak.length}</p>
      </div>
      <div style={{background: `linear-gradient(160deg, #0f1f3d, #16264a)`, borderRadius: '24px', padding: '2rem', border: `2px solid ${szin}`, textAlign: 'center'}}>
        <p style={{color: 'white', fontSize: '29px', fontWeight: '900', fontFamily: 'monospace', margin: '0 0 1.25rem'}}>{jelszo.jelszo}</p>
        <div style={{background: 'rgba(255,255,255,0.15)', borderRadius: '12px', height: '22px', overflow: 'hidden', marginBottom: '1rem'}}>
          <div style={{width: `${csik}%`, height: '100%', background: szin_csik, transition: 'width 1s ease-out'}}/>
        </div>
        {mutatva && <p style={{fontSize: '23px', fontWeight: '900', color: 'white', margin: 0}}>{cimke}</p>}
        {mutatva && <p style={{fontSize: '15px', color: 'rgba(255,255,255,0.7)', fontWeight: '700', marginTop: '8px'}}>{jelszo.magyarazat}</p>}
      </div>
      {mutatva && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={tovabb} className="k911-btn" style={{padding: '18px 48px', background: `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>{index + 1 < feladat.jelszavak.length ? 'Következő jelszó →' : 'Tovább! 🚀'}</button>
        </div>
      )}
      {mutatva && index === feladat.jelszavak.length - 1 && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
    </div>
  );
}

// ============ LAKATNYITÓ (sorrend kattintással) ============
function LakatNyito({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#0d47a1';
  const opciok = useState(() => feladat.lepesek.map((l, i) => ({ ...l, i })).sort(() => Math.random() - 0.5))[0];
  const [kesz, setKesz] = useState([]);
  const [hiba, setHiba] = useState(null);
  const [nyitva, setNyitva] = useState(false);

  const kattint = (l) => {
    if (l.sorrend !== kesz.length + 1) { setHiba(l.i); setTimeout(() => setHiba(null), 500); return; }
    const uj = [...kesz, l.i];
    setKesz(uj);
    if (uj.length === feladat.lepesek.length) { setNyitva(true); }
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
      </div>
      <div style={{background: `linear-gradient(160deg, #0f1f3d, #16264a)`, borderRadius: '24px', padding: '2rem', border: `2px solid ${szin}`, textAlign: 'center'}}>
        <div style={{fontSize: '64px', marginBottom: '1.25rem', transition: 'transform 0.4s', transform: nyitva ? 'rotate(-15deg) scale(1.2)' : 'none'}}>{nyitva ? '🔓' : '🔒'}</div>
        <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
          {opciok.map(l => {
            const van_kesz = kesz.includes(l.i);
            return (
              <div key={l.i} onClick={() => !van_kesz && kattint(l)}
                style={{background: van_kesz ? 'rgba(52,168,83,0.25)' : hiba === l.i ? 'rgba(234,67,53,0.25)' : 'rgba(255,255,255,0.08)', border: `2px solid ${van_kesz ? '#34a853' : hiba === l.i ? '#ea4335' : 'rgba(255,255,255,0.25)'}`, borderRadius: '14px', padding: '14px 18px', color: 'white', fontWeight: '800', fontSize: '17px', cursor: van_kesz ? 'default' : 'pointer'}}>
                {van_kesz && <span style={{marginRight: '8px'}}>{l.sorrend}.</span>}{l.szoveg}
              </div>
            );
          })}
        </div>
      </div>
      {nyitva && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {nyitva && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ EGYSZERŰSÍTETT KERESZTREJTVÉNY ============
function Keresztrejtveny({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#0d47a1';
  const [aktivIndex, setAktivIndex] = useState(null);
  const [kitoltott, setKitoltott] = useState({});

  const valaszt = (opt) => {
    if (aktivIndex === null) return;
    const helyes = feladat.szavak[aktivIndex].szo;
    if (opt === helyes) {
      const uj = { ...kitoltott, [aktivIndex]: opt };
      setKitoltott(uj); setAktivIndex(null);
      if (Object.keys(uj).length === feladat.szavak.length) { /* várunk a gombra */ }
    } else {
      setAktivIndex(null);
    }
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '18px', color: '#64748b', margin: 0, fontWeight: '600'}}>Kattints egy sorra, majd válaszd ki, melyik szó illik a meghatározáshoz!</p>
      </div>
      <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
        {feladat.szavak.map((s, i) => {
          const van_kesz = kitoltott[i];
          return (
            <div key={i}>
              <div onClick={() => !van_kesz && setAktivIndex(i)}
                style={{display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 18px', borderRadius: '14px', cursor: van_kesz ? 'default' : 'pointer', background: van_kesz ? '#e8f5e9' : aktivIndex === i ? `${szin}15` : 'var(--bg-card)', border: `2px solid ${van_kesz ? '#34a853' : aktivIndex === i ? szin : `${szin}20`}`}}>
                <span style={{width: '28px', height: '28px', borderRadius: '50%', background: szin, color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', fontWeight: '900', flexShrink: 0}}>{i + 1}</span>
                <p style={{margin: 0, fontWeight: '700', color: '#2d3748', flex: 1}}>{s.definicio}</p>
                {van_kesz && <span style={{fontWeight: '900', color: '#34a853', fontFamily: 'monospace', letterSpacing: '2px'}}>{s.szo}</span>}
              </div>
              {aktivIndex === i && (
                <div style={{display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '8px', paddingLeft: '40px'}}>
                  {s.opciok.map((o, j) => (
                    <button key={j} onClick={() => valaszt(o)} className="k911-btn" style={{padding: '8px 18px', borderRadius: '10px', border: `2px solid ${szin}30`, background: 'var(--bg-card)', fontWeight: '800', fontSize: '15px', cursor: 'pointer', fontFamily: 'monospace'}}>{o}</button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
      {Object.keys(kitoltott).length === feladat.szavak.length && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {Object.keys(kitoltott).length === feladat.szavak.length && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ ÉRZELEMFELISMERŐ ============
function ErzelemFelismero({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1976d2';
  const korok = feladat.korok || [{ kerdes: feladat.kerdes, opciok: feladat.opciok }];
  const [korIndex, setKorIndex] = useState(0);
  const [kivalasztott, setKivalasztott] = useState(null);
  const kor = korok[korIndex];
  const helyes = kivalasztott !== null && kor.opciok[kivalasztott]?.helyes;

  const tovabb = () => {
    if (korIndex + 1 < korok.length) { setKorIndex(k => k + 1); setKivalasztott(null); }
    else onKesz();
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem'}}>
          <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>{feladat.cim}</p>
          {korok.length > 1 && <span style={{fontSize: '15px', fontWeight: '900', color: szin, background: `${szin}12`, padding: '5px 14px', borderRadius: '50px'}}>{korIndex + 1}/{korok.length}</span>}
        </div>
        <p style={{fontSize: '18px', color: '#2d3748', fontWeight: '700', margin: 0}}>{kor.kerdes}</p>
      </div>
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: '1rem'}}>
        {kor.opciok.map((o, i) => {
          const kiv = kivalasztott === i;
          const jo = kivalasztott !== null && o.helyes;
          const rossz = kivalasztott !== null && kiv && !o.helyes;
          return (
            <div key={i} onClick={() => kivalasztott === null && setKivalasztott(i)} className="k911-valasz"
              style={{textAlign: 'center', padding: '1.5rem 1rem', borderRadius: '20px', cursor: kivalasztott === null ? 'pointer' : 'default', background: jo && kiv ? '#e8f5e9' : rossz ? '#fce8e6' : 'var(--bg-card)', border: `2.5px solid ${jo && kiv ? '#34a853' : rossz ? '#ea4335' : `${szin}20`}`}}>
              <div style={{fontSize: '48px'}}>{o.emoji}</div>
              <p style={{fontSize: '15px', fontWeight: '800', color: '#2d3748', marginTop: '6px'}}>{o.felirat}</p>
            </div>
          );
        })}
      </div>
      {kivalasztott !== null && (
        <div className="k911-pop" style={{background: helyes ? '#e8f5e9' : '#fce8e6', border: `2px solid ${helyes ? '#34a853' : '#ea4335'}`, borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '18px', fontWeight: '900', color: helyes ? '#1e7e34' : '#c62828', margin: 0}}>{kor.opciok[kivalasztott].magyarazat}</p>
        </div>
      )}
      {helyes && korIndex === korok.length - 1 && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      <div style={{display: 'flex', justifyContent: 'center'}}>
        {kivalasztott !== null && (helyes ? (
          <button onClick={tovabb} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>{korIndex + 1 < korok.length ? 'Következő! →' : 'Tovább! 🚀'}</button>
        ) : (
          <button onClick={() => setKivalasztott(null)} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>🔄 Próbáld újra!</button>
        ))}
      </div>
    </div>
  );
}

// ============ SEGÍTSÉGKÉRŐ ÚTVONAL (folyamatábra) ============
function SegitsegUtvonal({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1976d2';
  const [kivalasztott, setKivalasztott] = useState(null);

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.75rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '21px', color: '#2d3748', fontWeight: '700', margin: 0}}>{feladat.kerdes}</p>
      </div>
      <div style={{textAlign: 'center'}}>
        <div style={{display: 'inline-block', background: szin, color: 'white', padding: '12px 24px', borderRadius: '16px', fontWeight: '900', fontSize: '17px'}}>😟 Bajban vagyok</div>
        <div style={{width: '2px', height: '28px', background: `${szin}40`, margin: '0 auto'}}/>
      </div>
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '1rem'}}>
        {feladat.opciok.map((o, i) => {
          const kiv = kivalasztott === i;
          return (
            <div key={i} onClick={() => setKivalasztott(i)} className="k911-valasz"
              style={{textAlign: 'center', padding: '1.25rem 1rem', borderRadius: '18px', cursor: 'pointer', background: kiv ? (o.helyes ? '#e8f5e9' : '#fce8e6') : 'var(--bg-card)', border: `2.5px solid ${kiv ? (o.helyes ? '#34a853' : '#ea4335') : `${szin}20`}`}}>
              <div style={{fontSize: '36px'}}>{o.emoji}</div>
              <p style={{fontSize: '16px', fontWeight: '800', color: '#2d3748', margin: '6px 0 0'}}>{o.felirat}</p>
              {kiv && <p style={{fontSize: '14px', fontWeight: '700', color: o.helyes ? '#1e7e34' : '#c62828', marginTop: '8px'}}>{o.magyarazat}</p>}
            </div>
          );
        })}
      </div>
      {kivalasztott !== null && feladat.opciok[kivalasztott].helyes && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {kivalasztott !== null && feladat.opciok[kivalasztott].helyes && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ KÉPREGÉNY (panelek + döntés) ============
function Kepregeny({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1976d2';
  const [panelIndex, setPanelIndex] = useState(0);
  const [kivalasztott, setKivalasztott] = useState(null);
  const panel = feladat.panelek[panelIndex];
  const utolso = panelIndex === feladat.panelek.length - 1;
  const helyes = kivalasztott !== null && panel.opciok?.[kivalasztott]?.helyes;

  const tovabb = () => {
    if (!utolso) { setPanelIndex(p => p + 1); setKivalasztott(null); }
    else onKesz();
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>{feladat.cim}</p>
          <span style={{fontSize: '15px', fontWeight: '900', color: szin, background: `${szin}12`, padding: '5px 14px', borderRadius: '50px'}}>Panel {panelIndex + 1}/{feladat.panelek.length}</span>
        </div>
      </div>
      <div style={{display: 'flex', gap: '6px', padding: '0 4px'}}>
        {feladat.panelek.map((_, i) => (
          <div key={i} style={{flex: 1, height: '6px', borderRadius: '6px', background: i < panelIndex ? szin : i === panelIndex ? `${szin}80` : '#e0e0e0', transition: 'background 0.3s'}}/>
        ))}
      </div>
      <div className="k911-pop" style={{background: `linear-gradient(160deg, ${szin}12, white 55%)`, border: `2px solid ${szin}25`, borderRadius: '32px', padding: '2.5rem 2rem', textAlign: 'center', position: 'relative', boxShadow: `0 12px 36px ${szin}18`, overflow: 'hidden'}}>
        <div style={{position: 'absolute', top: '-30px', right: '-30px', width: '140px', height: '140px', borderRadius: '50%', background: `${szin}10`}}/>
        <div style={{position: 'absolute', bottom: '-40px', left: '-20px', width: '120px', height: '120px', borderRadius: '50%', background: `${szin}08`}}/>
        <div style={{position: 'relative', width: '130px', height: '130px', borderRadius: '50%', background: 'white', margin: '0 auto 1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '64px', boxShadow: `0 8px 24px ${szin}25`, border: `3px solid ${szin}30`}}>{panel.illusztracio}</div>
        <p style={{position: 'relative', fontSize: '21px', fontWeight: '700', color: '#2d3748', margin: 0, lineHeight: 1.6, maxWidth: '460px', marginLeft: 'auto', marginRight: 'auto'}}>{panel.szoveg}</p>
      </div>
      {panel.opciok ? (
        <div style={{display: 'flex', flexDirection: 'column', gap: '0.875rem'}}>
          {panel.opciok.map((o, i) => {
            const kiv = kivalasztott === i;
            const jo = kivalasztott !== null && o.helyes;
            const rossz = kivalasztott !== null && kiv && !o.helyes;
            return (
              <div key={i} onClick={() => kivalasztott === null && setKivalasztott(i)} className="k911-valasz"
                style={{padding: '1.3rem 1.7rem', borderRadius: '18px', cursor: kivalasztott === null ? 'pointer' : 'default', background: jo && kiv ? '#e8f5e9' : rossz ? '#fce8e6' : 'var(--bg-card)', border: `2.5px solid ${jo && kiv ? '#34a853' : rossz ? '#ea4335' : `${szin}20`}`}}>
                <p style={{margin: 0, fontWeight: '700', color: '#2d3748'}}>{o.szoveg}</p>
                {kiv && <p style={{fontSize: '15px', fontWeight: '800', color: jo ? '#1e7e34' : '#c62828', margin: '8px 0 0'}}>{o.magyarazat}</p>}
              </div>
            );
          })}
        </div>
      ) : null}
      <div style={{display: 'flex', justifyContent: 'center'}}>
        {(!panel.opciok || helyes) ? (
          <button onClick={tovabb} className="k911-btn" style={{padding: '18px 48px', background: `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>{utolso ? 'Befejezés! 🚀' : 'Következő panel →'}</button>
        ) : kivalasztott !== null && (
          <button onClick={() => setKivalasztott(null)} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>🔄 Próbáld újra!</button>
        )}
      </div>
      {utolso && helyes && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
    </div>
  );
}

// ============ KÁRTYAFORDÍTÓ (jó/rossz döntés) ============
function KartyaFordito({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1976d2';
  const [index, setIndex] = useState(0);
  const [fordulva, setFordulva] = useState(false);
  const [valasz, setValasz] = useState(null);
  const kartya = feladat.kartyak[index];

  const dontes = (jo) => {
    setValasz(jo); setFordulva(true);
  };
  const tovabb = () => {
    if (index + 1 < feladat.kartyak.length) { setIndex(i => i + 1); setFordulva(false); setValasz(null); }
    else onKesz();
  };
  const eltalalta = valasz === kartya.jo;

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>{feladat.cim}</p>
          <span style={{fontSize: '15px', fontWeight: '900', color: szin, background: `${szin}12`, padding: '5px 14px', borderRadius: '50px'}}>{index + 1}/{feladat.kartyak.length}</span>
        </div>
      </div>
      <div style={{perspective: '1000px'}}>
        <div style={{background: fordulva ? (eltalalta ? '#e8f5e9' : '#fce8e6') : `linear-gradient(135deg, ${szin}, ${szin}cc)`, borderRadius: '24px', padding: '2.5rem 2rem', textAlign: 'center', minHeight: '160px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', border: `3px solid ${fordulva ? (eltalalta ? '#34a853' : '#ea4335') : szin}`, transition: 'all 0.3s'}}>
          {!fordulva ? (
            <p style={{color: 'white', fontSize: '23px', fontWeight: '800', margin: 0}}>{kartya.szoveg}</p>
          ) : (
            <>
              <p style={{fontSize: '33px', margin: '0 0 8px'}}>{eltalalta ? '✅' : '❌'}</p>
              <p style={{fontSize: '17px', fontWeight: '800', color: eltalalta ? '#1e7e34' : '#c62828', margin: 0}}>{kartya.magyarazat}</p>
            </>
          )}
        </div>
      </div>
      {!fordulva ? (
        <div style={{display: 'flex', gap: '1rem', justifyContent: 'center'}}>
          <button onClick={() => dontes(true)} className="k911-btn" style={{padding: '16px 36px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>✅ Jó döntés</button>
          <button onClick={() => dontes(false)} className="k911-btn" style={{padding: '16px 36px', background: 'linear-gradient(135deg, #ea4335, #e57373)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>🚨 Rossz döntés</button>
        </div>
      ) : eltalalta ? (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={tovabb} className="k911-btn" style={{padding: '18px 48px', background: `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>{index + 1 < feladat.kartyak.length ? 'Következő kártya →' : 'Befejezés! 🚀'}</button>
        </div>
      ) : (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={() => { setFordulva(false); setValasz(null); }} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>🔄 Próbáld újra!</button>
        </div>
      )}
      {fordulva && eltalalta && index === feladat.kartyak.length - 1 && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
    </div>
  );
}

// ============ LÁBNYOM TÉRKÉP ============
function LabnyomTerkep({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#0d47a1';
  const [felfedve, setFelfedve] = useState([]);
  const celDarab = feladat.elemek.filter(e => e.cel).length;

  const kattint = (i, e) => {
    if (!e.cel || felfedve.includes(i)) return;
    const uj = [...felfedve, i];
    setFelfedve(uj);
    if (uj.length === celDarab) { /* várunk a gombra */ }
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
        <p style={{fontSize: '15px', color: szin, fontWeight: '800', marginTop: '8px'}}>{felfedve.length}/{celDarab} lábnyom megtalálva</p>
      </div>
      <div style={{background: `linear-gradient(160deg, ${szin}10, #f8fafc)`, borderRadius: '24px', padding: '2rem', border: `2px solid ${szin}25`}}>
        <div style={{display: 'flex', flexWrap: 'wrap', gap: '14px', justifyContent: 'center'}}>
          {feladat.elemek.map((e, i) => {
            const felfedettE = felfedve.includes(i);
            return (
              <div key={i} onClick={() => kattint(i, e)}
                style={{background: felfedettE ? (e.cel ? '#e8f5e9' : '#f0f4f8') : 'var(--bg-card)', border: `2px solid ${felfedettE && e.cel ? '#34a853' : `${szin}30`}`, borderRadius: '16px', padding: '14px 18px', cursor: e.cel && !felfedettE ? 'pointer' : 'default', textAlign: 'center', minWidth: '110px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', opacity: felfedettE && !e.cel ? 0.6 : 1}}>
                <div style={{fontSize: '33px'}}>{felfedettE ? (e.cel ? '👣' : '⭕') : '❔'}</div>
                <p style={{fontSize: '16px', color: '#2d3748', fontWeight: '700', margin: '4px 0 0'}}>{e.szoveg}</p>
              </div>
            );
          })}
        </div>
      </div>
      {felfedve.length === celDarab && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {felfedve.length === celDarab && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ POSZTOLNÁD? (like vagy kuka) ============
function Posztolnad({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#0d47a1';
  const [index, setIndex] = useState(0);
  const [valasz, setValasz] = useState(null);
  const poszt = feladat.posztok[index];
  const eltalalta = valasz !== null && valasz === poszt.helyes;

  const tovabb = () => {
    if (index + 1 < feladat.posztok.length) { setIndex(i => i + 1); setValasz(null); }
    else onKesz();
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>{feladat.cim}</p>
          <span style={{fontSize: '15px', fontWeight: '900', color: szin, background: `${szin}12`, padding: '5px 14px', borderRadius: '50px'}}>{index + 1}/{feladat.posztok.length}</span>
        </div>
      </div>
      <div style={{background: 'var(--bg-card)', border: `2px solid ${szin}20`, borderRadius: '20px', padding: '1.75rem', textAlign: 'center'}}>
        <div style={{fontSize: '64px', marginBottom: '1rem'}}>{poszt.emoji}</div>
        <p style={{fontSize: '18px', fontWeight: '700', color: '#2d3748', margin: 0}}>{poszt.leiras}</p>
        {valasz !== null && <p style={{fontSize: '16px', fontWeight: '800', color: eltalalta ? '#1e7e34' : '#c62828', marginTop: '14px', padding: '10px 16px', background: eltalalta ? '#e8f5e9' : '#fce8e6', borderRadius: '12px'}}>{poszt.magyarazat}</p>}
      </div>
      {valasz === null ? (
        <div style={{display: 'flex', gap: '1rem', justifyContent: 'center'}}>
          <button onClick={() => setValasz('like')} className="k911-btn" style={{padding: '16px 36px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>❤️ Posztolnám</button>
          <button onClick={() => setValasz('kuka')} className="k911-btn" style={{padding: '16px 36px', background: 'linear-gradient(135deg, #ea4335, #e57373)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>🗑️ Kuka</button>
        </div>
      ) : (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={tovabb} className="k911-btn" style={{padding: '18px 48px', background: `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>{index + 1 < feladat.posztok.length ? 'Következő →' : 'Befejezés! 🚀'}</button>
        </div>
      )}
      {valasz !== null && index === feladat.posztok.length - 1 && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
    </div>
  );
}

// ============ IDŐUTAZÁS (reflexió) ============
function Idoutazas({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#0d47a1';
  const korok = feladat.korok || [{ kerdes: feladat.kerdes, valaszok: feladat.valaszok }];
  const [korIndex, setKorIndex] = useState(0);
  const [kivalasztott, setKivalasztott] = useState(null);
  const kor = korok[korIndex];
  const helyes = kivalasztott !== null && kor.valaszok[kivalasztott]?.helyes;
  const tovabb = () => {
    if (korIndex + 1 < korok.length) { setKorIndex(k => k + 1); setKivalasztott(null); }
    else onKesz();
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: `radial-gradient(circle, ${szin}30, white 70%)`, borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`}}>
        <div style={{fontSize: '40px', textAlign: 'center', marginBottom: '0.5rem'}}>🔮</div>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '0.5rem'}}>
          <p style={{fontSize: '25px', fontWeight: '900', color: '#1a1a2e', margin: 0, textAlign: 'center'}}>{feladat.cim}</p>
          {korok.length > 1 && <span style={{fontSize: '15px', fontWeight: '900', color: szin, background: 'white', padding: '5px 14px', borderRadius: '50px'}}>{korIndex + 1}/{korok.length}</span>}
        </div>
        <p style={{fontSize: '18px', color: '#2d3748', fontWeight: '700', margin: 0, textAlign: 'center'}}>{kor.kerdes}</p>
      </div>
      <div style={{display: 'flex', flexDirection: 'column', gap: '0.875rem'}}>
        {kor.valaszok.map((v, i) => {
          const kiv = kivalasztott === i;
          const jo = kivalasztott !== null && v.helyes;
          const rossz = kivalasztott !== null && kiv && !v.helyes;
          return (
            <div key={i} onClick={() => kivalasztott === null && setKivalasztott(i)} className="k911-valasz"
              style={{padding: '1.3rem 1.7rem', borderRadius: '18px', cursor: kivalasztott === null ? 'pointer' : 'default', background: jo && kiv ? '#e8f5e9' : rossz ? '#fce8e6' : 'var(--bg-card)', border: `2.5px solid ${jo && kiv ? '#34a853' : rossz ? '#ea4335' : `${szin}20`}`}}>
              <p style={{margin: 0, fontWeight: '700', color: '#2d3748', fontSize: '22px'}}>{v.szoveg}</p>
              {kiv && <p style={{fontSize: '15px', fontWeight: '800', color: jo ? '#1e7e34' : '#c62828', margin: '8px 0 0'}}>{v.magyarazat}</p>}
            </div>
          );
        })}
      </div>
      {helyes && korIndex === korok.length - 1 && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      <div style={{display: 'flex', justifyContent: 'center'}}>
        {kivalasztott !== null && (helyes ? (
          <button onClick={tovabb} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>{korIndex + 1 < korok.length ? 'Következő! →' : 'Tovább! 🚀'}</button>
        ) : (
          <button onClick={() => setKivalasztott(null)} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>🔄 Próbáld újra!</button>
        ))}
      </div>
    </div>
  );
}

// ============ DIGITÁLIS TAKARÍTÁS (húzd a kukába) ============
function DigitalisTakaritas({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#0d47a1';
  const [kukaban, setKukaban] = useState([]);
  const [dragolt, setDragolt] = useState(null);
  const [ellenorzott, setEllenorzott] = useState(false);
  const [helyes, setHelyes] = useState(false);
  const pool = feladat.elemek.map((e, i) => ({ ...e, i })).filter(e => !kukaban.includes(e.i));

  const dobas = () => { if (dragolt !== null) { setKukaban(prev => [...prev, dragolt]); setDragolt(null); } };
  const ellenorzes = () => { setHelyes(feladat.elemek.every((e, i) => kukaban.includes(i) === e.torlendo)); setEllenorzott(true); };
  const ujra = () => { setKukaban([]); setEllenorzott(false); setHelyes(false); };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
      </div>
      <div>
        <p style={{fontSize: '15px', fontWeight: '800', color: '#94a3b8', margin: '0 0 10px', textTransform: 'uppercase', letterSpacing: '0.5px'}}>Elemek</p>
        <div style={{background: '#f8fafc', borderRadius: '20px', padding: '1.25rem', border: `2px dashed ${szin}30`, minHeight: '90px', display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center'}}>
          {pool.map(e => (
            <div key={e.i} draggable={!ellenorzott} onDragStart={() => setDragolt(e.i)} className="k911-btn"
              style={{background: 'var(--bg-card)', border: `2px solid ${szin}30`, borderRadius: '16px', padding: '12px 16px', cursor: 'grab', fontSize: '16px', fontWeight: '800', display: 'flex', alignItems: 'center', gap: '8px'}}>
              <span style={{fontSize: '25px'}}>{e.emoji}</span>{e.szoveg}
            </div>
          ))}
          {pool.length === 0 && <p style={{color: '#94a3b8', fontWeight: '700', fontSize: '15px'}}>Minden elem elbírálva.</p>}
        </div>
      </div>
      <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <div onDragOver={e => e.preventDefault()} onDrop={dobas}
          style={{background: 'linear-gradient(160deg, #37474f, #263238)', borderRadius: '32px', padding: '2rem', width: '100%', maxWidth: '440px', minHeight: '200px', border: `4px dashed #90a4ae`, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', boxShadow: '0 10px 32px rgba(0,0,0,0.15)'}}>
          <div style={{fontSize: '64px'}}>🗑️</div>
          <p style={{color: 'rgba(255,255,255,0.6)', fontSize: '15px', fontWeight: '700', margin: 0}}>Húzd ide, amit törölnél!</p>
          <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center'}}>
            {kukaban.map(i => {
              const e = feladat.elemek[i];
              const jo = ellenorzott && e.torlendo;
              const rossz = ellenorzott && !e.torlendo;
              return <div key={i} style={{background: jo ? 'rgba(52,168,83,0.3)' : rossz ? 'rgba(234,67,53,0.3)' : 'rgba(255,255,255,0.15)', color: 'white', borderRadius: '10px', padding: '6px 12px', fontSize: '17px', fontWeight: '700'}}>{e.emoji} {e.szoveg}{ellenorzott && (jo ? ' ✅' : ' ❌')}</div>;
            })}
          </div>
        </div>
      </div>
      {ellenorzott && (
        <div className="k911-pop" style={{background: helyes ? '#e8f5e9' : '#fce8e6', border: `2px solid ${helyes ? '#34a853' : '#ea4335'}`, borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '21px', fontWeight: '900', color: helyes ? '#1e7e34' : '#c62828', margin: 0}}>{helyes ? feladat.visszajelzes_jo : feladat.visszajelzes_rossz}</p>
        </div>
      )}
      {helyes && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      <div style={{display: 'flex', justifyContent: 'center'}}>
        {!ellenorzott ? (
          <button onClick={ellenorzes} className="k911-btn" style={{padding: '18px 48px', background: `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>✅ Kész vagyok</button>
        ) : helyes ? (
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>Tovább! 🚀</button>
        ) : (
          <button onClick={ujra} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>🔄 Próbáld újra!</button>
        )}
      </div>
    </div>
  );
}

// ============ IN-GAME BOLT ============
function InGameBolt({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1565c0';
  const [kivalasztott, setKivalasztott] = useState([]);
  const [ellenorzott, setEllenorzott] = useState(false);
  const helyes = ellenorzott && feladat.termekek.every((t, i) => kivalasztott.includes(i) === t.helyes);

  const toggle = (i) => { if (!ellenorzott) setKivalasztott(prev => prev.includes(i) ? prev.filter(x => x !== i) : [...prev, i]); };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
      </div>
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '1rem'}}>
        {feladat.termekek.map((t, i) => {
          const kiv = kivalasztott.includes(i);
          const jo = ellenorzott && kiv && t.helyes;
          const rossz = ellenorzott && kiv && !t.helyes;
          const kihagyott = ellenorzott && !kiv && t.helyes;
          return (
            <div key={i} onClick={() => toggle(i)} className="k911-valasz"
              style={{textAlign: 'center', padding: '1.25rem 1rem', borderRadius: '18px', cursor: ellenorzott ? 'default' : 'pointer', background: jo ? '#e8f5e9' : rossz || kihagyott ? '#fce8e6' : kiv ? `${szin}12` : 'var(--bg-card)', border: `2.5px solid ${jo ? '#34a853' : rossz || kihagyott ? '#ea4335' : kiv ? szin : `${szin}20`}`}}>
              <div style={{fontSize: '36px'}}>{t.emoji}</div>
              <p style={{fontSize: '16px', fontWeight: '800', color: '#2d3748', margin: '6px 0 2px'}}>{t.nev}</p>
              <p style={{fontSize: '15px', fontWeight: '700', color: szin, margin: 0}}>{t.ar}</p>
              {ellenorzott && <p style={{fontSize: '14px', fontWeight: '700', color: t.helyes ? '#1e7e34' : '#c62828', marginTop: '6px'}}>{t.magyarazat}</p>}
            </div>
          );
        })}
      </div>
      {ellenorzott && (
        <div className="k911-pop" style={{background: helyes ? '#e8f5e9' : '#fce8e6', border: `2px solid ${helyes ? '#34a853' : '#ea4335'}`, borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '21px', fontWeight: '900', color: helyes ? '#1e7e34' : '#c62828', margin: 0}}>{helyes ? feladat.visszajelzes_jo : feladat.visszajelzes_rossz}</p>
        </div>
      )}
      {helyes && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      <div style={{display: 'flex', justifyContent: 'center'}}>
        {!ellenorzott ? (
          <button onClick={() => setEllenorzott(true)} className="k911-btn" style={{padding: '18px 48px', background: `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>🛒 Vásárlás</button>
        ) : helyes ? (
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>Tovább! 🚀</button>
        ) : (
          <button onClick={() => { setKivalasztott([]); setEllenorzott(false); }} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>🔄 Próbáld újra!</button>
        )}
      </div>
    </div>
  );
}

// ============ CSALÓVADÁSZAT ============
function Csalovadaszat({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1565c0';
  const [kivalasztott, setKivalasztott] = useState(null);
  const helyes = kivalasztott !== null && feladat.ajanlatok[kivalasztott]?.scam;

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
      </div>
      <div style={{display: 'flex', flexDirection: 'column', gap: '0.875rem'}}>
        {feladat.ajanlatok.map((a, i) => {
          const kiv = kivalasztott === i;
          const jo = kivalasztott !== null && a.scam;
          const rossz = kivalasztott !== null && kiv && !a.scam;
          return (
            <div key={i} onClick={() => kivalasztott === null && setKivalasztott(i)} className="k911-valasz"
              style={{padding: '1.3rem 1.7rem', borderRadius: '18px', cursor: kivalasztott === null ? 'pointer' : 'default', background: jo && kiv ? '#e8f5e9' : rossz ? '#fce8e6' : jo ? '#e8f5e9' : 'var(--bg-card)', border: `2.5px solid ${jo ? '#34a853' : rossz ? '#ea4335' : `${szin}20`}`}}>
              <p style={{margin: 0, fontWeight: '700', color: '#2d3748'}}>{a.szoveg}</p>
              {kivalasztott !== null && (jo || (kiv && rossz)) && <p style={{fontSize: '15px', fontWeight: '800', color: a.scam ? '#1e7e34' : '#c62828', margin: '8px 0 0'}}>{a.magyarazat}</p>}
            </div>
          );
        })}
      </div>
      {helyes && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      <div style={{display: 'flex', justifyContent: 'center'}}>
        {kivalasztott !== null && (helyes ? (
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>Tovább! 🚀</button>
        ) : (
          <button onClick={() => setKivalasztott(null)} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>🔄 Próbáld újra!</button>
        ))}
      </div>
    </div>
  );
}

// ============ SZERENCSEKERÉK ============
function Szerencsekerek({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1565c0';
  const [forgat, setForgat] = useState(false);
  const [eredmeny, setEredmeny] = useState(null);
  const [kivalasztott, setKivalasztott] = useState(null);
  const [fokSzog, setFokSzog] = useState(0);
  const szinek = ['#1976d2','#34a853','#f9ab00','#ea4335','#8e24aa','#00acc1'];

  const perget = () => {
    if (forgat) return;
    const index = Math.floor(Math.random() * feladat.kerdesek.length);
    const szeletSzog = 360 / feladat.kerdesek.length;
    const cel = 360 * 4 + (360 - index * szeletSzog - szeletSzog / 2);
    setFokSzog(cel);
    setForgat(true);
    setTimeout(() => { setEredmeny(index); setForgat(false); }, 2200);
  };

  const kerdes = eredmeny !== null ? feladat.kerdesek[eredmeny] : null;
  const helyes = kivalasztott !== null && kerdes?.opciok[kivalasztott]?.helyes;

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '18px', color: '#64748b', margin: 0, fontWeight: '600'}}>Pörgesd meg a kereket, és válaszolj a kérdésre!</p>
      </div>
      {eredmeny === null ? (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1.5rem', padding: '2rem'}}>
          <div style={{position: 'relative', width: '220px', height: '220px'}}>
            <div style={{position: 'absolute', top: '-14px', left: '50%', transform: 'translateX(-50%)', width: 0, height: 0, borderLeft: '12px solid transparent', borderRight: '12px solid transparent', borderTop: '20px solid #1a1a2e', zIndex: 2}}/>
            <div style={{width: '220px', height: '220px', borderRadius: '50%', position: 'relative', overflow: 'hidden', transform: `rotate(${fokSzog}deg)`, transition: forgat ? 'transform 2.2s cubic-bezier(0.2,0.8,0.2,1)' : 'none', border: '6px solid #1a1a2e', boxShadow: '0 8px 28px rgba(0,0,0,0.25)'}}>
              {feladat.kerdesek.map((k, i) => {
                const szeletSzog = 360 / feladat.kerdesek.length;
                return (
                  <div key={i} style={{position: 'absolute', width: '50%', height: '50%', top: '50%', left: '50%', transformOrigin: '0 0', transform: `rotate(${i * szeletSzog}deg) skewY(${90 - szeletSzog}deg)`, background: szinek[i % szinek.length]}}/>
                );
              })}
            </div>
          </div>
          <button onClick={perget} disabled={forgat} className="k911-btn" style={{padding: '18px 48px', background: `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: forgat ? 'default' : 'pointer'}}>{forgat ? '🎡 Pörög...' : '🎡 Pergesd meg!'}</button>
        </div>
      ) : (
        <>
          <div style={{background: `linear-gradient(135deg, ${szin}10, ${szin}06)`, border: `2px solid ${szin}25`, borderRadius: '18px', padding: '1.5rem'}}>
            <p style={{fontSize: '19px', color: '#2d3748', fontWeight: '700', margin: 0}}>{kerdes.kerdes}</p>
          </div>
          <div style={{display: 'flex', flexDirection: 'column', gap: '0.875rem'}}>
            {kerdes.opciok.map((o, i) => {
              const kiv = kivalasztott === i;
              const jo = kivalasztott !== null && o.helyes;
              const rossz = kivalasztott !== null && kiv && !o.helyes;
              return (
                <div key={i} onClick={() => kivalasztott === null && setKivalasztott(i)} className="k911-valasz"
                  style={{padding: '1.3rem 1.7rem', borderRadius: '18px', cursor: kivalasztott === null ? 'pointer' : 'default', background: jo && kiv ? '#e8f5e9' : rossz ? '#fce8e6' : 'var(--bg-card)', border: `2.5px solid ${jo && kiv ? '#34a853' : rossz ? '#ea4335' : `${szin}20`}`}}>
                  <p style={{margin: 0, fontWeight: '700', color: '#2d3748'}}>{o.szoveg}</p>
                </div>
              );
            })}
          </div>
          {helyes && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
          <div style={{display: 'flex', justifyContent: 'center'}}>
            {kivalasztott !== null && (helyes ? (
              <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>Tovább! 🚀</button>
            ) : (
              <button onClick={() => { setKivalasztott(null); setEredmeny(null); }} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>🔄 Pergesd újra!</button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

// ============ PROMPT ÉPÍTŐ ============
function PromptEpito({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1976d2';
  const korok = feladat.korok || [{ kerdes: feladat.kerdes, kotelezoElemek: feladat.kotelezoElemek, szavak: feladat.szavak }];
  const [korIndex, setKorIndex] = useState(0);
  const [kivalasztott, setKivalasztott] = useState([]);
  const [ellenorzott, setEllenorzott] = useState(false);
  const kor = korok[korIndex];
  const helyes = ellenorzott && kor.kotelezoElemek.every(k => kivalasztott.includes(k));
  const pool = kor.szavak.filter(s => !kivalasztott.includes(s.id));

  const hozzaad = (s) => setKivalasztott(prev => [...prev, s.id]);
  const eltavolit = (id) => { if (!ellenorzott) setKivalasztott(prev => prev.filter(x => x !== id)); };
  const tovabb = () => {
    if (korIndex + 1 < korok.length) { setKorIndex(k => k + 1); setKivalasztott([]); setEllenorzott(false); }
    else onKesz();
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
          {korok.length > 1 && <span style={{fontSize: '15px', fontWeight: '900', color: szin, background: `${szin}12`, padding: '5px 14px', borderRadius: '50px'}}>{korIndex + 1}/{korok.length}</span>}
        </div>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{kor.kerdes}</p>
      </div>
      <div style={{background: 'linear-gradient(160deg, #0f1f3d, #16264a)', borderRadius: '20px', padding: '1.5rem', minHeight: '70px', display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center', border: `2px solid ${szin}`}}>
        {kivalasztott.length === 0 && <p style={{color: 'rgba(255,255,255,0.5)', fontSize: '16px'}}>Kattints a szavakra lent, hogy összeállítsd a promptot!</p>}
        {kivalasztott.map(id => {
          const s = kor.szavak.find(x => x.id === id);
          return <span key={id} onClick={() => eltavolit(id)} style={{background: `${szin}40`, color: 'white', padding: '8px 14px', borderRadius: '10px', fontWeight: '700', fontSize: '16px', cursor: ellenorzott ? 'default' : 'pointer'}}>{s.szo}</span>;
        })}
      </div>
      <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px'}}>
        {pool.map(s => (
          <button key={s.id} onClick={() => hozzaad(s)} disabled={ellenorzott} className="k911-btn" style={{padding: '10px 16px', borderRadius: '12px', border: `2px solid ${szin}30`, background: 'var(--bg-card)', fontWeight: '700', fontSize: '16px', cursor: 'pointer'}}>{s.szo}</button>
        ))}
      </div>
      {ellenorzott && (
        <div className="k911-pop" style={{background: helyes ? '#e8f5e9' : '#fce8e6', border: `2px solid ${helyes ? '#34a853' : '#ea4335'}`, borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '21px', fontWeight: '900', color: helyes ? '#1e7e34' : '#c62828', margin: 0}}>{helyes ? (kor.visszajelzes_jo || feladat.visszajelzes_jo) : (kor.visszajelzes_rossz || feladat.visszajelzes_rossz)}</p>
        </div>
      )}
      {ellenorzott && helyes && kor.aiValasz && (
        <div className="k911-pop" style={{background: '#f0f4f8', borderRadius: '20px', padding: '1.5rem', border: `2px solid ${szin}15`}}>
          <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1rem'}}>
            <div style={{width: '38px', height: '38px', borderRadius: '50%', background: 'linear-gradient(135deg, #10a37f, #1a7f64)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '19px'}}>🤖</div>
            <p style={{fontSize: '16px', fontWeight: '800', color: '#2d3748', margin: 0}}>ChatGPT válaszol...</p>
          </div>
          <AgentXBuborek szoveg={kor.aiValasz} szin="#10a37f"/>
        </div>
      )}
      {helyes && korIndex === korok.length - 1 && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      <div style={{display: 'flex', justifyContent: 'center'}}>
        {!ellenorzott ? (
          <button onClick={() => setEllenorzott(true)} disabled={kivalasztott.length === 0} className="k911-btn" style={{padding: '18px 48px', background: kivalasztott.length === 0 ? '#f0f4f8' : `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: kivalasztott.length === 0 ? '#94a3b8' : 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: kivalasztott.length === 0 ? 'not-allowed' : 'pointer'}}>✅ Prompt ellenőrzése</button>
        ) : helyes ? (
          <button onClick={tovabb} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>{korIndex + 1 < korok.length ? 'Következő téma! →' : 'Tovább! 🚀'}</button>
        ) : (
          <button onClick={() => { setKivalasztott([]); setEllenorzott(false); }} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>🔄 Próbáld újra!</button>
        )}
      </div>
    </div>
  );
}

// ============ AI LABIRINTUS ============
function AILabirintus({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1976d2';
  const [korIndex, setKorIndex] = useState(0);
  const [kivalasztott, setKivalasztott] = useState(null);
  const [kijutott, setKijutott] = useState(false);
  const kor = feladat.kerdesek[korIndex];
  const helyes = kivalasztott !== null && kor.opciok[kivalasztott]?.helyes;
  const OSZLOP = 4;
  const n = feladat.kerdesek.length;

  const tovabb = () => {
    if (korIndex + 1 < n) { setKorIndex(k => k + 1); setKivalasztott(null); }
    else { setKijutott(true); }
  };

  const pozicio = (i) => {
    const sor = Math.floor(i / OSZLOP);
    const posSorban = i % OSZLOP;
    const oszlop = sor % 2 === 0 ? posSorban : (OSZLOP - 1 - posSorban);
    return { sor, oszlop };
  };
  const sorokSzama = Math.ceil(n / OSZLOP);

  if (kijutott) {
    return (
      <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out', alignItems: 'center', textAlign: 'center', position: 'relative'}}>
        <KonfettiHatter/>
        <div style={{position: 'relative', zIndex: 1, padding: '2rem'}}>
          <div style={{fontSize: '90px', animation: 'ugorj911 0.8s ease-in-out infinite'}}>🚪✨</div>
          <h2 style={{fontSize: '30px', fontWeight: '900', color: szin, margin: '0.5rem 0'}}>Kijutottál a labirintusból!</h2>
          <p style={{fontSize: '18px', color: '#64748b', fontWeight: '700'}}>Minden ajtót helyesen nyitottál ki — igazi AI-szakértő vagy!</p>
          <div style={{background: `linear-gradient(135deg, ${szin}15, ${szin}08)`, border: `2px dashed ${szin}50`, borderRadius: '20px', padding: '1.25rem 2rem', display: 'inline-block', margin: '1rem 0'}}>
            <p style={{fontSize: '22px', fontWeight: '900', color: szin, margin: 0}}>🏆 Jutalom: +30 XP</p>
          </div>
        </div>
        {feladat.jegyzet && (
          <div style={{position: 'relative', zIndex: 1, width: '100%', maxWidth: '600px'}}>
            <AgentXJegyzet jegyzet={feladat.jegyzet}/>
          </div>
        )}
        <div style={{position: 'relative', zIndex: 1, display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: `0 8px 24px ${szin}35`}}>Tovább! 🚀</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '15px', color: '#94a3b8', fontWeight: '700', margin: 0}}>Válaszolj helyesen, hogy kinyisd a következő ajtót és kijuss a labirintusból! {korIndex + 1}/{n}</p>
      </div>
      <div style={{background: `linear-gradient(160deg, #0f1f3d, #16264a)`, borderRadius: '28px', padding: '2.5rem', border: `2px solid ${szin}`}}>
        <div style={{display: 'grid', gridTemplateColumns: `repeat(${OSZLOP}, 1fr)`, gridTemplateRows: `repeat(${sorokSzama}, 1fr)`, gap: '14px', maxWidth: '480px', margin: '0 auto'}}>
          {feladat.kerdesek.map((_, i) => {
            const { sor, oszlop } = pozicio(i);
            const kesz = i < korIndex || (i === korIndex && helyes);
            const aktiv = i === korIndex;
            const utolso = i === n - 1;
            return (
              <div key={i} style={{gridRow: sor + 1, gridColumn: oszlop + 1, aspectRatio: '1', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', background: kesz ? 'rgba(52,168,83,0.25)' : aktiv ? `${szin}50` : 'rgba(255,255,255,0.06)', border: `3px solid ${kesz ? '#34a853' : aktiv ? szin : 'rgba(255,255,255,0.2)'}`, boxShadow: aktiv ? `0 0 20px ${szin}80` : 'none', transition: 'all 0.4s'}}>
                <div style={{fontSize: '30px'}}>{aktiv ? '🧍' : kesz ? '✅' : utolso ? '🚪' : '🔒'}</div>
              </div>
            );
          })}
        </div>
        <p style={{color: 'rgba(255,255,255,0.6)', fontSize: '13px', fontWeight: '700', textAlign: 'center', marginTop: '1.25rem'}}>🔒 zárt ajtó · 🧍 te vagy itt · ✅ már kinyitott ajtó · 🚪 a kijárat</p>
      </div>
      <div style={{background: `linear-gradient(135deg, ${szin}10, ${szin}06)`, border: `2px solid ${szin}25`, borderRadius: '18px', padding: '1.5rem'}}>
        <p style={{fontSize: '22px', color: '#2d3748', fontWeight: '700', margin: 0}}>{kor.kerdes}</p>
      </div>
      <div style={{display: 'flex', flexDirection: 'column', gap: '0.875rem'}}>
        {kor.opciok.map((o, i) => {
          const kiv = kivalasztott === i;
          const jo = kivalasztott !== null && o.helyes;
          const rossz = kivalasztott !== null && kiv && !o.helyes;
          return (
            <div key={i} onClick={() => kivalasztott === null && setKivalasztott(i)} className="k911-valasz"
              style={{padding: '1.3rem 1.7rem', borderRadius: '18px', cursor: kivalasztott === null ? 'pointer' : 'default', background: jo && kiv ? '#e8f5e9' : rossz ? '#fce8e6' : 'var(--bg-card)', border: `2.5px solid ${jo && kiv ? '#34a853' : rossz ? '#ea4335' : `${szin}20`}`}}>
              <p style={{margin: 0, fontWeight: '700', color: '#2d3748'}}>{o.szoveg}</p>
              {kiv && <p style={{fontSize: '15px', fontWeight: '800', color: jo ? '#1e7e34' : '#c62828', margin: '8px 0 0'}}>{o.magyarazat}</p>}
            </div>
          );
        })}
      </div>
      {helyes && korIndex === n - 1 && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      <div style={{display: 'flex', justifyContent: 'center'}}>
        {kivalasztott !== null && (helyes ? (
          <button onClick={tovabb} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>{korIndex + 1 < n ? '🚪 Nyílik az ajtó! →' : '🎉 Kijutok a labirintusból!'}</button>
        ) : (
          <button onClick={() => setKivalasztott(null)} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer'}}>🔄 Próbáld újra!</button>
        ))}
      </div>
    </div>
  );
}

// ============ BOSS FIGHT (10 gyors döntés) ============
function BossFight({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#0d47a1';
  const [index, setIndex] = useState(0);
  const [elet, setElet] = useState(100);
  const [kivalasztott, setKivalasztott] = useState(null);
  const kerdes = feladat.kerdesek[index];

  const valaszt = (i) => {
    if (kivalasztott !== null) return;
    setKivalasztott(i);
    if (!kerdes.opciok[i].helyes) setElet(e => Math.max(0, e - 15));
    setTimeout(() => {
      if (index + 1 < feladat.kerdesek.length) { setIndex(x => x + 1); setKivalasztott(null); }
      else onKesz();
    }, 1100);
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'linear-gradient(160deg, #1a1a2e, #0d47a1)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}`}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem'}}>
          <p style={{fontSize: '25px', fontWeight: '900', color: 'white', margin: 0}}>👾 {feladat.cim}</p>
          <span style={{fontSize: '15px', fontWeight: '900', color: 'white', background: 'rgba(255,255,255,0.15)', padding: '5px 14px', borderRadius: '50px'}}>{index + 1}/{feladat.kerdesek.length}</span>
        </div>
        <div style={{background: 'rgba(255,255,255,0.15)', borderRadius: '10px', height: '18px', overflow: 'hidden'}}>
          <div style={{width: `${elet}%`, height: '100%', background: elet > 50 ? '#34a853' : elet > 20 ? '#f9ab00' : '#ea4335', transition: 'width 0.4s'}}/>
        </div>
        <p style={{color: 'rgba(255,255,255,0.7)', fontSize: '14px', fontWeight: '700', marginTop: '6px'}}>Agent X életereje: {elet}%</p>
      </div>
      <div style={{background: `linear-gradient(135deg, ${szin}10, ${szin}06)`, border: `2px solid ${szin}25`, borderRadius: '18px', padding: '1.5rem'}}>
        <p style={{fontSize: '21px', color: '#2d3748', fontWeight: '800', margin: 0}}>{kerdes.kerdes}</p>
      </div>
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem'}}>
        {kerdes.opciok.map((o, i) => {
          const kiv = kivalasztott === i;
          const jo = kivalasztott !== null && o.helyes;
          const rossz = kivalasztott !== null && kiv && !o.helyes;
          return (
            <div key={i} onClick={() => valaszt(i)} className="k911-valasz"
              style={{padding: '1.1rem 1.25rem', borderRadius: '18px', cursor: kivalasztott === null ? 'pointer' : 'default', textAlign: 'center', background: jo && kiv ? '#e8f5e9' : rossz ? '#fce8e6' : 'var(--bg-card)', border: `2.5px solid ${jo && kiv ? '#34a853' : rossz ? '#ea4335' : `${szin}20`}`}}>
              <p style={{margin: 0, fontWeight: '800', color: '#2d3748', fontSize: '18px'}}>{o.szoveg}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ============ CYBER SZÉF (kód-kirakó) ============
function CyberSzef({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#0d47a1';
  const [index, setIndex] = useState(0);
  const [szamjegyek, setSzamjegyek] = useState([]);
  const [kivalasztott, setKivalasztott] = useState(null);
  const [nyitva, setNyitva] = useState(false);
  const kerdes = feladat.kerdesek[index];

  const valaszt = (i) => {
    if (kivalasztott !== null) return;
    setKivalasztott(i);
    if (kerdes.opciok[i].helyes) {
      const uj = [...szamjegyek, kerdes.szamjegy];
      setSzamjegyek(uj);
      setTimeout(() => {
        if (index + 1 < feladat.kerdesek.length) { setIndex(x => x + 1); setKivalasztott(null); }
        else { setNyitva(true); }
      }, 1000);
    } else {
      setTimeout(() => setKivalasztott(null), 700);
    }
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '18px', color: '#64748b', margin: 0, fontWeight: '600'}}>Minden helyes válasz egy számjegyet ad — gyűjtsd össze mind a {feladat.kerdesek.length}-öt, és nyisd ki a széfet!</p>
      </div>
      <div style={{background: 'linear-gradient(160deg, #263238, #0d47a1)', borderRadius: '24px', padding: '2rem', textAlign: 'center', border: `3px solid ${szin}`}}>
        <div style={{fontSize: '56px', marginBottom: '1rem'}}>{nyitva ? '🔓' : '🔐'}</div>
        <div style={{display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '1.5rem'}}>
          {feladat.kerdesek.map((_, i) => (
            <div key={i} style={{width: '46px', height: '54px', borderRadius: '10px', background: 'rgba(255,255,255,0.1)', border: '2px solid rgba(255,255,255,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '25px', fontWeight: '900', fontFamily: 'monospace'}}>{szamjegyek[i] ?? '?'}</div>
          ))}
        </div>
        {!nyitva && (
          <>
            <p style={{color: 'white', fontSize: '18px', fontWeight: '700', marginBottom: '1rem'}}>{kerdes.kerdes}</p>
            <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
              {kerdes.opciok.map((o, i) => {
                const kiv = kivalasztott === i;
                const jo = kiv && o.helyes;
                const rossz = kiv && !o.helyes;
                return (
                  <div key={i} onClick={() => valaszt(i)}
                    style={{padding: '12px 16px', borderRadius: '12px', cursor: kivalasztott === null ? 'pointer' : 'default', background: jo ? 'rgba(52,168,83,0.3)' : rossz ? 'rgba(234,67,53,0.3)' : 'rgba(255,255,255,0.08)', border: `2px solid ${jo ? '#34a853' : rossz ? '#ea4335' : 'rgba(255,255,255,0.25)'}`, color: 'white', fontWeight: '700', fontSize: '16px'}}>
                    {o.szoveg}
                  </div>
                );
              })}
            </div>
          </>
        )}
        {nyitva && <p style={{color: '#a5d6a7', fontSize: '23px', fontWeight: '900'}}>🎉 A széf kinyílt!</p>}
      </div>
      {nyitva && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {nyitva && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ KINCSVADÁSZAT (rejtett jelvények) ============
function Kincsvadaszat({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#0d47a1';
  const [megtalalt, setMegtalalt] = useState([]);
  const pozok = useState(() => feladat.elemek.map(() => ({ top: 8 + Math.random() * 76, left: 5 + Math.random() * 82 })))[0];

  const kattint = (i) => {
    if (megtalalt.includes(i)) return;
    const uj = [...megtalalt, i];
    setMegtalalt(uj);
    if (uj.length === feladat.elemek.length) { /* várunk a gombra */ }
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '18px', color: '#64748b', margin: 0, fontWeight: '600'}}>Keresd meg az összes elrejtett Agent X jelvényt!</p>
        <p style={{fontSize: '15px', color: szin, fontWeight: '800', marginTop: '8px'}}>{megtalalt.length}/{feladat.elemek.length} jelvény megtalálva</p>
      </div>
      <div style={{position: 'relative', background: 'linear-gradient(160deg, #0f1f3d, #16264a)', borderRadius: '24px', height: '360px', border: `2px solid ${szin}`, overflow: 'hidden'}}>
        {feladat.elemek.map((e, i) => {
          const van = megtalalt.includes(i);
          return (
            <div key={i} onClick={() => kattint(i)}
              style={{position: 'absolute', top: `${pozok[i].top}%`, left: `${pozok[i].left}%`, fontSize: van ? '36px' : '30px', cursor: van ? 'default' : 'pointer', transition: 'all 0.3s', filter: van ? 'none' : 'brightness(0.6)', opacity: van ? 1 : 0.7}}>
              {van ? '🏅' : '✨'}
            </div>
          );
        })}
      </div>
      {megtalalt.length === feladat.elemek.length && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {megtalalt.length === feladat.elemek.length && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ LÁBNYOM ELEMZŐ (modern mérő-játék) ============
function LabnyomAnalizator({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#0d47a1';
  const [index, setIndex] = useState(0);
  const [pontszam, setPontszam] = useState(0);
  const [valasz, setValasz] = useState(null);
  const [kesz, setKesz] = useState(false);
  const helyzet = feladat.helyzetek[index];

  const dontes = (opt, i) => {
    if (valasz !== null) return;
    setValasz(i);
    const uj = Math.max(0, Math.min(100, pontszam + opt.hatas));
    setTimeout(() => {
      setPontszam(uj);
      setTimeout(() => {
        if (index + 1 < feladat.helyzetek.length) { setIndex(x => x + 1); setValasz(null); }
        else { setKesz(true); }
      }, 700);
    }, 300);
  };

  const szazalek = pontszam;
  const gaugeSzin = szazalek < 35 ? '#34a853' : szazalek < 65 ? '#f9ab00' : '#ea4335';
  const cimke = szazalek < 35 ? '🟢 Kis lábnyom' : szazalek < 65 ? '🟡 Közepes lábnyom' : '🔴 Nagy lábnyom';

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '27px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '18px', color: '#64748b', margin: 0, fontWeight: '600'}}>Minden döntésed hat a digitális lábnyom-mérődre — figyeld, hogyan változik!</p>
      </div>
      <div style={{background: `linear-gradient(160deg, #0f1f3d, #16264a)`, borderRadius: '28px', padding: '2rem', border: `2px solid ${szin}`, textAlign: 'center'}}>
        <div style={{position: 'relative', width: '220px', height: '120px', margin: '0 auto 1rem', overflow: 'hidden'}}>
          <div style={{position: 'absolute', top: 0, left: 0, width: '220px', height: '220px', borderRadius: '50%', background: `conic-gradient(${gaugeSzin} ${szazalek * 1.8}deg, rgba(255,255,255,0.12) 0deg)`, transform: 'rotate(-90deg)'}}/>
          <div style={{position: 'absolute', top: '20px', left: '20px', width: '180px', height: '180px', borderRadius: '50%', background: '#16264a'}}/>
          <div style={{position: 'absolute', bottom: 0, left: 0, right: 0, textAlign: 'center'}}>
            <p style={{color: 'white', fontSize: '30px', fontWeight: '900', margin: 0}}>{szazalek}%</p>
          </div>
        </div>
        <p style={{color: gaugeSzin, fontSize: '19px', fontWeight: '900', margin: '0 0 1.5rem'}}>{cimke}</p>
        {!kesz && (
          <>
            <p style={{color: 'white', fontSize: '18px', fontWeight: '700', marginBottom: '1.25rem'}}>{helyzet.szoveg}</p>
            <div style={{display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '420px', margin: '0 auto'}}>
              {helyzet.opciok.map((o, i) => (
                <div key={i} onClick={() => dontes(o, i)}
                  style={{padding: '14px 18px', borderRadius: '14px', cursor: valasz === null ? 'pointer' : 'default', background: valasz === i ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,0.08)', border: `2px solid ${valasz === i ? 'white' : 'rgba(255,255,255,0.25)'}`, color: 'white', fontWeight: '700', fontSize: '15px', textAlign: 'left'}}>
                  {o.szoveg}
                </div>
              ))}
            </div>
          </>
        )}
        {kesz && <p style={{color: '#a5d6a7', fontSize: '19px', fontWeight: '900'}}>🎉 Elkészült a lábnyom-elemzésed!</p>}
        {!kesz && <p style={{color: 'rgba(255,255,255,0.5)', fontSize: '13px', fontWeight: '700', marginTop: '1rem'}}>{index + 1}/{feladat.helyzetek.length}</p>}
      </div>
      {kesz && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      {kesz && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        </div>
      )}
    </div>
  );
}

// ============ CÉLBALÖVŐ (lufi-lövős játék) ============
function CelbalovoJatek({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#1565c0';
  const [eltalalt, setEltalalt] = useState([]);
  const [hiba, setHiba] = useState(null);
  const pozok = useState(() => feladat.lufik.map(() => ({ left: 5 + Math.random() * 82, keses: Math.random() * 3, tartam: 6 + Math.random() * 4 })))[0];
  const celDarab = feladat.lufik.filter(l => l.veszelyes).length;

  const kattint = (i, l) => {
    if (eltalalt.includes(i)) return;
    if (!l.veszelyes) { setHiba(i); setTimeout(() => setHiba(null), 500); return; }
    const uj = [...eltalalt, i];
    setEltalalt(uj);
    if (uj.length === celDarab) { /* várunk a gombra */ }
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '27px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '18px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
        <p style={{fontSize: '15px', color: szin, fontWeight: '800', marginTop: '8px'}}>{eltalalt.length}/{celDarab} veszélyes lufi kilőve</p>
      </div>
      <div style={{position: 'relative', background: 'linear-gradient(180deg, #bbdefb, #e3f2fd)', borderRadius: '28px', height: '420px', border: `2px solid ${szin}25`, overflow: 'hidden'}}>
        {feladat.lufik.map((l, i) => {
          if (eltalalt.includes(i)) return null;
          return (
            <div key={i} onClick={() => kattint(i, l)}
              style={{position: 'absolute', left: `${pozok[i].left}%`, bottom: '-140px', width: '90px', textAlign: 'center', cursor: 'pointer', animation: `lufiSzall ${pozok[i].tartam}s linear infinite`, animationDelay: `${pozok[i].keses}s`, transform: hiba === i ? 'scale(0.85)' : 'scale(1)', transition: 'transform 0.2s'}}>
              <div style={{fontSize: '52px', filter: hiba === i ? 'grayscale(0.6)' : 'none'}}>🎈</div>
              <p style={{fontSize: '12px', fontWeight: '800', color: '#1a1a2e', background: 'rgba(255,255,255,0.85)', borderRadius: '8px', padding: '2px 6px', margin: '-6px auto 0', maxWidth: '86px', lineHeight: 1.2}}>{l.szoveg}</p>
            </div>
          );
        })}
      </div>
      {eltalalt.length === celDarab && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      <style>{`@keyframes lufiSzall { 0% { bottom: -140px; } 100% { bottom: 440px; } }`}</style>
    </div>
  );
}

// ============ RANG ANIMÁCIÓ (záró jutalom) ============
function RangAnimacio({ feladat, onKesz, kuldes }) {
  const szin = kuldes?.szin || '#0d47a1';
  const [xp, setXp] = useState(0);
  useEffect(() => {
    const cel = feladat.xpOsszeg || 850;
    const lepes = Math.ceil(cel / 40);
    const id = setInterval(() => setXp(x => { const uj = x + lepes; return uj >= cel ? cel : uj; }), 30);
    return () => clearInterval(id);
  }, []);

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out', alignItems: 'center', textAlign: 'center', position: 'relative'}}>
      <KonfettiHatter/>
      <div style={{position: 'relative', zIndex: 1, width: '100%'}}>
        <div style={{fontSize: '80px', animation: 'ugorj911 0.9s ease-in-out infinite'}}>🏅</div>
        <h2 style={{fontSize: '33px', fontWeight: '900', color: szin, margin: '0 0 0.5rem'}}>{feladat.rangNev || 'Digitális Őr'}</h2>
        <p style={{fontSize: '18px', color: '#64748b', fontWeight: '700'}}>Új Agent X jelvény kioldva!</p>
        <div style={{background: 'var(--bg-card)', border: `3px solid ${szin}`, borderRadius: '24px', padding: '1.5rem 2rem', margin: '1.5rem auto', maxWidth: '360px', boxShadow: `0 12px 32px ${szin}25`}}>
          <p style={{fontSize: '15px', color: '#94a3b8', fontWeight: '800', margin: '0 0 6px', textTransform: 'uppercase'}}>Összesített XP</p>
          <p style={{fontSize: '38px', fontWeight: '900', color: szin, margin: 0}}>{xp} XP</p>
        </div>
        <div style={{background: `linear-gradient(135deg, ${szin}10, ${szin}06)`, border: `2px dashed ${szin}50`, borderRadius: '20px', padding: '1.75rem', margin: '0 auto 1.5rem', maxWidth: '420px'}}>
          <p style={{fontSize: '15px', color: '#94a3b8', fontWeight: '800', margin: '0 0 8px', textTransform: 'uppercase'}}>📜 Digitális Oklevél</p>
          <p style={{fontSize: '18px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 4px'}}>Agent X Akadémia</p>
          <p style={{fontSize: '15px', color: '#64748b', fontWeight: '700'}}>Ezúton igazoljuk, hogy sikeresen teljesítetted a záróvizsgát és megszerezted a "{feladat.rangNev || 'Digitális Őr'}" rangot.</p>
        </div>
        <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: 'white', border: 'none', borderRadius: '50px', fontSize: '19px', fontWeight: '900', cursor: 'pointer', boxShadow: `0 10px 30px ${szin}40`}}>🏅 Befejezés</button>
      </div>
    </div>
  );
}

// ============ SZITUÁCIÓ ============
function SzituacioFeladat({ feladat, onKesz, kuldes }) {
  const korok = feladat.korok || [{ kerdes: feladat.kerdes, valaszok: feladat.valaszok, visszajelzes_jo: feladat.visszajelzes_jo, visszajelzes_rossz: feladat.visszajelzes_rossz }];
  const [korIndex, setKorIndex] = useState(0);
  const [kivalasztott, setKivalasztott] = useState(null);
  const [ellenorzott, setEllenorzott] = useState(false);
  const szin = kuldes?.szin || '#1976d2';
  const kor = korok[korIndex];
  const helyes = kivalasztott !== null && kor.valaszok[kivalasztott]?.helyes;

  const tovabb = () => {
    if (korIndex + 1 < korok.length) { setKorIndex(k => k + 1); setKivalasztott(null); setEllenorzott(false); }
    else onKesz();
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem'}}>
          <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: 0}}>{feladat.cim}</p>
          {korok.length > 1 && <span style={{fontSize: '15px', fontWeight: '900', color: szin, background: `${szin}12`, padding: '5px 14px', borderRadius: '50px'}}>{korIndex + 1}/{korok.length}</span>}
        </div>
        <div style={{background: `linear-gradient(135deg, ${szin}10, ${szin}06)`, border: `2px solid ${szin}25`, borderRadius: '18px', padding: '1.5rem'}}>
          <p style={{fontSize: '19px', color: '#2d3748', fontWeight: '700', margin: 0, lineHeight: 1.7}}>{kor.kerdes}</p>
        </div>
      </div>
      <div style={{display: 'flex', flexDirection: 'column', gap: '0.875rem'}}>
        {kor.valaszok.map((v, i) => {
          const kiv = kivalasztott === i;
          const jo = ellenorzott && v.helyes;
          const rossz = ellenorzott && kiv && !v.helyes;
          return (
            <div key={i} onClick={() => !ellenorzott && setKivalasztott(i)} className="k911-valasz" data-disabled={ellenorzott ? 'true' : undefined}
              style={{background: jo ? '#e8f5e9' : rossz ? '#fce8e6' : kiv ? `${szin}12` : 'var(--bg-card)', border: `2.5px solid ${jo ? '#34a853' : rossz ? '#ea4335' : kiv ? szin : `${szin}15`}`, borderRadius: '20px', padding: '1.4rem 1.9rem', cursor: ellenorzott ? 'default' : 'pointer', transition: 'all 0.2s'}}>
              <p style={{fontSize: '21px', fontWeight: '700', color: '#2d3748', margin: 0, lineHeight: 1.5}}>{v.szoveg}</p>
              {ellenorzott && (jo || rossz) && <p style={{fontSize: '15px', fontWeight: '700', color: jo ? '#1e7e34' : '#c62828', margin: '8px 0 0', padding: '6px 12px', background: jo ? '#e8f5e9' : '#fce8e6', borderRadius: '10px'}}>{v.magyarazat}</p>}
              {ellenorzott && !kiv && v.helyes && <p style={{fontSize: '15px', fontWeight: '700', color: '#1e7e34', margin: '8px 0 0', padding: '6px 12px', background: '#e8f5e9', borderRadius: '10px'}}>✅ {v.magyarazat}</p>}
            </div>
          );
        })}
      </div>
      {ellenorzott && (
        <div className="k911-pop" style={{background: helyes ? '#e8f5e9' : '#fce8e6', border: `2px solid ${helyes ? '#34a853' : '#ea4335'}`, borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '21px', fontWeight: '900', color: helyes ? '#1e7e34' : '#c62828', margin: 0}}>{helyes ? kor.visszajelzes_jo : kor.visszajelzes_rossz}</p>
        </div>
      )}
      {helyes && korIndex === korok.length - 1 && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      <div style={{display: 'flex', justifyContent: 'center'}}>
        {!ellenorzott ? (
          <button onClick={() => kivalasztott !== null && setEllenorzott(true)} disabled={kivalasztott === null} className="k911-btn"
            style={{padding: '18px 48px', background: kivalasztott === null ? '#f0f4f8' : `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: kivalasztott === null ? '#94a3b8' : 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: kivalasztott === null ? 'not-allowed' : 'pointer', boxShadow: kivalasztott === null ? 'none' : `0 8px 24px ${szin}35`}}>
            ✅ Ellenőrzés
          </button>
        ) : helyes ? (
          <button onClick={tovabb} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>{korIndex + 1 < korok.length ? 'Következő! →' : 'Tovább! 🚀'}</button>
        ) : (
          <button onClick={() => { setKivalasztott(null); setEllenorzott(false); }} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(249,171,0,0.35)'}}>🔄 Próbáld újra!</button>
        )}
      </div>
    </div>
  );
}

// ============ JELSZÓ ÉPÍTŐ ============
function JelszoEpitoFeladat({ feladat, onKesz, kuldes }) {
  const [besorolt, setBesorolt] = useState({});
  const [ellenorzott, setEllenorzott] = useState(false);
  const [helyes, setHelyes] = useState(false);
  const szin = kuldes?.szin || '#1976d2';

  const erosseg = (j) => [j.hossz, j.szam, j.jel, j.nagybetu].filter(Boolean).length;
  const besorol = (i, ertek) => { if (ellenorzott) return; setBesorolt(prev => ({ ...prev, [i]: ertek })); };
  const ellenorzes = () => { setHelyes(feladat.jelszavak.every((j, i) => besorolt[i] === (erosseg(j) >= 3 ? 'erős' : 'gyenge'))); setEllenorzott(true); };
  const ujra = () => { setBesorolt({}); setEllenorzott(false); setHelyes(false); };
  const mindenBesorolt = feladat.jelszavak.every((_, i) => besorolt[i]);

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
      </div>
      <div style={{background: 'var(--bg-card)', borderRadius: '20px', padding: '1.5rem', border: `2px solid ${szin}15`, overflow: 'hidden'}}>
        <div style={{display: 'grid', gridTemplateColumns: '1fr auto auto auto auto auto', gap: '12px', marginBottom: '0.75rem', padding: '0 0 0.75rem', borderBottom: `1px solid ${szin}15`}}>
          <span style={{fontSize: '15px', fontWeight: '800', color: '#64748b'}}>Jelszó</span>
          <span style={{fontSize: '14px', fontWeight: '800', color: '#64748b', textAlign: 'center'}}>8+ kar</span>
          <span style={{fontSize: '14px', fontWeight: '800', color: '#64748b', textAlign: 'center'}}>Szám</span>
          <span style={{fontSize: '14px', fontWeight: '800', color: '#64748b', textAlign: 'center'}}>Jel</span>
          <span style={{fontSize: '14px', fontWeight: '800', color: '#64748b', textAlign: 'center'}}>Nagy</span>
          <span style={{fontSize: '14px', fontWeight: '800', color: '#64748b', textAlign: 'center', minWidth: '150px'}}>Erős / Gyenge?</span>
        </div>
        {feladat.jelszavak.map((j, i) => {
          const eros = erosseg(j) >= 3;
          const jo = ellenorzott && besorolt[i] === (eros ? 'erős' : 'gyenge');
          const rossz = ellenorzott && besorolt[i] !== (eros ? 'erős' : 'gyenge');
          return (
            <div key={i} style={{display: 'grid', gridTemplateColumns: '1fr auto auto auto auto auto', gap: '12px', alignItems: 'center', padding: '10px 12px', background: jo ? '#e8f5e920' : rossz ? '#fce8e620' : i % 2 === 0 ? '#f8fafc' : 'var(--bg-card)', borderRadius: '12px', marginBottom: '6px', border: `1px solid ${jo ? '#34a853' : rossz ? '#ea4335' : 'transparent'}`}}>
              <span style={{fontSize: '16px', fontWeight: '800', fontFamily: 'monospace', color: '#1a1a2e', wordBreak: 'break-all'}}>{j.jelszo}</span>
              <span style={{fontSize: '21px', textAlign: 'center'}}>{j.hossz ? '✅' : '❌'}</span>
              <span style={{fontSize: '21px', textAlign: 'center'}}>{j.szam ? '✅' : '❌'}</span>
              <span style={{fontSize: '21px', textAlign: 'center'}}>{j.jel ? '✅' : '❌'}</span>
              <span style={{fontSize: '21px', textAlign: 'center'}}>{j.nagybetu ? '✅' : '❌'}</span>
              <div style={{display: 'flex', gap: '6px', minWidth: '150px'}}>
                <button onClick={() => besorol(i, 'erős')} className="k911-btn"
                  style={{flex: 1, padding: '6px 10px', background: besorolt[i] === 'erős' ? (ellenorzott ? (eros ? '#34a853' : '#ea4335') : szin) : 'var(--bg-card)', color: besorolt[i] === 'erős' ? 'white' : '#555', border: `1.5px solid ${besorolt[i] === 'erős' ? (ellenorzott ? (eros ? '#34a853' : '#ea4335') : szin) : '#e0e0e0'}`, borderRadius: '50px', fontSize: '14px', fontWeight: '800', cursor: ellenorzott ? 'default' : 'pointer'}}>
                  💪
                </button>
                <button onClick={() => besorol(i, 'gyenge')} className="k911-btn"
                  style={{flex: 1, padding: '6px 10px', background: besorolt[i] === 'gyenge' ? (ellenorzott ? (!eros ? '#34a853' : '#ea4335') : '#64748b') : 'var(--bg-card)', color: besorolt[i] === 'gyenge' ? 'white' : '#555', border: `1.5px solid ${besorolt[i] === 'gyenge' ? (ellenorzott ? (!eros ? '#34a853' : '#ea4335') : '#64748b') : '#e0e0e0'}`, borderRadius: '50px', fontSize: '14px', fontWeight: '800', cursor: ellenorzott ? 'default' : 'pointer'}}>
                  😰
                </button>
              </div>
            </div>
          );
        })}
      </div>
      {ellenorzott && (
        <div className="k911-pop" style={{background: helyes ? '#e8f5e9' : '#fce8e6', border: `2px solid ${helyes ? '#34a853' : '#ea4335'}`, borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '21px', fontWeight: '900', color: helyes ? '#1e7e34' : '#c62828', margin: 0}}>{helyes ? feladat.visszajelzes_jo : feladat.visszajelzes_rossz}</p>
        </div>
      )}
      {helyes && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      <div style={{display: 'flex', justifyContent: 'center'}}>
        {!ellenorzott ? (
          <button onClick={ellenorzes} disabled={!mindenBesorolt} className="k911-btn"
            style={{padding: '18px 48px', background: !mindenBesorolt ? '#f0f4f8' : `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: !mindenBesorolt ? '#94a3b8' : 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: !mindenBesorolt ? 'not-allowed' : 'pointer', boxShadow: !mindenBesorolt ? 'none' : `0 8px 24px ${szin}35`}}>
            🔐 Ellenőrzés
          </button>
        ) : helyes ? (
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        ) : (
          <button onClick={ujra} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(249,171,0,0.35)'}}>🔄 Próbáld újra!</button>
        )}
      </div>
    </div>
  );
}

// ============ SORREND ============
function SorrendFeladat({ feladat, onKesz, kuldes }) {
  const [elemek, setElemek] = useState(() => [...feladat.elemek].sort(() => Math.random() - 0.5));
  const [dragolt, setDragolt] = useState(null);
  const [dragolCel, setDragolCel] = useState(null);
  const [ellenorzott, setEllenorzott] = useState(false);
  const [helyes, setHelyes] = useState(false);
  const szin = kuldes?.szin || '#1976d2';

  const onDrop = (i) => {
    if (dragolt === null || dragolt === i) return;
    const uj = [...elemek]; const temp = uj[dragolt]; uj[dragolt] = uj[i]; uj[i] = temp;
    setElemek(uj); setDragolt(null); setDragolCel(null);
  };
  const ellenorzes = () => { setHelyes(elemek.every((e, i) => e.helyes_sorrend === i + 1)); setEllenorzott(true); };
  const ujra = () => { setElemek([...feladat.elemek].sort(() => Math.random() - 0.5)); setEllenorzott(false); setHelyes(false); };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
        <p style={{fontSize: '15px', color: '#94a3b8', fontWeight: '700', marginTop: '6px'}}>Húzd a megfelelő sorrendbe! 🔢</p>
      </div>
      <div style={{display: 'flex', flexDirection: 'column', gap: '0.75rem'}}>
        {elemek.map((e, i) => {
          const jo = ellenorzott && e.helyes_sorrend === i + 1;
          const rossz = ellenorzott && e.helyes_sorrend !== i + 1;
          return (
            <div key={e.szoveg} draggable={!ellenorzott}
              onDragStart={() => setDragolt(i)} onDragOver={(ev) => { ev.preventDefault(); setDragolCel(i); }} onDrop={() => onDrop(i)} onDragLeave={() => setDragolCel(null)}
              style={{background: jo ? '#e8f5e9' : rossz ? '#fce8e6' : dragolCel === i ? `${szin}15` : 'var(--bg-card)', border: `2.5px solid ${jo ? '#34a853' : rossz ? '#ea4335' : dragolCel === i ? szin : `${szin}15`}`, borderRadius: '18px', padding: '1.3rem 1.7rem', cursor: ellenorzott ? 'default' : 'grab', display: 'flex', alignItems: 'center', gap: '1rem', userSelect: 'none', transition: 'all 0.2s'}}>
              <div style={{width: '36px', height: '36px', borderRadius: '50%', background: jo ? '#34a853' : rossz ? '#ea4335' : `${szin}15`, border: `2px solid ${jo ? '#34a853' : rossz ? '#ea4335' : szin}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '17px', fontWeight: '900', color: jo || rossz ? 'white' : szin, flexShrink: 0}}>{i + 1}</div>
              <p style={{fontSize: '19px', fontWeight: '700', color: '#2d3748', margin: 0, flex: 1}}>{e.szoveg}</p>
              {!ellenorzott && <span style={{fontSize: '21px', opacity: 0.3}}>⠿</span>}
              {ellenorzott && <span style={{fontSize: '16px', fontWeight: '800'}}>{jo ? '✅' : `❌ (${e.helyes_sorrend}. hely)`}</span>}
            </div>
          );
        })}
      </div>
      {ellenorzott && (
        <div className="k911-pop" style={{background: helyes ? '#e8f5e9' : '#fce8e6', border: `2px solid ${helyes ? '#34a853' : '#ea4335'}`, borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '21px', fontWeight: '900', color: helyes ? '#1e7e34' : '#c62828', margin: 0}}>{helyes ? feladat.visszajelzes_jo : feladat.visszajelzes_rossz}</p>
        </div>
      )}
      {helyes && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      <div style={{display: 'flex', justifyContent: 'center'}}>
        {!ellenorzott ? (
          <button onClick={ellenorzes} className="k911-btn" style={{padding: '18px 48px', background: `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: `0 8px 24px ${szin}35`}}>✅ Ellenőrzés</button>
        ) : helyes ? (
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        ) : (
          <button onClick={ujra} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(249,171,0,0.35)'}}>🔄 Próbáld újra!</button>
        )}
      </div>
    </div>
  );
}

// ============ VÁLOGATÓ ============
function ValogatoFeladat({ feladat, onKesz, kuldes }) {
  const [elemek, setElemek] = useState(feladat.elemek.map(e => ({ ...e, elhelyezve: false, celKategoria: null })));
  const [dragolt, setDragolt] = useState(null);
  const [ellenorzott, setEllenorzott] = useState(false);
  const [helyes, setHelyes] = useState(false);
  const szin = kuldes?.szin || '#1976d2';

  const onDrop = (kat) => {
    if (dragolt === null) return;
    const uj = [...elemek]; uj[dragolt] = { ...uj[dragolt], elhelyezve: true, celKategoria: kat };
    setElemek(uj); setDragolt(null);
  };
  const ellenorzes = () => { setHelyes(elemek.every(e => e.elhelyezve && e.celKategoria === e.kategoria)); setEllenorzott(true); };
  const ujra = () => { setElemek(feladat.elemek.map(e => ({ ...e, elhelyezve: false, celKategoria: null }))); setEllenorzott(false); setHelyes(false); };
  const elhelyezetlen = elemek.filter(e => !e.elhelyezve);

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
        <p style={{fontSize: '22px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.kerdes}</p>
      </div>
      <div style={{background: '#f8fafc', borderRadius: '22px', padding: '1.5rem', border: `2px dashed ${szin}30`, minHeight: '100px', display: 'flex', flexWrap: 'wrap', gap: '12px', justifyContent: 'center', alignItems: 'center'}}>
        {elhelyezetlen.map((e) => {
          const idx = elemek.indexOf(e);
          return (
            <div key={idx} draggable onDragStart={() => setDragolt(idx)} className="k911-btn"
              style={{background: 'var(--bg-card)', border: `2px solid ${szin}30`, borderRadius: '18px', padding: '14px 22px', cursor: 'grab', fontSize: '18px', fontWeight: '800', color: '#2d3748', display: 'flex', alignItems: 'center', gap: '10px', userSelect: 'none', boxShadow: `0 2px 8px ${szin}15`}}>
              <span style={{fontSize: '31px'}}>{e.kep}</span>{e.felirat}
            </div>
          );
        })}
        {elhelyezetlen.length === 0 && <p style={{color: '#34a853', fontWeight: '800', fontSize: '16px', margin: 0}}>✅ Minden elem elhelyezve!</p>}
      </div>
      <div style={{display: 'grid', gridTemplateColumns: `repeat(${feladat.kategoriak.length}, 1fr)`, gap: '1.5rem'}}>
        {feladat.kategoriak.map(kat => (
          <div key={kat.id} onDragOver={e => e.preventDefault()} onDrop={() => onDrop(kat.id)}
            style={{background: `${kat.szin}06`, border: `3px dashed ${kat.szin}`, borderRadius: '26px', padding: '1.75rem', minHeight: '200px'}}>
            <p style={{fontSize: '19px', fontWeight: '900', color: kat.szin, marginBottom: '1.1rem', textAlign: 'center'}}>{kat.felirat}</p>
            <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center'}}>
              {elemek.filter(e => e.elhelyezve && e.celKategoria === kat.id).map((e) => {
                const jo = ellenorzott && e.kategoria === e.celKategoria;
                return (
                  <div key={elemek.indexOf(e)} style={{background: ellenorzott ? (jo ? '#e8f5e9' : '#fce8e6') : 'var(--bg-card)', border: `2px solid ${ellenorzott ? (jo ? '#34a853' : '#ea4335') : '#e0e0e0'}`, borderRadius: '14px', padding: '9px 16px', fontSize: '17px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px'}}>
                    <span style={{fontSize: '25px'}}>{e.kep}</span>{e.felirat}{ellenorzott && <span>{jo ? '✅' : '❌'}</span>}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
      {ellenorzott && (
        <div className="k911-pop" style={{background: helyes ? '#e8f5e9' : '#fce8e6', border: `2px solid ${helyes ? '#34a853' : '#ea4335'}`, borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '21px', fontWeight: '900', color: helyes ? '#1e7e34' : '#c62828', margin: 0}}>{helyes ? feladat.visszajelzes_jo : feladat.visszajelzes_rossz}</p>
        </div>
      )}
      {helyes && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      <div style={{display: 'flex', justifyContent: 'center'}}>
        {!ellenorzott ? (
          <button onClick={ellenorzes} disabled={elhelyezetlen.length > 0} className="k911-btn"
            style={{padding: '18px 48px', background: elhelyezetlen.length > 0 ? '#f0f4f8' : `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: elhelyezetlen.length > 0 ? '#94a3b8' : 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: elhelyezetlen.length > 0 ? 'not-allowed' : 'pointer', boxShadow: elhelyezetlen.length > 0 ? 'none' : `0 8px 24px ${szin}35`}}>
            ✅ Ellenőrzés
          </button>
        ) : helyes ? (
          <button onClick={onKesz} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>Tovább! 🚀</button>
        ) : (
          <button onClick={ujra} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(249,171,0,0.35)'}}>🔄 Próbáld újra!</button>
        )}
      </div>
    </div>
  );
}

// ============ CHAT SZIMULÁCIÓS ============
function ChatSzimulaciosFeladat({ feladat, onKesz, kuldes }) {
  const korok = feladat.korok || [{ menetek: [{ uzenet: feladat.uzenetlanc[0].uzenet, valaszok: feladat.valaszok }], visszajelzes_jo: feladat.visszajelzes_jo, visszajelzes_rossz: feladat.visszajelzes_rossz }];
  const [korIndex, setKorIndex] = useState(0);
  const [menetIndex, setMenetIndex] = useState(0);
  const [transzkript, setTranszkript] = useState(() => [{ ki: 'idegen', uzenet: korok[0].menetek[0].uzenet }]);
  const [kivalasztott, setKivalasztott] = useState(null);
  const [ellenorzott, setEllenorzott] = useState(false);
  const szin = kuldes?.szin || '#1976d2';
  const smsStilus = feladat.stilus === 'sms';
  const kor = korok[korIndex];
  const menet = kor.menetek[menetIndex];
  const helyes = kivalasztott !== null && menet.valaszok[kivalasztott]?.helyes;
  const korVege = ellenorzott && helyes && menetIndex === kor.menetek.length - 1;

  const valaszAdas = () => setEllenorzott(true);

  const tovabbLep = () => {
    if (helyes) {
      const uj = [...transzkript, { ki: 'te', uzenet: menet.valaszok[kivalasztott].szoveg.replace(/^[🟢🔴🟡]\s*/, '') }];
      if (menetIndex + 1 < kor.menetek.length) {
        const kovetkezoMenet = kor.menetek[menetIndex + 1];
        uj.push({ ki: 'idegen', uzenet: kovetkezoMenet.uzenet });
        setTranszkript(uj);
        setMenetIndex(m => m + 1);
        setKivalasztott(null);
        setEllenorzott(false);
      } else {
        setTranszkript(uj);
        if (korIndex + 1 < korok.length) {
          const ujKor = korok[korIndex + 1];
          setKorIndex(k => k + 1);
          setMenetIndex(0);
          setKivalasztott(null);
          setEllenorzott(false);
          setTranszkript([{ ki: 'idegen', uzenet: ujKor.menetek[0].uzenet }]);
        } else {
          onKesz();
        }
      }
    } else {
      setKivalasztott(null);
      setEllenorzott(false);
    }
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', animation: 'felugrik911 0.4s ease-out'}}>
      <div style={{background: 'var(--bg-card)', borderRadius: '24px', padding: '2.25rem 2.75rem', border: `2px solid ${szin}20`, boxShadow: '0 4px 24px rgba(33,150,243,0.08)'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <p style={{fontSize: '30px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>{feladat.cim}</p>
          {korok.length > 1 && <span style={{fontSize: '15px', fontWeight: '900', color: szin, background: `${szin}12`, padding: '5px 14px', borderRadius: '50px'}}>{korIndex + 1}/{korok.length}</span>}
        </div>
        <p style={{fontSize: '17px', color: '#64748b', margin: 0, fontWeight: '600'}}>{feladat.leiras}</p>
      </div>
      <div style={{background: smsStilus ? '#e8eaed' : '#f0f4f8', borderRadius: '22px', padding: '1.5rem', border: `2px solid ${szin}15`}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: `1px solid ${szin}15`}}>
          <div style={{width: '44px', height: '44px', borderRadius: '50%', background: 'linear-gradient(135deg, #64748b, #94a3b8)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '23px'}}>{smsStilus ? '📱' : '❓'}</div>
          <div>
            <p style={{fontSize: '16px', fontWeight: '800', color: '#2d3748', margin: 0}}>{smsStilus ? 'Ismeretlen szám' : 'Ismeretlen felhasználó'}</p>
            <p style={{fontSize: '14px', color: '#94a3b8', margin: 0}}>{smsStilus ? 'SMS' : 'Online'}</p>
          </div>
        </div>
        {transzkript.map((u, i) => (
          <div key={i} className="k911-pop" style={{display: 'flex', justifyContent: u.ki === 'te' ? 'flex-end' : 'flex-start', marginBottom: '10px'}}>
            <div style={{background: u.ki === 'te' ? (smsStilus ? 'linear-gradient(135deg, #34c759, #2fb350)' : `linear-gradient(135deg, ${szin}, ${szin}cc)`) : 'white', color: u.ki === 'te' ? 'white' : '#2d3748', borderRadius: u.ki === 'te' ? '20px 20px 4px 20px' : '20px 20px 20px 4px', padding: '12px 18px', maxWidth: '80%', fontSize: '17px', fontWeight: '700', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', lineHeight: 1.5}}>
              {u.uzenet}
            </div>
          </div>
        ))}
        {!ellenorzott && (
          <div style={{background: `${szin}15`, borderRadius: '14px', padding: '10px 16px', fontSize: '16px', fontWeight: '700', color: szin, textAlign: 'center', marginTop: '10px'}}>
            💬 Hogyan válaszolsz?
          </div>
        )}
      </div>
      {!ellenorzott && (
        <div style={{display: 'flex', flexDirection: 'column', gap: '0.875rem'}}>
          {menet.valaszok.map((v, i) => (
            <div key={i} onClick={() => setKivalasztott(i)} className="k911-valasz"
              style={{background: kivalasztott === i ? `${szin}12` : 'var(--bg-card)', border: `2.5px solid ${kivalasztott === i ? szin : `${szin}15`}`, borderRadius: '20px', padding: '1.4rem 1.9rem', cursor: 'pointer', transition: 'all 0.2s'}}>
              <p style={{fontSize: '19px', fontWeight: '700', color: '#2d3748', margin: 0}}>{v.szoveg}</p>
            </div>
          ))}
        </div>
      )}
      {ellenorzott && (
        <div className="k911-pop" style={{background: helyes ? '#e8f5e9' : '#fce8e6', border: `2px solid ${helyes ? '#34a853' : '#ea4335'}`, borderRadius: '20px', padding: '1.5rem', textAlign: 'center'}}>
          <p style={{fontSize: '19px', fontWeight: '900', color: helyes ? '#1e7e34' : '#c62828', margin: 0}}>{menet.valaszok[kivalasztott].magyarazat}</p>
        </div>
      )}
      {korVege && <AgentXJegyzet jegyzet={feladat.jegyzet}/>}
      <div style={{display: 'flex', justifyContent: 'center'}}>
        {!ellenorzott ? (
          <button onClick={valaszAdas} disabled={kivalasztott === null} className="k911-btn"
            style={{padding: '18px 48px', background: kivalasztott === null ? '#f0f4f8' : `linear-gradient(135deg, ${szin}, ${szin}cc)`, color: kivalasztott === null ? '#94a3b8' : 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: kivalasztott === null ? 'not-allowed' : 'pointer', boxShadow: kivalasztott === null ? 'none' : `0 8px 24px ${szin}35`}}>
            💬 Elküldöm
          </button>
        ) : helyes ? (
          <button onClick={tovabbLep} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(52,168,83,0.35)'}}>
            {menetIndex + 1 < kor.menetek.length ? 'Folytatom a chatet →' : korIndex + 1 < korok.length ? 'Következő beszélgetés →' : 'Befejezés! 🚀'}
          </button>
        ) : (
          <button onClick={tovabbLep} className="k911-btn" style={{padding: '18px 48px', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: '800', cursor: 'pointer', boxShadow: '0 8px 24px rgba(249,171,0,0.35)'}}>🔄 Próbáld újra!</button>
        )}
      </div>
    </div>
  );
}

// ============ FŐ KOMPONENS ============
function Leckek911({ felhasznalo }) {
  const [aktivKuldes, setAktivKuldes] = useState(null);
  const [aktivFeladat, setAktivFeladat] = useState(0);
  const [teljesitett, setTeljesitett] = useState([]);
  const [kuldesKesz, setKuldesKesz] = useState(false);
  const [konyvOlvasva, setKonyvOlvasva] = useState(false);
  const [digitalisOr, setDigitalisOr] = useState(false);
  const { gyerekek, leckeTeljesitese } = useGyerekek();
  const aktivGyerek = gyerekek[0] || null;

  useEffect(() => {
    if (aktivGyerek?.halado?.['9-11']) setTeljesitett(aktivGyerek.halado['9-11']);
  }, [aktivGyerek?.id]);

  const visszaKuldetesekhez = () => { setAktivKuldes(null); setAktivFeladat(0); setKuldesKesz(false); setKonyvOlvasva(false); };
  const kuldesIndit = (k) => { setAktivKuldes(k); setAktivFeladat(0); setKuldesKesz(false); setKonyvOlvasva(false); };
  const kovetkezoFeladat = () => {
    if (aktivFeladat + 1 < aktivKuldes.feladatok.length) { setAktivFeladat(p => p + 1); }
    else {
      setKuldesKesz(true);
      if (!teljesitett.includes(aktivKuldes.id)) {
        const ujTeljesitett = [...teljesitett, aktivKuldes.id];
        setTeljesitett(ujTeljesitett);
        if (aktivKuldes.id === 7) setDigitalisOr(true);
        if (aktivGyerek) {
          const xpOsszeg = aktivKuldes.id === 7 ? 100 : 50;
          leckeTeljesitese(aktivGyerek.id, '9-11', ujTeljesitett, xpOsszeg);
        }
      }
    }
  };

  const vanKonyv = aktivKuldes && !!aktivKuldes.konyv;
  const konyvZarol = vanKonyv && !konyvOlvasva;
  const haladásszazalek = Math.round((teljesitett.length / kuldetesek.length) * 100);

  const renderFeladat = (f) => {
    const props = { feladat: f, onKesz: kovetkezoFeladat, kuldes: aktivKuldes };
    if (f.tipus === 'igaz_hamis') return <IgazHamisFeladat key={f.id} {...props}/>;
    if (f.tipus === 'nyomozo' && f.stilus) return <ProfilNyomozo key={f.id} {...props}/>;
    if (f.tipus === 'nyomozo') return <NyomozoFeladat key={f.id} {...props}/>;
    if (f.tipus === 'szituacio') return <SzituacioFeladat key={f.id} {...props}/>;
    if (f.tipus === 'jelszo_epito') return <JelszoEpitoFeladat key={f.id} {...props}/>;
    if (f.tipus === 'sorrend') return <SorrendFeladat key={f.id} {...props}/>;
    if (f.tipus === 'valogatо') return <ValogatoFeladat key={f.id} {...props}/>;
    if (f.tipus === 'chat_szimulacios') return <ChatSzimulaciosFeladat key={f.id} {...props}/>;
    if (f.tipus === 'profil_epito') return <ProfilEpito key={f.id} {...props}/>;
    if (f.tipus === 'naplo') return <AgentXNaplo key={f.id} {...props}/>;
    if (f.tipus === 'szokereso') return <SzoKereso key={f.id} {...props}/>;
    if (f.tipus === 'memoria') return <MemoriaFeladat key={f.id} {...props}/>;
    if (f.tipus === 'parosito') return <ParositoFeladat key={f.id} {...props}/>;
    if (f.tipus === 'idore_meno') return <IdoreMenoFeladat key={f.id} {...props}/>;
    if (f.tipus === 'puzzle') return <PuzzleFeladat key={f.id} {...props}/>;
    if (f.tipus === 'labnyom_analizator') return <LabnyomAnalizator key={f.id} {...props}/>;
    if (f.tipus === 'celbalovo') return <CelbalovoJatek key={f.id} {...props}/>;
    if (f.tipus === 'profil_epito_drag') return <ProfilEpitoDrag key={f.id} {...props}/>;
    if (f.tipus === 'profil_vizsgalo') return <ProfilVizsgalo key={f.id} {...props}/>;
    if (f.tipus === 'digitalis_tukor') return <DigitalisTukor key={f.id} {...props}/>;
    if (f.tipus === 'jelszo_epito2') return <JelszoEpito2 key={f.id} {...props}/>;
    if (f.tipus === 'erossegmero') return <ErosessegMero key={f.id} {...props}/>;
    if (f.tipus === 'lakatnyito') return <LakatNyito key={f.id} {...props}/>;
    if (f.tipus === 'keresztrejtveny') return <Keresztrejtveny key={f.id} {...props}/>;
    if (f.tipus === 'erzelemfelismero') return <ErzelemFelismero key={f.id} {...props}/>;
    if (f.tipus === 'segitseg_utvonal') return <SegitsegUtvonal key={f.id} {...props}/>;
    if (f.tipus === 'kepregeny') return <Kepregeny key={f.id} {...props}/>;
    if (f.tipus === 'kartyafordito') return <KartyaFordito key={f.id} {...props}/>;
    if (f.tipus === 'labnyom_terkep') return <LabnyomTerkep key={f.id} {...props}/>;
    if (f.tipus === 'posztolnad') return <Posztolnad key={f.id} {...props}/>;
    if (f.tipus === 'idoutazas') return <Idoutazas key={f.id} {...props}/>;
    if (f.tipus === 'digitalis_takaritas') return <DigitalisTakaritas key={f.id} {...props}/>;
    if (f.tipus === 'ingame_bolt') return <InGameBolt key={f.id} {...props}/>;
    if (f.tipus === 'csalovadaszat') return <Csalovadaszat key={f.id} {...props}/>;
    if (f.tipus === 'szerencsekerek') return <Szerencsekerek key={f.id} {...props}/>;
    if (f.tipus === 'prompt_epito') return <PromptEpito key={f.id} {...props}/>;
    if (f.tipus === 'ai_labirintus') return <AILabirintus key={f.id} {...props}/>;
    if (f.tipus === 'boss_fight') return <BossFight key={f.id} {...props}/>;
    if (f.tipus === 'cyber_szef') return <CyberSzef key={f.id} {...props}/>;
    if (f.tipus === 'kincsvadaszat') return <Kincsvadaszat key={f.id} {...props}/>;
    if (f.tipus === 'rang_animacio') return <RangAnimacio key={f.id} {...props}/>;
    if (f.tipus === 'email_postafiok') return <EmailPostafiok key={f.id} {...props}/>;
    if (f.tipus === 'qr_vizsgalo') return <QRKodVizsgalo key={f.id} {...props}/>;
    if (f.tipus === 'gamer_chat') return <GamerChatSzoba key={f.id} {...props}/>;
    if (f.tipus === 'ai_vagy_ember') return <AIVagyEmber key={f.id} {...props}/>;
    return null;
  };

  if (digitalisOr && !aktivKuldes) {
    return (
      <div className="l911-wrapper" style={{minHeight: 'calc(100vh - 70px)', background: 'var(--bg-page)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', position: 'relative', overflow: 'hidden'}}>
        <style>{globalStyles}</style>
        <AnimaltHatter911/>
        <div style={{textAlign: 'center', maxWidth: '700px', animation: 'felugrik911 0.6s cubic-bezier(0.34,1.56,0.64,1)', position: 'relative', zIndex: 1, background: 'var(--bg-card-transparent)', borderRadius: '40px', padding: '4rem 3rem', boxShadow: '0 32px 80px rgba(33,150,243,0.2)', border: '3px solid #1976d2', overflow: 'hidden'}}>
          <KonfettiHatter/>
          <div style={{position: 'relative', zIndex: 1}}>
            <div style={{fontSize: '100px', marginBottom: '1rem', animation: 'pulzal911 1.5s ease-in-out infinite'}}>🏅</div>
            <h1 style={{fontSize: '42px', fontWeight: '900', color: '#1565c0', marginBottom: '0.5rem'}}>Digitális Őr!</h1>
            <p style={{fontSize: '23px', color: '#2d3748', fontWeight: '700', marginBottom: '2rem'}}>Mind a 7 küldetést teljesítetted! 🛡️</p>
            <div style={{background: 'linear-gradient(135deg, #e3f2fd, #e8eaf6)', border: '2px solid #1976d2', borderRadius: '24px', padding: '2rem', marginBottom: '2rem'}}>
              <p style={{fontSize: '18px', color: '#1565c0', fontWeight: '800', fontStyle: 'italic', margin: 0, lineHeight: 1.8}}>"Megfogadom hogy felelősen és kritikusan használom az internetet, megvédem az adataimat, és segítek másoknak ha bajban vannak online!" ✊</p>
            </div>
            <button onClick={() => setDigitalisOr(false)} className="k911-btn"
              style={{padding: '18px 48px', background: 'linear-gradient(135deg, #1976d2, #1565c0)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '21px', fontWeight: '900', cursor: 'pointer', boxShadow: '0 10px 32px rgba(25,118,210,0.4)'}}>
              🏅 Vissza a küldetésekhez
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!aktivKuldes) {
    return (
      <div className="l911-wrapper k911-bg-animalt" style={{minHeight: 'calc(100vh - 70px)', background: 'var(--bg-page)', position: 'relative', overflow: 'hidden', padding: '4rem 2rem'}}>
        <style>{globalStyles}</style>
        <AnimaltHatter911/>
        <div style={{position: 'absolute', top: '8%', left: '6%', fontSize: '54px', opacity: 0.35, zIndex: 0}} className="k911-lebego">🔐</div>
        <div style={{position: 'absolute', top: '18%', right: '9%', fontSize: '46px', opacity: 0.3, zIndex: 0, animationDelay: '1.5s'}} className="k911-lebego">🛡️</div>
        <div style={{position: 'absolute', bottom: '14%', left: '10%', fontSize: '50px', opacity: 0.3, zIndex: 0, animationDelay: '3s'}} className="k911-lebego">🤖</div>
        <div style={{position: 'absolute', bottom: '22%', right: '13%', fontSize: '40px', opacity: 0.32, zIndex: 0, animationDelay: '2s'}} className="k911-lebego">⭐</div>
        <div style={{position: 'relative', zIndex: 1}}>
          <div style={{textAlign: 'center', marginBottom: '3.5rem', animation: 'felugrik911 0.5s ease-out'}}>
            <div style={{display: 'inline-flex', alignItems: 'center', gap: '10px', background: 'var(--bg-card)', border: '2px solid #1976d2', borderRadius: '50px', padding: '12px 28px', fontSize: '17px', fontWeight: '800', color: '#1565c0', marginBottom: '1.5rem', boxShadow: '0 4px 16px rgba(25,118,210,0.15)'}}>
              <span style={{fontSize: '25px', animation: 'ugorj911 2s ease-in-out infinite'}}>🕵️</span> Agent X Akadémia – 9-11 éveseknek <span className="k911-csillag-forog">✨</span>
            </div>
            <h1 className="l911-fejcim" style={{fontSize: '56px', fontWeight: '800', color: '#1a1a2e', marginBottom: '1rem', lineHeight: 1.1}}>
              Válaszd ki a{' '}
              <span style={{background: 'linear-gradient(135deg, #1976d2, #42a5f5, #8e24aa)', backgroundSize: '200% auto', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', animation: 'gradientMozog 4s ease infinite'}}>küldetést!</span>
            </h1>
            <p style={{fontSize: '22px', color: '#64748b', maxWidth: '560px', margin: '0 auto 2.5rem', fontWeight: '600', lineHeight: 1.7}}>7 haladó küldetés! Valósághű helyzetek, modern veszélyek, Agent X jegyzetek minden feladathoz! 🛡️</p>
            <div style={{background: 'var(--bg-card)', borderRadius: '28px', padding: '2.25rem 2.75rem', maxWidth: '460px', margin: '0 auto', boxShadow: '0 8px 32px rgba(33,150,243,0.12)', border: '2px solid #e3f2fd'}}>
              <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '12px'}}>
                <span style={{fontSize: '17px', fontWeight: '800', color: '#64748b'}}>Haladás</span>
                <span style={{fontSize: '17px', fontWeight: '900', color: '#1976d2'}}>{teljesitett.length}/{kuldetesek.length} küldetés {teljesitett.length > 0 && <span className="k911-dobban" style={{display: 'inline-block'}}>🔥</span>}</span>
              </div>
              <div style={{background: '#e3f2fd', borderRadius: '12px', height: '14px', overflow: 'hidden'}}>
                <div style={{background: 'linear-gradient(90deg, #1565c0, #42a5f5, #8e24aa)', backgroundSize: '200% auto', animation: haladásszazalek > 0 ? 'gradientMozog 3s ease infinite' : 'none', width: `${haladásszazalek}%`, height: '14px', borderRadius: '12px', transition: 'width 0.6s', minWidth: haladásszazalek > 0 ? '14px' : '0', boxShadow: '0 2px 8px rgba(25,118,210,0.4)'}}/>
              </div>
            </div>
          </div>

          <div style={{maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '1.75rem'}}>
            {kuldetesek.map((k, i) => {
              const teljesitettE = teljesitett.includes(k.id);
              const zarolasVegzos = k.id === kuldetesek.length && kuldetesek.slice(0, -1).some(o => !teljesitett.includes(o.id));
              return (
                <div key={k.id} onClick={() => !zarolasVegzos && kuldesIndit(k)} className={zarolasVegzos ? 'k911-pop' : 'k911-kartya k911-pop'}
                  style={{background: zarolasVegzos ? '#f0f4f8' : 'var(--bg-card)', borderRadius: '28px', padding: '2rem', cursor: zarolasVegzos ? 'not-allowed' : 'pointer', border: `2.5px solid ${zarolasVegzos ? '#e0e0e0' : teljesitettE ? k.szin : '#e3f2fd'}`, boxShadow: teljesitettE ? `0 8px 32px ${k.szin}35` : '0 4px 20px rgba(33,150,243,0.08)', position: 'relative', overflow: 'hidden', animationDelay: `${i * 0.08}s`, animationFillMode: 'backwards', opacity: zarolasVegzos ? 0.75 : 1}}>
                  <div style={{position: 'absolute', top: 0, right: 0, width: '120px', height: '120px', background: `linear-gradient(135deg, ${k.szin}18, transparent)`, borderBottomLeftRadius: '100%'}}/>
                  {teljesitettE && <div className="k911-pop" style={{position: 'absolute', top: '16px', right: '16px', background: 'linear-gradient(135deg, #34a853, #66bb6a)', color: 'white', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '21px', fontWeight: '900', boxShadow: '0 0 14px rgba(52,168,83,0.6)'}}>✓</div>}
                  {zarolasVegzos && <div style={{position: 'absolute', top: '16px', right: '16px', background: '#94a3b8', color: 'white', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px'}}>🔒</div>}
                  <div style={{display: 'flex', alignItems: 'flex-start', gap: '1.25rem', marginBottom: '1.25rem'}}>
                    <div style={{width: '72px', height: '72px', borderRadius: '22px', background: zarolasVegzos ? '#e0e0e0' : `linear-gradient(135deg, ${k.szin}25, ${k.szin}10)`, border: `2px solid ${zarolasVegzos ? '#cfd8dc' : `${k.szin}40`}`, boxShadow: zarolasVegzos ? 'none' : `0 4px 14px ${k.szin}30`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '36px', flexShrink: 0, filter: zarolasVegzos ? 'grayscale(1)' : 'none', animation: zarolasVegzos ? 'none' : 'ugorj911 3s ease-in-out infinite', animationDelay: `${i * 0.3}s`}}>
                      {k.ikon}
                    </div>
                    <div style={{flex: 1}}>
                      <div style={{fontSize: '14px', color: '#94a3b8', fontWeight: '800', marginBottom: '4px', letterSpacing: '1px', textTransform: 'uppercase'}}>{i + 1}. küldetés</div>
                      <div style={{fontSize: '23px', fontWeight: '900', color: '#1a1a2e', lineHeight: 1.2}}>{k.cim}</div>
                    </div>
                  </div>
                  <p style={{fontSize: '16px', color: '#64748b', fontWeight: '600', marginBottom: '1.25rem', lineHeight: 1.6}}>{zarolasVegzos ? 'Zárolva — teljesítsd az összes korábbi küldetést a feloldáshoz!' : k.leiras}</p>
                  <div style={{display: 'flex', gap: '8px', marginBottom: '1.25rem', flexWrap: 'wrap'}}>
                    {k.konyv && <div style={{fontSize: '14px', background: '#e3f2fd', color: '#1565c0', borderRadius: '10px', padding: '4px 12px', fontWeight: '800'}}>📖 Olvasmány</div>}
                    <div style={{fontSize: '14px', background: '#f0f4f8', color: '#64748b', borderRadius: '10px', padding: '4px 12px', fontWeight: '800'}}>{k.feladatok.length} feladat</div>
                    <div style={{fontSize: '14px', background: '#e8f5e9', color: '#34a853', borderRadius: '10px', padding: '4px 12px', fontWeight: '800'}}>📝 Agent X jegyzetek</div>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <div style={{background: `${k.szin}12`, color: k.szin, fontSize: '15px', fontWeight: '900', padding: '8px 18px', borderRadius: '50px', border: `1.5px solid ${k.szin}30`}}>
                      {teljesitettE ? '✓ Teljesítve! 🌟' : k.id === kuldetesek.length ? '+100 XP 🏆' : '+50 XP ⚡'}
                    </div>
                    <div style={{fontSize: '27px', opacity: 0.6}}>{teljesitettE ? '🏆' : zarolasVegzos ? '🔒' : '→'}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  const feladat = aktivKuldes.feladatok[aktivFeladat];

  return (
    <div className="l911-wrapper k911-bg-animalt" style={{minHeight: 'calc(100vh - 70px)', background: 'var(--bg-page)', position: 'relative', overflow: 'hidden', padding: '1.5rem 2rem 4rem'}}>
      <style>{globalStyles}</style>
      <AnimaltHatter911/>
      <div style={{position: 'relative', zIndex: 1}}>
        <div style={{maxWidth: '1100px', margin: '0 auto 2rem', background: 'var(--bg-card)', borderRadius: '22px', padding: '1rem 1.75rem', display: 'flex', alignItems: 'center', gap: '14px', boxShadow: '0 4px 20px rgba(33,150,243,0.1)', border: `2px solid ${aktivKuldes.szin}20`}}>
          <button onClick={visszaKuldetesekhez} className="k911-btn"
            style={{background: `${aktivKuldes.szin}12`, border: `2px solid ${aktivKuldes.szin}30`, borderRadius: '14px', padding: '10px 20px', cursor: 'pointer', fontSize: '16px', color: aktivKuldes.szin, fontWeight: '800'}}>
            ← Vissza
          </button>
          <span style={{fontSize: '29px'}}>{aktivKuldes.ikon}</span>
          <span style={{fontSize: '19px', fontWeight: '900', color: '#1a1a2e'}}>{aktivKuldes.cim}</span>
          <div style={{flex: 1}}/>
          <div style={{display: 'flex', gap: '6px', alignItems: 'center'}}>
            {vanKonyv && <div style={{width: '28px', height: '8px', borderRadius: '4px', background: konyvOlvasva ? aktivKuldes.szin : `${aktivKuldes.szin}25`, transition: 'background 0.4s'}}/>}
            {aktivKuldes.feladatok.map((_, i) => (
              <div key={i} style={{width: '28px', height: '8px', borderRadius: '4px', background: !konyvZarol ? (i < aktivFeladat ? aktivKuldes.szin : i === aktivFeladat ? `${aktivKuldes.szin}70` : '#e3f2fd') : '#e3f2fd', transition: 'background 0.3s'}}/>
            ))}
          </div>
          <div style={{fontSize: '15px', color: '#94a3b8', fontWeight: '800', minWidth: '90px', textAlign: 'right'}}>
            {konyvZarol ? '📖 Olvasmány' : `${aktivFeladat + 1} / ${aktivKuldes.feladatok.length}`}
          </div>
        </div>

        <div style={{maxWidth: '1100px', margin: '0 auto'}}>
          {konyvZarol ? (
            <div style={{animation: 'felugrik911 0.4s ease-out'}}>
              <KonyvOlvaso konyv={aktivKuldes.konyv} kuldes={aktivKuldes} onKesz={() => setKonyvOlvasva(true)}/>
            </div>
          ) : !kuldesKesz ? (
            <div className="lecke-elrendezes" style={{animation: 'felugrik911 0.4s ease-out'}}>
              <div className="lecke-oldalsav" style={{background: 'var(--bg-card)', borderRadius: '28px', padding: '1.5rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem', boxShadow: `0 8px 28px ${aktivKuldes.szin}18`, border: `2px solid ${aktivKuldes.szin}20`}}>
                <img src="/agent x.png" alt="Agent X" style={{width: '150px', height: 'auto', animation: 'pulzal911 3s ease-in-out infinite', filter: `drop-shadow(0 8px 20px ${aktivKuldes.szin}35)`}}/>
                <AgentXBuborek szoveg={feladat.kerdes || feladat.cim} szin={aktivKuldes.szin}/>
                <div style={{textAlign: 'center'}}>
                  <div style={{fontSize: '14px', color: '#94a3b8', fontWeight: '800', marginBottom: '4px', letterSpacing: '0.5px', textTransform: 'uppercase'}}>Küldetés</div>
                  <div style={{fontSize: '17px', fontWeight: '900', color: '#1a1a2e', lineHeight: 1.3}}>{aktivKuldes.cim}</div>
                </div>
                <div style={{background: `linear-gradient(135deg, ${aktivKuldes.szin}, ${aktivKuldes.szin}cc)`, color: 'white', borderRadius: '50px', padding: '8px 18px', fontSize: '15px', fontWeight: '900'}}>
                  {aktivFeladat + 1}/{aktivKuldes.feladatok.length} feladat
                </div>
              </div>
              <div style={{flex: 1}}>
                {renderFeladat(feladat)}
              </div>
            </div>
          ) : (
            <div className="k911-pop" style={{background: 'var(--bg-card)', border: `3px solid ${aktivKuldes.szin}`, borderRadius: '36px', padding: '4rem 3rem', textAlign: 'center', boxShadow: `0 20px 60px ${aktivKuldes.szin}35, 0 0 0 6px ${aktivKuldes.szin}12`, position: 'relative', overflow: 'hidden'}}>
              <KonfettiHatter/>
              <div style={{position: 'relative', zIndex: 1}}>
                <div style={{fontSize: '88px', marginBottom: '1rem', animation: 'ugorj911 0.8s ease-in-out infinite'}}>{aktivKuldes.id === 7 ? '🏅' : '🎯'}</div>
                <h2 style={{fontSize: '34px', fontWeight: '900', color: aktivKuldes.szin, marginBottom: '0.5rem'}}>{aktivKuldes.id === 7 ? 'DIGITÁLIS ŐR RANG MEGSZERZVE!' : 'Küldetés teljesítve!'}</h2>
                <p style={{color: '#64748b', fontSize: '19px', marginBottom: '0.5rem', fontWeight: '700'}}>Kiváló munka Agent X!</p>
                <p className="k911-dobban" style={{color: aktivKuldes.szin, fontWeight: '900', fontSize: '29px', marginBottom: '2rem', display: 'inline-block'}}>+50 XP szereztél! ⚡</p>
                <div>
                  <button onClick={visszaKuldetesekhez} className="k911-btn"
                    style={{padding: '18px 48px', background: `linear-gradient(135deg, ${aktivKuldes.szin}, ${aktivKuldes.szin}cc)`, color: 'white', border: 'none', borderRadius: '50px', fontSize: '21px', fontWeight: '900', cursor: 'pointer', boxShadow: `0 10px 32px ${aktivKuldes.szin}40`}}>
                    {aktivKuldes.id === 7 ? '🏅 Digitális Őr rang megtekintése!' : '🗺️ Vissza a küldetésekhez'}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Leckek911;